// import React, { useState } from "react";

// export default function VisitDashboard() {

//   const [activeTab, setActiveTab] = useState("current");
//   const [search, setSearch] = useState("");
//   const [selectedRestaurant, setSelectedRestaurant] = useState(null);

//   const restaurants = [
//     {
//       id: 1,
//       name: "Cafe Mocha",
//       logo: "☕",
//       visits: 3,
//       reward: "1 Reward Ready",
//       progress: 80,
//       rule: "Visit 5 times & Get 20% OFF",
//     },
//     {
//       id: 2,
//       name: "Burger Town",
//       logo: "🍔",
//       visits: 2,
//       reward: "2 Visits Left",
//       progress: 40,
//       rule: "Visit 4 times & Get Free Fries",
//     },
//     {
//       id: 3,
//       name: "Pizza Hub",
//       logo: "🍕",
//       visits: 7,
//       reward: "Reward Unlocked",
//       progress: 100,
//       rule: "Visit 7 times & Get Free Pizza",
//     },
//     {
//       id: 4,
//       name: "Shake Point",
//       logo: "🥤",
//       visits: 1,
//       reward: "3 Visits Left",
//       progress: 20,
//       rule: "Visit 4 times & Get Free Shake",
//     },
//   ];

//   const filteredRestaurants = restaurants.filter((item) =>
//     item.name.toLowerCase().includes(search.toLowerCase())
//   );

//   return (
//     <>
//       <style>{`

//         *{
//           margin:0;
//           padding:0;
//           box-sizing:border-box;
//           font-family:'Poppins',sans-serif;
//         }

//         body{
//           background:#f4f7fb;
//         }

//         .dashboard{
//           min-height:100vh;
//           padding:35px;
//           background:
//           linear-gradient(135deg,#fff7ed,#fff,#f3f7ff);
//         }

//         /* TOP BAR */

//         .topbar{
//           display:flex;
//           justify-content:space-between;
//           align-items:center;
//           margin-bottom:35px;
//           flex-wrap:wrap;
//           gap:20px;
//         }

//         .topbar h1{
//           font-size:38px;
//           font-weight:800;
//           color:#111827;
//         }

//         .topbar p{
//           color:#6b7280;
//           margin-top:8px;
//           font-size:15px;
//         }

//         .profile{
//           width:58px;
//           height:58px;
//           border-radius:50%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           font-size:24px;
//           font-weight:700;
//           box-shadow:0 10px 30px rgba(255,94,98,0.3);
//         }

//         /* TABS */

//         .tabs{
//           display:flex;
//           gap:15px;
//           margin-bottom:35px;
//           flex-wrap:wrap;
//         }

//         .tab-btn{
//           padding:15px 28px;
//           border:none;
//           border-radius:18px;
//           font-size:16px;
//           font-weight:700;
//           background:white;
//           color:#555;
//           cursor:pointer;
//           transition:0.3s;
//           box-shadow:0 5px 20px rgba(0,0,0,0.05);
//         }

//         .tab-btn.active{
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           transform:translateY(-2px);
//         }

//         /* CURRENT VISIT */

//         .current-visit{
//           display:grid;
//           grid-template-columns:1fr 1fr;
//           gap:30px;
//         }

//         .card{
//           background:white;
//           border-radius:30px;
//           padding:35px;
//           box-shadow:0 10px 35px rgba(0,0,0,0.06);
//         }

//         .card h3{
//           font-size:26px;
//           margin-bottom:25px;
//           color:#111827;
//         }

//         /* VISIT RING */

//         .visit-ring{
//           width:230px;
//           height:230px;
//           margin:auto;
//           border-radius:50%;
//           background:
//           conic-gradient(
//           #ff8c42 0% 75%,
//           #e5e7eb 75% 100%
//           );
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           animation:spin 1s ease;
//         }

//         .ring-inner{
//           width:180px;
//           height:180px;
//           background:white;
//           border-radius:50%;
//           display:flex;
//           flex-direction:column;
//           align-items:center;
//           justify-content:center;
//         }

//         .ring-inner h1{
//           font-size:52px;
//           color:#ff6b35;
//           font-weight:800;
//         }

//         .ring-inner p{
//           color:#6b7280;
//           font-size:17px;
//           font-weight:600;
//         }

//         @keyframes spin{
//           from{
//             transform:scale(0.7) rotate(-100deg);
//             opacity:0;
//           }
//           to{
//             transform:scale(1) rotate(0deg);
//             opacity:1;
//           }
//         }

//         /* REWARD */

//         .reward-card{
//           background:
//           linear-gradient(135deg,#111827,#1f2937);
//           border-radius:28px;
//           padding:35px;
//           color:white;
//           position:relative;
//           overflow:hidden;
//         }

//         .reward-card::before{
//           content:'';
//           position:absolute;
//           width:180px;
//           height:180px;
//           background:rgba(255,255,255,0.05);
//           border-radius:50%;
//           top:-50px;
//           right:-40px;
//         }

//         .reward-tag{
//           display:inline-block;
//           background:#22c55e;
//           color:white;
//           padding:8px 18px;
//           border-radius:30px;
//           font-size:14px;
//           font-weight:700;
//           margin-bottom:20px;
//         }

//         .reward-card h2{
//           font-size:34px;
//           margin-bottom:18px;
//         }

//         .coupon{
//           background:#ff8c42;
//           padding:16px;
//           border-radius:18px;
//           text-align:center;
//           font-size:24px;
//           font-weight:800;
//           letter-spacing:2px;
//           margin-top:25px;
//         }

//         /* MILESTONE */

//         .milestone{
//           margin-top:30px;
//         }

//         .milestone h4{
//           margin-bottom:15px;
//           font-size:18px;
//           color:#111827;
//         }

//         .progress{
//           height:16px;
//           border-radius:30px;
//           background:#e5e7eb;
//           overflow:hidden;
//         }

//         .progress-fill{
//           width:80%;
//           height:100%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           border-radius:30px;
//         }

//         .milestone p{
//           margin-top:12px;
//           color:#6b7280;
//           font-weight:500;
//         }

//         /* SEARCH */

//         .search-box{
//           margin-bottom:30px;
//         }

//         .search-box input{
//           width:100%;
//           height:68px;
//           border:none;
//           border-radius:20px;
//           padding:0 25px;
//           font-size:17px;
//           background:white;
//           box-shadow:0 10px 30px rgba(0,0,0,0.05);
//           outline:none;
//         }

//         /* GRID */

//         .grid{
//           display:grid;
//           grid-template-columns:repeat(auto-fit,minmax(280px,1fr));
//           gap:25px;
//         }

//         .restaurant-card{
//           background:white;
//           border-radius:28px;
//           padding:30px;
//           box-shadow:0 10px 30px rgba(0,0,0,0.05);
//           transition:0.3s;
//           cursor:pointer;
//           position:relative;
//         }

//         .restaurant-card:hover{
//           transform:translateY(-8px);
//         }

//         .restaurant-top{
//           display:flex;
//           justify-content:space-between;
//           align-items:center;
//           margin-bottom:20px;
//         }

//         .restaurant-logo{
//           width:65px;
//           height:65px;
//           border-radius:20px;
//           background:#fff4eb;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           font-size:34px;
//         }

//         .status{
//           background:#ecfdf5;
//           color:#059669;
//           padding:10px 15px;
//           border-radius:30px;
//           font-size:13px;
//           font-weight:700;
//         }

//         .restaurant-card h3{
//           font-size:24px;
//           margin-bottom:12px;
//         }

//         .restaurant-card p{
//           color:#6b7280;
//           margin-bottom:18px;
//         }

//         .small-progress{
//           height:12px;
//           background:#eee;
//           border-radius:20px;
//           overflow:hidden;
//         }

//         .small-fill{
//           height:100%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//         }

//         /* MODAL */

//         .modal-overlay{
//           position:fixed;
//           top:0;
//           left:0;
//           width:100%;
//           height:100%;
//           background:rgba(0,0,0,0.5);
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           z-index:999;
//           padding:20px;
//         }

//         .modal{
//           background:white;
//           width:100%;
//           max-width:520px;
//           border-radius:35px;
//           padding:40px;
//           animation:popup 0.3s ease;
//         }

//         @keyframes popup{
//           from{
//             transform:scale(0.8);
//             opacity:0;
//           }
//           to{
//             transform:scale(1);
//             opacity:1;
//           }
//         }

//         .modal h2{
//           font-size:34px;
//           margin-bottom:20px;
//         }

//         .modal p{
//           color:#6b7280;
//           line-height:1.8;
//           margin-bottom:25px;
//         }

//         .rule-box{
//           background:#fff7ed;
//           border-radius:22px;
//           padding:25px;
//           margin-bottom:25px;
//         }

//         .close-btn{
//           width:100%;
//           height:60px;
//           border:none;
//           border-radius:18px;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           font-size:18px;
//           font-weight:700;
//           cursor:pointer;
//         }

//         @media(max-width:900px){

//           .dashboard{
//             padding:20px;
//           }

//           .current-visit{
//             grid-template-columns:1fr;
//           }

//           .topbar h1{
//             font-size:28px;
//           }

//           .visit-ring{
//             width:190px;
//             height:190px;
//           }

//           .ring-inner{
//             width:145px;
//             height:145px;
//           }

//           .ring-inner h1{
//             font-size:42px;
//           }

//         }

//       `}</style>

//       <div className="dashboard">

//         {/* TOPBAR */}

//         <div className="topbar">

//           <div>
//             <h1>Smart Loyalty Dashboard</h1>
//             <p>
//               Live restaurant visits, rewards & loyalty tracking
//             </p>
//           </div>

//           <div className="profile">
//             S
//           </div>

//         </div>

//         {/* TABS */}

//         <div className="tabs">

//           <button
//             className={`tab-btn ${activeTab === "current" ? "active" : ""}`}
//             onClick={() => setActiveTab("current")}
//           >
//             Current Visit
//           </button>

//           <button
//             className={`tab-btn ${activeTab === "passes" ? "active" : ""}`}
//             onClick={() => setActiveTab("passes")}
//           >
//             My All Passes
//           </button>

//         </div>

//         {/* CURRENT VISIT */}

//         {activeTab === "current" && (

//           <div className="current-visit">

//             {/* VISIT RING */}

//             <div className="card">

//               <h3>Your Current Visit</h3>

//               <div className="visit-ring">

//                 <div className="ring-inner">
//                   <h1>3rd</h1>
//                   <p>Visit</p>
//                 </div>

//               </div>

//               <div className="milestone">

//                 <h4>Next Milestone</h4>

//                 <div className="progress">
//                   <div className="progress-fill"></div>
//                 </div>

//                 <p>
//                   Only 1 visit left to unlock FREE Mocktail 🎉
//                 </p>

//               </div>

//             </div>

//             {/* REWARD */}

//             <div className="reward-card">

//               <div className="reward-tag">
//                 Reward Unlocked
//               </div>

//               <h2>20% OFF Coupon</h2>

//               <p>
//                 Show this code at counter and enjoy your discount.
//               </p>

//               <div className="coupon">
//                 CAFE20
//               </div>

//             </div>

//           </div>

//         )}

//         {/* ALL PASSES */}

//         {activeTab === "passes" && (

//           <div>

//             {/* SEARCH */}

//             <div className="search-box">

//               <input
//                 type="text"
//                 placeholder="Search Restaurants..."
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//               />

//             </div>

//             {/* GRID */}

//             <div className="grid">

//               {filteredRestaurants.map((item) => (

//                 <div
//                   key={item.id}
//                   className="restaurant-card"
//                   onClick={() => setSelectedRestaurant(item)}
//                 >

//                   <div className="restaurant-top">

//                     <div className="restaurant-logo">
//                       {item.logo}
//                     </div>

//                     <div className="status">
//                       {item.reward}
//                     </div>

//                   </div>

//                   <h3>{item.name}</h3>

//                   <p>
//                     Total Visits: {item.visits}
//                   </p>

//                   <div className="small-progress">

//                     <div
//                       className="small-fill"
//                       style={{
//                         width: `${item.progress}%`
//                       }}
//                     ></div>

//                   </div>

//                 </div>

//               ))}

//             </div>

//           </div>

//         )}

//         {/* MODAL */}

//         {selectedRestaurant && (

//           <div className="modal-overlay">

//             <div className="modal">

//               <h2>
//                 {selectedRestaurant.logo} {selectedRestaurant.name}
//               </h2>

//               <p>
//                 Loyalty Rule Details & Reward Tracking
//               </p>

//               <div className="rule-box">

//                 <h3>
//                   {selectedRestaurant.rule}
//                 </h3>

//                 <p style={{ marginTop: "10px" }}>
//                   Current Visits: {selectedRestaurant.visits}
//                 </p>

//               </div>

//               <button
//                 className="close-btn"
//                 onClick={() => setSelectedRestaurant(null)}
//               >
//                 Close
//               </button>

//             </div>

//           </div>

//         )}

//       </div>
//     </>
//   );
// }


// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";

// export default function VisitDashboard() {

//   const navigate = useNavigate();

//   const [activeTab, setActiveTab] = useState("current");
//   const [search, setSearch] = useState("");
//   const [selectedRestaurant, setSelectedRestaurant] = useState(null);

//   const restaurants = [
//     {
//       id: 1,
//       name: "Cafe Mocha",
//       logo: "☕",
//       visits: 3,
//       reward: "1 Reward Ready",
//       progress: 80,
//       rule: "Visit 5 times & Get 20% OFF",
//     },
//     {
//       id: 2,
//       name: "Burger Town",
//       logo: "🍔",
//       visits: 2,
//       reward: "2 Visits Left",
//       progress: 40,
//       rule: "Visit 4 times & Get Free Fries",
//     },
//     {
//       id: 3,
//       name: "Pizza Hub",
//       logo: "🍕",
//       visits: 7,
//       reward: "Reward Unlocked",
//       progress: 100,
//       rule: "Visit 7 times & Get Free Pizza",
//     },
//     {
//       id: 4,
//       name: "Shake Point",
//       logo: "🥤",
//       visits: 1,
//       reward: "3 Visits Left",
//       progress: 20,
//       rule: "Visit 4 times & Get Free Shake",
//     },
//   ];

//   const filteredRestaurants = restaurants.filter((item) =>
//     item.name.toLowerCase().includes(search.toLowerCase())
//   );

//   return (
//     <>
//       <style>{`

//         *{
//           margin:0;
//           padding:0;
//           box-sizing:border-box;
//           font-family:'Poppins',sans-serif;
//         }

//         body{
//           background:#f4f7fb;
//         }

//         .dashboard{
//           min-height:100vh;
//           padding:35px;
//           background:
//           linear-gradient(135deg,#fff7ed,#fff,#f3f7ff);
//         }

//         /* TOP BAR */

//         .topbar{
//           display:flex;
//           justify-content:space-between;
//           align-items:center;
//           margin-bottom:35px;
//           flex-wrap:wrap;
//           gap:20px;
//         }

//         .top-left h1{
//           font-size:38px;
//           font-weight:800;
//           color:#111827;
//         }

//         .top-left p{
//           color:#6b7280;
//           margin-top:8px;
//           font-size:15px;
//         }

//         .top-right{
//           display:flex;
//           align-items:center;
//           gap:15px;
//           flex-wrap:wrap;
//         }

//         .profile{
//           width:58px;
//           height:58px;
//           border-radius:50%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           font-size:24px;
//           font-weight:700;
//           box-shadow:0 10px 30px rgba(255,94,98,0.3);
//         }

//         /* NAV BUTTONS */

//         .nav-btn{
//           border:none;
//           padding:14px 22px;
//           border-radius:16px;
//           background:linear-gradient(135deg,#111827,#374151);
//           color:white;
//           font-size:14px;
//           font-weight:700;
//           cursor:pointer;
//           transition:0.3s;
//         }

//         .nav-btn:hover{
//           transform:translateY(-3px);
//         }

//         /* TABS */

//         .tabs{
//           display:flex;
//           gap:15px;
//           margin-bottom:35px;
//           flex-wrap:wrap;
//         }

//         .tab-btn{
//           padding:15px 28px;
//           border:none;
//           border-radius:18px;
//           font-size:16px;
//           font-weight:700;
//           background:white;
//           color:#555;
//           cursor:pointer;
//           transition:0.3s;
//           box-shadow:0 5px 20px rgba(0,0,0,0.05);
//         }

//         .tab-btn.active{
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           transform:translateY(-2px);
//         }

//         /* CURRENT VISIT */

//         .current-visit{
//           display:grid;
//           grid-template-columns:1fr 1fr;
//           gap:30px;
//         }

//         .card{
//           background:white;
//           border-radius:30px;
//           padding:35px;
//           box-shadow:0 10px 35px rgba(0,0,0,0.06);
//         }

//         .card h3{
//           font-size:26px;
//           margin-bottom:25px;
//           color:#111827;
//         }

//         /* VISIT RING */

//         .visit-ring{
//           width:230px;
//           height:230px;
//           margin:auto;
//           border-radius:50%;
//           background:
//           conic-gradient(
//           #ff8c42 0% 75%,
//           #e5e7eb 75% 100%
//           );
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           animation:spin 1s ease;
//         }

//         .ring-inner{
//           width:180px;
//           height:180px;
//           background:white;
//           border-radius:50%;
//           display:flex;
//           flex-direction:column;
//           align-items:center;
//           justify-content:center;
//         }

//         .ring-inner h1{
//           font-size:52px;
//           color:#ff6b35;
//           font-weight:800;
//         }

//         .ring-inner p{
//           color:#6b7280;
//           font-size:17px;
//           font-weight:600;
//         }

//         @keyframes spin{
//           from{
//             transform:scale(0.7) rotate(-100deg);
//             opacity:0;
//           }
//           to{
//             transform:scale(1) rotate(0deg);
//             opacity:1;
//           }
//         }

//         /* REWARD */

//         .reward-card{
//           background:
//           linear-gradient(135deg,#111827,#1f2937);
//           border-radius:28px;
//           padding:35px;
//           color:white;
//           position:relative;
//           overflow:hidden;
//         }

//         .reward-card::before{
//           content:'';
//           position:absolute;
//           width:180px;
//           height:180px;
//           background:rgba(255,255,255,0.05);
//           border-radius:50%;
//           top:-50px;
//           right:-40px;
//         }

//         .reward-tag{
//           display:inline-block;
//           background:#22c55e;
//           color:white;
//           padding:8px 18px;
//           border-radius:30px;
//           font-size:14px;
//           font-weight:700;
//           margin-bottom:20px;
//         }

//         .reward-card h2{
//           font-size:34px;
//           margin-bottom:18px;
//         }

//         .reward-card p{
//           color:#d1d5db;
//           line-height:1.7;
//         }

//         .coupon{
//           background:#ff8c42;
//           padding:16px;
//           border-radius:18px;
//           text-align:center;
//           font-size:24px;
//           font-weight:800;
//           letter-spacing:2px;
//           margin-top:25px;
//         }

//         /* FEEDBACK BTN */

//         .feedback-btn{
//           margin-top:25px;
//           width:100%;
//           height:60px;
//           border:none;
//           border-radius:18px;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           font-size:17px;
//           font-weight:700;
//           cursor:pointer;
//           transition:0.3s;
//         }

//         .feedback-btn:hover{
//           transform:translateY(-3px);
//         }

//         /* MILESTONE */

//         .milestone{
//           margin-top:30px;
//         }

//         .milestone h4{
//           margin-bottom:15px;
//           font-size:18px;
//           color:#111827;
//         }

//         .progress{
//           height:16px;
//           border-radius:30px;
//           background:#e5e7eb;
//           overflow:hidden;
//         }

//         .progress-fill{
//           width:80%;
//           height:100%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           border-radius:30px;
//         }

//         .milestone p{
//           margin-top:12px;
//           color:#6b7280;
//           font-weight:500;
//         }

//         /* SEARCH */

//         .search-box{
//           margin-bottom:30px;
//         }

//         .search-box input{
//           width:100%;
//           height:68px;
//           border:none;
//           border-radius:20px;
//           padding:0 25px;
//           font-size:17px;
//           background:white;
//           box-shadow:0 10px 30px rgba(0,0,0,0.05);
//           outline:none;
//         }

//         /* GRID */

//         .grid{
//           display:grid;
//           grid-template-columns:repeat(auto-fit,minmax(280px,1fr));
//           gap:25px;
//         }

//         .restaurant-card{
//           background:white;
//           border-radius:28px;
//           padding:30px;
//           box-shadow:0 10px 30px rgba(0,0,0,0.05);
//           transition:0.3s;
//           cursor:pointer;
//           position:relative;
//         }

//         .restaurant-card:hover{
//           transform:translateY(-8px);
//         }

//         .restaurant-top{
//           display:flex;
//           justify-content:space-between;
//           align-items:center;
//           margin-bottom:20px;
//         }

//         .restaurant-logo{
//           width:65px;
//           height:65px;
//           border-radius:20px;
//           background:#fff4eb;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           font-size:34px;
//         }

//         .status{
//           background:#ecfdf5;
//           color:#059669;
//           padding:10px 15px;
//           border-radius:30px;
//           font-size:13px;
//           font-weight:700;
//         }

//         .restaurant-card h3{
//           font-size:24px;
//           margin-bottom:12px;
//         }

//         .restaurant-card p{
//           color:#6b7280;
//           margin-bottom:18px;
//         }

//         .small-progress{
//           height:12px;
//           background:#eee;
//           border-radius:20px;
//           overflow:hidden;
//         }

//         .small-fill{
//           height:100%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//         }

//         /* MODAL */

//         .modal-overlay{
//           position:fixed;
//           top:0;
//           left:0;
//           width:100%;
//           height:100%;
//           background:rgba(0,0,0,0.5);
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           z-index:999;
//           padding:20px;
//         }

//         .modal{
//           background:white;
//           width:100%;
//           max-width:520px;
//           border-radius:35px;
//           padding:40px;
//           animation:popup 0.3s ease;
//         }

//         @keyframes popup{
//           from{
//             transform:scale(0.8);
//             opacity:0;
//           }
//           to{
//             transform:scale(1);
//             opacity:1;
//           }
//         }

//         .modal h2{
//           font-size:34px;
//           margin-bottom:20px;
//         }

//         .modal p{
//           color:#6b7280;
//           line-height:1.8;
//           margin-bottom:25px;
//         }

//         .rule-box{
//           background:#fff7ed;
//           border-radius:22px;
//           padding:25px;
//           margin-bottom:25px;
//         }

//         .close-btn{
//           width:100%;
//           height:60px;
//           border:none;
//           border-radius:18px;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           font-size:18px;
//           font-weight:700;
//           cursor:pointer;
//           margin-top:15px;
//         }

//         @media(max-width:900px){

//           .dashboard{
//             padding:20px;
//           }

//           .current-visit{
//             grid-template-columns:1fr;
//           }

//           .top-left h1{
//             font-size:28px;
//           }

//           .visit-ring{
//             width:190px;
//             height:190px;
//           }

//           .ring-inner{
//             width:145px;
//             height:145px;
//           }

//           .ring-inner h1{
//             font-size:42px;
//           }

//         }

//       `}</style>

//       <div className="dashboard">

//         {/* TOPBAR */}

//         <div className="topbar">

//           <div className="top-left">

//             <h1>
//               Smart Loyalty Dashboard
//             </h1>

//             <p>
//               Live restaurant visits, rewards & loyalty tracking
//             </p>

//           </div>

//           <div className="top-right">

//             <button
//               className="nav-btn"
//               onClick={() => navigate("/feedback")}
//             >
//               Feedback
//             </button>

//             <button
//               className="nav-btn"
//               onClick={() => navigate("/user-feed")}
//             >
//               My Profile
//             </button>

//             <button
//               className="nav-btn"
//               onClick={() => navigate("/merchantrules")}
//             >
//               Merchant Rules
//             </button>

//             <button
//               className="nav-btn"
//               onClick={() => navigate("/merchantanalytics")}
//             > 
//               Analytics
//             </button>

//             <div className="profile">
//               S
//             </div>

//           </div>

//         </div>

//         {/* TABS */}

//         <div className="tabs">

//           <button
//             className={`tab-btn ${activeTab === "current" ? "active" : ""}`}
//             onClick={() => setActiveTab("current")}
//           >
//             Current Visit
//           </button>

//           <button
//             className={`tab-btn ${activeTab === "passes" ? "active" : ""}`}
//             onClick={() => setActiveTab("passes")}
//           >
//             My All Passes
//           </button>

//         </div>

//         {/* CURRENT VISIT */}

//         {activeTab === "current" && (

//           <div className="current-visit">

//             {/* VISIT RING */}

//             <div className="card">

//               <h3>Your Current Visit</h3>

//               <div className="visit-ring">

//                 <div className="ring-inner">
//                   <h1>3rd</h1>
//                   <p>Visit</p>
//                 </div>

//               </div>

//               <div className="milestone">

//                 <h4>Next Milestone</h4>

//                 <div className="progress">
//                   <div className="progress-fill"></div>
//                 </div>

//                 <p>
//                   Only 1 visit left to unlock FREE Mocktail 🎉
//                 </p>

//               </div>

//             </div>

//             {/* REWARD */}

//             <div className="reward-card">

//               <div className="reward-tag">
//                 Reward Unlocked
//               </div>

//               <h2>20% OFF Coupon</h2>

//               <p>
//                 Show this code at counter and enjoy your discount.
//               </p>

//               <div className="coupon">
//                 CAFE20
//               </div>

//               <button
//                 className="feedback-btn"
//                 onClick={() => navigate("/feedback")}
//               >
//                 Give Feedback →
//               </button>

//             </div>

//           </div>

//         )}

//         {/* ALL PASSES */}

//         {activeTab === "passes" && (

//           <div>

//             <div className="search-box">

//               <input
//                 type="text"
//                 placeholder="Search Restaurants..."
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//               />

//             </div>

//             <div className="grid">

//               {filteredRestaurants.map((item) => (

//                 <div
//                   key={item.id}
//                   className="restaurant-card"
//                   onClick={() => setSelectedRestaurant(item)}
//                 >

//                   <div className="restaurant-top">

//                     <div className="restaurant-logo">
//                       {item.logo}
//                     </div>

//                     <div className="status">
//                       {item.reward}
//                     </div>

//                   </div>

//                   <h3>{item.name}</h3>

//                   <p>
//                     Total Visits: {item.visits}
//                   </p>

//                   <div className="small-progress">

//                     <div
//                       className="small-fill"
//                       style={{
//                         width: `${item.progress}%`
//                       }}
//                     ></div>

//                   </div>

//                 </div>

//               ))}

//             </div>

//           </div>

//         )}

//         {/* MODAL */}

//         {selectedRestaurant && (

//           <div className="modal-overlay">

//             <div className="modal">

//               <h2>
//                 {selectedRestaurant.logo} {selectedRestaurant.name}
//               </h2>

//               <p>
//                 Loyalty Rule Details & Reward Tracking
//               </p>

//               <div className="rule-box">

//                 <h3>
//                   {selectedRestaurant.rule}
//                 </h3>

//                 <p style={{ marginTop: "10px" }}>
//                   Current Visits: {selectedRestaurant.visits}
//                 </p>

//               </div>

//               <button
//                 className="close-btn"
//                 onClick={() => navigate("/feedback")}
//               >
//                 Give Feedback
//               </button>

//               <button
//                 className="close-btn"
//                 onClick={() => setSelectedRestaurant(null)}
//               >
//                 Close
//               </button>

//             </div>

//           </div>

//         )}

//       </div>
//     </>
//   );
// }

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// export default function VisitDashboard() {
//   const navigate = useNavigate();

//   const [activeTab, setActiveTab] = useState("current");
//   const [search, setSearch] = useState("");
//   const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  
//   // API State Handles
//   const [dashboardData, setDashboardData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const formdata = new FormData();
//     formdata.append("customer_id", "CMVC497B3A688");
//     formdata.append("merchant_id", "CMV9A117EAC");

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch("https://countmyvisit.com/Apis/customer_dashboard.php", requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         // API ke aage 'DATABASE CONNECTED' text aa raha hai, use clean kar rahe hain taaki JSON parse ho sake
//         const cleanJsonString = result.replace("DATABASE CONNECTED", "").trim();
//         const data = JSON.parse(cleanJsonString);

//         if (data.success) {
//           setDashboardData(data);
//         } else {
//           setError("Failed to fetch dashboard data.");
//         }
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error(err);
//         setError("Something went wrong while fetching data.");
//         setLoading(false);
//       });
//   }, []);

//   if (loading) {
//     return (
//       <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "Poppins, sans-serif", fontSize: "20px", fontWeight: "600", color: "#ff8c42" }}>
//         Loading Dashboard...
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "Poppins, sans-serif", fontSize: "18px", color: "red" }}>
//         {error}
//       </div>
//     );
//   }

//   // Destructuring Data from API
//   const { current_visit, next_reward, unlocked_rewards, all_passes, merchant, customer } = dashboardData;

//   // Search Filter for All Passes
//   const filteredPasses = all_passes.filter((item) =>
//     item.title.toLowerCase().includes(search.toLowerCase()) || 
//     item.reward.toLowerCase().includes(search.toLowerCase())
//   );

//   // Calculate Progress Ring Percentage
//   const maxVisitsForProgress = next_reward ? next_reward.required_visits : 1;
//   const progressPercentage = Math.min((current_visit / maxVisitsForProgress) * 100, 100);

//   return (
//     <>
//       <style>{`
//         *{
//           margin:0;
//           padding:0;
//           box-sizing:border-box;
//           font-family:'Poppins',sans-serif;
//         }

//         body{
//           background:#f4f7fb;
//         }

//         .dashboard{
//           min-height:100vh;
//           padding:35px;
//           background: linear-gradient(135deg,#fff7ed,#fff,#f3f7ff);
//         }

//         /* TOP BAR */
//         .topbar{
//           display:flex;
//           justify-content:space-between;
//           align-items:center;
//           margin-bottom:35px;
//           flex-wrap:wrap;
//           gap:20px;
//         }

//         .top-left h1{
//           font-size:38px;
//           font-weight:800;
//           color:#111827;
//         }

//         .top-left p{
//           color:#6b7280;
//           margin-top:8px;
//           font-size:15px;
//         }

//         .top-right{
//           display:flex;
//           align-items:center;
//           gap:15px;
//           flex-wrap:wrap;
//         }

//         .profile{
//           width:58px;
//           height:58px;
//           border-radius:50%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           font-size:24px;
//           font-weight:700;
//           box-shadow:0 10px 30px rgba(255,94,98,0.3);
//         }

//         /* NAV BUTTONS */
//         .nav-btn{
//           border:none;
//           padding:14px 22px;
//           border-radius:16px;
//           background:linear-gradient(135deg,#111827,#374151);
//           color:white;
//           font-size:14px;
//           font-weight:700;
//           cursor:pointer;
//           transition:0.3s;
//         }

//         .nav-btn:hover{
//           transform:translateY(-3px);
//         }

//         /* TABS */
//         .tabs{
//           display:flex;
//           gap:15px;
//           margin-bottom:35px;
//           flex-wrap:wrap;
//         }

//         .tab-btn{
//           padding:15px 28px;
//           border:none;
//           border-radius:18px;
//           font-size:16px;
//           font-weight:700;
//           background:white;
//           color:#555;
//           cursor:pointer;
//           transition:0.3s;
//           box-shadow:0 5px 20px rgba(0,0,0,0.05);
//         }

//         .tab-btn.active{
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           transform:translateY(-2px);
//         }

//         /* CURRENT VISIT */
//         .current-visit{
//           display:grid;
//           grid-template-columns:1fr 1fr;
//           gap:30px;
//         }

//         .card{
//           background:white;
//           border-radius:30px;
//           padding:35px;
//           box-shadow:0 10px 35px rgba(0,0,0,0.06);
//         }

//         .card h3{
//           font-size:26px;
//           margin-bottom:25px;
//           color:#111827;
//         }

//         /* VISIT RING Dynamic background injection using style attribute below */
//         .visit-ring{
//           width:230px;
//           height:230px;
//           margin:auto;
//           border-radius:50%;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           animation:spin 1s ease;
//         }

//         .ring-inner{
//           width:180px;
//           height:180px;
//           background:white;
//           border-radius:50%;
//           display:flex;
//           flex-direction:column;
//           align-items:center;
//           justify-content:center;
//         }

//         .ring-inner h1{
//           font-size:52px;
//           color:#ff6b35;
//           font-weight:800;
//         }

//         .ring-inner p{
//           color:#6b7280;
//           font-size:17px;
//           font-weight:600;
//         }

//         @keyframes spin{
//           from{
//             transform:scale(0.7) rotate(-100deg);
//             opacity:0;
//           }
//           to{
//             transform:scale(1) rotate(0deg);
//             opacity:1;
//           }
//         }

//         /* REWARD */
//         .reward-card{
//           background: linear-gradient(135deg,#111827,#1f2937);
//           border-radius:28px;
//           padding:35px;
//           color:white;
//           position:relative;
//           overflow:hidden;
//         }

//         .reward-card::before{
//           content:'';
//           position:absolute;
//           width:180px;
//           height:180px;
//           background:rgba(255,255,255,0.05);
//           border-radius:50%;
//           top:-50px;
//           right:-40px;
//         }

//         .reward-tag{
//           display:inline-block;
//           background:#22c55e;
//           color:white;
//           padding:8px 18px;
//           border-radius:30px;
//           font-size:14px;
//           font-weight:700;
//           margin-bottom:20px;
//         }

//         .reward-card h2{
//           font-size:34px;
//           margin-bottom:18px;
//         }

//         .reward-card p{
//           color:#d1d5db;
//           line-height:1.7;
//         }

//         .coupon{
//           background:#ff8c42;
//           padding:16px;
//           border-radius:18px;
//           text-align:center;
//           font-size:24px;
//           font-weight:800;
//           letter-spacing:2px;
//           margin-top:25px;
//         }

//         .feedback-btn{
//           margin-top:25px;
//           width:100%;
//           height:60px;
//           border:none;
//           border-radius:18px;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           font-size:17px;
//           font-weight:700;
//           cursor:pointer;
//           transition:0.3s;
//         }

//         .feedback-btn:hover{
//           transform:translateY(-3px);
//         }

//         /* MILESTONE */
//         .milestone{
//           margin-top:30px;
//         }

//         .milestone h4{
//           margin-bottom:15px;
//           font-size:18px;
//           color:#111827;
//         }

//         .progress{
//           height:16px;
//           border-radius:30px;
//           background:#e5e7eb;
//           overflow:hidden;
//         }

//         .progress-fill{
//           height:100%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           border-radius:30px;
//         }

//         .milestone p{
//           margin-top:12px;
//           color:#6b7280;
//           font-weight:500;
//         }

//         /* SEARCH */
//         .search-box{
//           margin-bottom:30px;
//         }

//         .search-box input{
//           width:100%;
//           height:68px;
//           border:none;
//           border-radius:20px;
//           padding:0 25px;
//           font-size:17px;
//           background:white;
//           box-shadow:0 10px 30px rgba(0,0,0,0.05);
//           outline:none;
//         }

//         /* GRID */
//         .grid{
//           display:grid;
//           grid-template-columns:repeat(auto-fit,minmax(280px,1fr));
//           gap:25px;
//         }

//         .restaurant-card{
//           background:white;
//           border-radius:28px;
//           padding:30px;
//           box-shadow:0 10px 30px rgba(0,0,0,0.05);
//           transition:0.3s;
//           cursor:pointer;
//           position:relative;
//         }

//         .restaurant-card:hover{
//           transform:translateY(-8px);
//         }

//         .restaurant-top{
//           display:flex;
//           justify-content:space-between;
//           align-items:center;
//           margin-bottom:20px;
//         }

//         .restaurant-logo{
//           width:65px;
//           height:65px;
//           border-radius:20px;
//           background:#fff4eb;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           font-size:34px;
//         }

//         .status{
//           background:#ecfdf5;
//           color:#059669;
//           padding:10px 15px;
//           border-radius:30px;
//           font-size:13px;
//           font-weight:700;
//         }

//         .restaurant-card h3{
//           font-size:24px;
//           margin-bottom:12px;
//         }

//         .restaurant-card p{
//           color:#6b7280;
//           margin-bottom:18px;
//         }

//         .small-progress{
//           height:12px;
//           background:#eee;
//           border-radius:20px;
//           overflow:hidden;
//         }

//         .small-fill{
//           height:100%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//         }

//         /* MODAL */
//         .modal-overlay{
//           position:fixed;
//           top:0;
//           left:0;
//           width:100%;
//           height:100%;
//           background:rgba(0,0,0,0.5);
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           z-index:999;
//           padding:20px;
//         }

//         .modal{
//           background:white;
//           width:100%;
//           max-width:520px;
//           border-radius:35px;
//           padding:40px;
//           animation:popup 0.3s ease;
//         }

//         @keyframes popup{
//           from{
//             transform:scale(0.8);
//             opacity:0;
//           }
//           to{
//             transform:scale(1);
//             opacity:1;
//           }
//         }

//         .modal h2{
//           font-size:34px;
//           margin-bottom:20px;
//         }

//         .modal p{
//           color:#6b7280;
//           line-height:1.8;
//           margin-bottom:25px;
//         }

//         .rule-box{
//           background:#fff7ed;
//           border-radius:22px;
//           padding:25px;
//           margin-bottom:25px;
//         }

//         .close-btn{
//           width:100%;
//           height:60px;
//           border:none;
//           border-radius:18px;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           font-size:18px;
//           font-weight:700;
//           cursor:pointer;
//           margin-top:15px;
//         }

//         @media(max-width:900px){
//           .dashboard{
//             padding:20px;
//           }
//           .current-visit{
//             grid-template-columns:1fr;
//           }
//           .top-left h1{
//             font-size:28px;
//           }
//           .visit-ring{
//             width:190px;
//             height:190px;
//           }
//           .ring-inner{
//             width:145px;
//             height:145px;
//           }
//           .ring-inner h1{
//             font-size:42px;
//           }
//         }
//       `}</style>

//       <div className="dashboard">

//         {/* TOPBAR */}
//         <div className="topbar">
//           <div className="top-left">
//             <h1>Smart Loyalty Dashboard</h1>
//             <p>Welcome, <b>{customer?.name || "User"}</b> | Live tracking for <b>{merchant?.business_name || "Merchant"}</b></p>
//           </div>

//           <div className="top-right">
//             <button className="nav-btn" onClick={() => navigate("/feedback")}>Feedback</button>
//             <button className="nav-btn" onClick={() => navigate("/user-feed")}>My Profile</button>
//             <button className="nav-btn" onClick={() => navigate("/merchantrules")}>Merchant Rules</button>
//             <button className="nav-btn" onClick={() => navigate("/merchantanalytics")}>Analytics</button>
//             <div className="profile">
//               {(customer?.name || "U").charAt(0).toUpperCase()}
//             </div>
//           </div>
//         </div>

//         {/* TABS */}
//         <div className="tabs">
//           <button
//             className={`tab-btn ${activeTab === "current" ? "active" : ""}`}
//             onClick={() => setActiveTab("current")}
//           >
//             Current Visit
//           </button>
//           <button
//             className={`tab-btn ${activeTab === "passes" ? "active" : ""}`}
//             onClick={() => setActiveTab("passes")}
//           >
//             My All Passes
//           </button>
//         </div>

//         {/* CURRENT VISIT TAB */}
//         {activeTab === "current" && (
//           <div className="current-visit">
            
//             {/* VISIT RING CARD */}
//             <div className="card">
//               <h3>Your Current Visit</h3>
              
//               {/* Dynamic Conic Gradient for Progress Ring */}
//               <div 
//                 className="visit-ring"
//                 style={{
//                   background: `conic-gradient(#ff8c42 0% ${progressPercentage}%, #e5e7eb ${progressPercentage}% 100%)`
//                 }}
//               >
//                 <div className="ring-inner">
//                   <h1>{current_visit}</h1>
//                   <p>Visits Done</p>
//                 </div>
//               </div>

//               {next_reward ? (
//                 <div className="milestone">
//                   <h4>Next Milestone: {next_reward.title}</h4>
//                   <div className="progress">
//                     <div className="progress-fill" style={{ width: `${progressPercentage}%` }}></div>
//                   </div>
//                   <p>
//                     Only <b>{next_reward.remaining_visits}</b> visit left to unlock reward worth <b>₹{next_reward.reward}</b> 🎉
//                   </p>
//                 </div>
//               ) : (
//                 <div className="milestone">
//                   <p>No upcoming rewards available right now!</p>
//                 </div>
//               )}
//             </div>

//             {/* UNLOCKED REWARDS CARD */}
//             <div className="reward-card">
//               {unlocked_rewards && unlocked_rewards.length > 0 ? (
//                 <>
//                   <div className="reward-tag">Reward Unlocked</div>
//                   <h2>{unlocked_rewards[0].title || "Discount Coupon"}</h2>
//                   <p>Show this code at counter and enjoy your reward: {unlocked_rewards[0].reward}</p>
//                   <div className="coupon">UNLOCKED</div>
//                 </>
//               ) : (
//                 <>
//                   <div className="reward-tag" style={{ background: "#6b7280" }}>No Rewards Unlocked</div>
//                   <h2>Keep Visiting!</h2>
//                   <p>Once you complete the required merchant pass visits, your reward code will appear right here.</p>
//                   <div className="coupon" style={{ background: "#374151", letterSpacing: "normal", fontSize: "16px" }}>
//                     LOCK 🔒
//                   </div>
//                 </>
//               )}

//               <button className="feedback-btn" onClick={() => navigate("/feedback")}>
//                 Give Feedback →
//               </button>
//             </div>

//           </div>
//         )}

//         {/* ALL PASSES TAB */}
//         {activeTab === "passes" && (
//           <div>
//             <div className="search-box">
//               <input
//                 type="text"
//                 placeholder="Search Passes (e.g. Visit 4 Times)..."
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//               />
//             </div>

//             <div className="grid">
//               {filteredPasses.map((item) => {
//                 // Calculate item progress inside the grid card
//                 const itemProgress = Math.min((current_visit / item.total_visits) * 100, 100);

//                 return (
//                   <div
//                     key={item.id}
//                     className="restaurant-card"
//                     onClick={() => setSelectedRestaurant(item)}
//                   >
//                     <div className="restaurant-top">
//                       <div className="restaurant-logo">🎫</div>
//                       <div className="status" style={{ backgroundColor: item.completed ? "#ecfdf5" : "#fef3c7", color: item.completed ? "#059669" : "#d97706" }}>
//                         {item.completed ? "Completed" : "In Progress"}
//                       </div>
//                     </div>

//                     <h3>{item.title}</h3>
//                     <p>Reward: <b>{item.reward}</b></p>
//                     <p style={{ fontSize: "14px" }}>Target: {item.total_visits} Visits</p>

//                     <div className="small-progress">
//                       <div
//                         className="small-fill"
//                         style={{ width: `${itemProgress}%` }}
//                       ></div>
//                     </div>
//                   </div>
//                 );
//               })}
//               {filteredPasses.length === 0 && <p style={{ textAlign: "center", width: "100%", color: "#6b7280" }}>No passes found matching your search.</p>}
//             </div>
//           </div>
//         )}

//         {/* DETAILS MODAL */}
//         {selectedRestaurant && (
//           <div className="modal-overlay">
//             <div className="modal">
//               <h2>🎫 {selectedRestaurant.title}</h2>
//               <p>Loyalty Rule Details & Reward Tracking</p>

//               <div className="rule-box">
//                 <h3>Reward: {selectedRestaurant.reward}</h3>
//                 <p style={{ marginTop: "10px" }}>
//                   Required Total Visits: <b>{selectedRestaurant.total_visits}</b>
//                 </p>
//                 <p>
//                   Your Current Visits: <b>{current_visit}</b>
//                 </p>
//               </div>

//               <button className="close-btn" onClick={() => navigate("/feedback")}>
//                 Give Feedback
//               </button>

//               <button className="close-btn" style={{ background: "#374151" }} onClick={() => setSelectedRestaurant(null)}>
//                 Close
//               </button>
//             </div>
//           </div>
//         )}

//       </div>
//     </>
//   );
// }



// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// export default function VisitDashboard() {
//   const navigate = useNavigate();

//   const [activeTab, setActiveTab] = useState("current");
//   const [search, setSearch] = useState("");
//   const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  
//   // API States
//   const [dashboardData, setDashboardData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const formdata = new FormData();
//     formdata.append("customer_id", "CMVC497B3A688");
//     formdata.append("merchant_id", "CMV9A117EAC");

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch("https://countmyvisit.com/Apis/customer_dashboard.php", requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         // API ke agge 'DATABASE CONNECTED' text ko clean kar rahe hain
//         const cleanJsonString = result.replace("DATABASE CONNECTED", "").trim();
//         const data = JSON.parse(cleanJsonString);

//         if (data.success) {
//           setDashboardData(data);
//         } else {
//           setError("Failed to fetch dashboard data.");
//         }
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error(err);
//         setError("Something went wrong while fetching data.");
//         setLoading(false);
//       });
//   }, []);

//   if (loading) {
//     return (
//       <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "Poppins, sans-serif", fontSize: "20px", fontWeight: "600", color: "#ff8c42" }}>
//         Loading Dashboard...
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "Poppins, sans-serif", fontSize: "18px", color: "red" }}>
//         {error}
//       </div>
//     );
//   }

//   const { current_visit, next_reward, unlocked_rewards, all_passes, merchant, customer } = dashboardData;

//   // Search Filter for All Passes Tab
//   const filteredPasses = all_passes.filter((item) =>
//     item.title.toLowerCase().includes(search.toLowerCase()) || 
//     item.reward.toLowerCase().includes(search.toLowerCase())
//   );

//   // Calculate Ring Progress Percentage
//   const maxVisitsForProgress = next_reward ? next_reward.required_visits : 1;
//   const progressPercentage = Math.min((current_visit / maxVisitsForProgress) * 100, 100);

//   return (
//     <>
//       <style>{`
//         *{
//           margin:0;
//           padding:0;
//           box-sizing:border-box;
//           font-family:'Poppins',sans-serif;
//         }

//         body{
//           background:#f4f7fb;
//         }

//         .dashboard{
//           min-height:100vh;
//           padding:35px;
//           background: linear-gradient(135deg,#fff7ed,#fff,#f3f7ff);
//         }

//         /* TOP BAR */
//         .topbar{
//           display:flex;
//           justify-content:space-between;
//           align-items:center;
//           margin-bottom:35px;
//           flex-wrap:wrap;
//           gap:20px;
//         }

//         .top-left h1{
//           font-size:38px;
//           font-weight:800;
//           color:#111827;
//         }

//         .top-left p{
//           color:#6b7280;
//           margin-top:8px;
//           font-size:15px;
//         }

//         .top-right{
//           display:flex;
//           align-items:center;
//           gap:15px;
//           flex-wrap:wrap;
//         }

//         .profile{
//           width:58px;
//           height:58px;
//           border-radius:50%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           font-size:24px;
//           font-weight:700;
//           box-shadow:0 10px 30px rgba(255,94,98,0.3);
//         }

//         .nav-btn{
//           border:none;
//           padding:14px 22px;
//           border-radius:16px;
//           background:linear-gradient(135deg,#111827,#374151);
//           color:white;
//           font-size:14px;
//           font-weight:700;
//           cursor:pointer;
//           transition:0.3s;
//         }

//         .nav-btn:hover{
//           transform:translateY(-3px);
//         }

//         /* TABS */
//         .tabs{
//           display:flex;
//           gap:15px;
//           margin-bottom:35px;
//           flex-wrap:wrap;
//         }

//         .tab-btn{
//           padding:15px 28px;
//           border:none;
//           border-radius:18px;
//           font-size:16px;
//           font-weight:700;
//           background:white;
//           color:#555;
//           cursor:pointer;
//           transition:0.3s;
//           box-shadow:0 5px 20px rgba(0,0,0,0.05);
//         }

//         .tab-btn.active{
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           transform:translateY(-2px);
//         }

//         /* NEW FEATURE: TIMELINE SLIDER CARD */
//         .timeline-card{
//           background: white;
//           border-radius: 30px;
//           padding: 30px;
//           margin-bottom: 30px;
//           box-shadow: 0 10px 35px rgba(0,0,0,0.06);
//         }

//         .timeline-card h3{
//           font-size: 22px;
//           color: #111827;
//           margin-bottom: 15px;
//         }

//         .timeline-slider{
//           display: flex;
//           gap: 20px;
//           overflow-x: auto;
//           padding: 10px 5px 20px 5px;
//           scroll-behavior: smooth;
//         }

//         /* Custom Scrollbar for Slider */
//         .timeline-slider::-webkit-scrollbar {
//           height: 8px;
//         }
//         .timeline-slider::-webkit-scrollbar-thumb {
//           background: #ff8c42;
//           border-radius: 10px;
//         }
//         .timeline-slider::-webkit-scrollbar-track {
//           background: #f3f4f6;
//         }

//         .timeline-item {
//           min-width: 240px;
//           background: #fff8f5;
//           border: 2px dashed #ffdcd0;
//           border-radius: 20px;
//           padding: 20px;
//           position: relative;
//           transition: 0.3s;
//         }

//         .timeline-item.next-up {
//           background: #fff7ed;
//           border: 2px solid #ff8c42;
//           box-shadow: 0 8px 25px rgba(255,140,66,0.15);
//         }

//         .timeline-item h5 {
//           font-size: 14px;
//           color: #ff6b35;
//           text-transform: uppercase;
//           margin-bottom: 5px;
//           font-weight: 700;
//         }

//         .timeline-item p {
//           font-size: 16px;
//           font-weight: 700;
//           color: #111827;
//         }

//         .timeline-badge {
//           display: inline-block;
//           font-size: 11px;
//           padding: 4px 10px;
//           border-radius: 20px;
//           font-weight: 700;
//           margin-top: 10px;
//         }

//         /* GRID LAYOUTS */
//         .current-visit{
//           display:grid;
//           grid-template-columns:1fr 1fr;
//           gap:30px;
//         }

//         .card{
//           background:white;
//           border-radius:30px;
//           padding:35px;
//           box-shadow:0 10px 35px rgba(0,0,0,0.06);
//         }

//         .card h3{
//           font-size:26px;
//           margin-bottom:25px;
//           color:#111827;
//         }

//         .visit-ring{
//           width:230px;
//           height:230px;
//           margin:auto;
//           border-radius:50%;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           animation:spin 1s ease;
//         }

//         .ring-inner{
//           width:180px;
//           height:180px;
//           background:white;
//           border-radius:50%;
//           display:flex;
//           flex-direction:column;
//           align-items:center;
//           justify-content:center;
//         }

//         .ring-inner h1{
//           font-size:52px;
//           color:#ff6b35;
//           font-weight:800;
//         }

//         .ring-inner p{
//           color:#6b7280;
//           font-size:17px;
//           font-weight:600;
//         }

//         @keyframes spin{
//           from{
//             transform:scale(0.7) rotate(-100deg);
//             opacity:0;
//           }
//           to{
//             transform:scale(1) rotate(0deg);
//             opacity:1;
//           }
//         }

//         /* REWARD */
//         .reward-card{
//           background: linear-gradient(135deg,#111827,#1f2937);
//           border-radius:28px;
//           padding:35px;
//           color:white;
//           position:relative;
//           overflow:hidden;
//         }

//         .reward-card::before{
//           content:'';
//           position:absolute;
//           width:180px;
//           height:180px;
//           background:rgba(255,255,255,0.05);
//           border-radius:50%;
//           top:-50px;
//           right:-40px;
//           }

//         .reward-tag{
//           display:inline-block;
//           background:#22c55e;
//           color:white;
//           padding:8px 18px;
//           border-radius:30px;
//           font-size:14px;
//           font-weight:700;
//           margin-bottom:20px;
//         }

//         .reward-card h2{
//           font-size:34px;
//           margin-bottom:18px;
//         }

//         .reward-card p{
//           color:#d1d5db;
//           line-height:1.7;
//         }

//         .coupon{
//           background:#ff8c42;
//           padding:16px;
//           border-radius:18px;
//           text-align:center;
//           font-size:24px;
//           font-weight:800;
//           letter-spacing:2px;
//           margin-top:25px;
//         }

//         .feedback-btn{
//           margin-top:25px;
//           width:100%;
//           height:60px;
//           border:none;
//           border-radius:18px;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           font-size:17px;
//           font-weight:700;
//           cursor:pointer;
//           transition:0.3s;
//         }

//         .feedback-btn:hover{
//           transform:translateY(-3px);
//         }

//         /* MILESTONE */
//         .milestone{
//           margin-top:30px;
//         }

//         .milestone h4{
//           margin-bottom:15px;
//           font-size:18px;
//           color:#111827;
//         }

//         .progress{
//           height:16px;
//           border-radius:30px;
//           background:#e5e7eb;
//           overflow:hidden;
//         }

//         .progress-fill{
//           height:100%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           border-radius:30px;
//         }

//         .milestone p{
//           margin-top:12px;
//           color:#6b7280;
//           font-weight:500;
//         }

//         /* SEARCH & GRID */
//         .search-box{
//           margin-bottom:30px;
//         }

//         .search-box input{
//           width:100%;
//           height:68px;
//           border:none;
//           border-radius:20px;
//           padding:0 25px;
//           font-size:17px;
//           background:white;
//           box-shadow:0 10px 30px rgba(0,0,0,0.05);
//           outline:none;
//         }

//         .grid{
//           display:grid;
//           grid-template-columns:repeat(auto-fit,minmax(280px,1fr));
//           gap:25px;
//         }

//         .restaurant-card{
//           background:white;
//           border-radius:28px;
//           padding:30px;
//           box-shadow:0 10px 30px rgba(0,0,0,0.05);
//           transition:0.3s;
//           cursor:pointer;
//           position:relative;
//         }

//         .restaurant-card:hover{
//           transform:translateY(-8px);
//         }

//         .restaurant-top{
//           display:flex;
//           justify-content:space-between;
//           align-items:center;
//           margin-bottom:20px;
//         }

//         .restaurant-logo{
//           width:65px;
//           height:65px;
//           border-radius:20px;
//           background:#fff4eb;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           font-size:34px;
//         }

//         .status{
//           background:#ecfdf5;
//           color:#059669;
//           padding:10px 15px;
//           border-radius:30px;
//           font-size:13px;
//           font-weight:700;
//         }

//         .restaurant-card h3{
//           font-size:24px;
//           margin-bottom:12px;
//         }

//         .restaurant-card p{
//           color:#6b7280;
//           margin-bottom:18px;
//         }

//         .small-progress{
//           height:12px;
//           background:#eee;
//           border-radius:20px;
//           overflow:hidden;
//         }

//         .small-fill{
//           height:100%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//         }

//         /* MODAL */
//         .modal-overlay{
//           position:fixed;
//           top:0;
//           left:0;
//           width:100%;
//           height:100%;
//           background:rgba(0,0,0,0.5);
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           z-index:999;
//           padding:20px;
//         }

//         .modal{
//           background:white;
//           width:100%;
//           max-width:520px;
//           border-radius:35px;
//           padding:40px;
//           animation:popup 0.3s ease;
//         }

//         @keyframes popup{
//           from{
//             transform:scale(0.8);
//             opacity:0;
//           }
//           to{
//             transform:scale(1);
//             opacity:1;
//           }
//         }

//         .modal h2{
//           font-size:34px;
//           margin-bottom:20px;
//         }

//         .modal p{
//           color:#6b7280;
//           line-height:1.8;
//           margin-bottom:25px;
//         }

//         .rule-box{
//           background:#fff7ed;
//           border-radius:22px;
//           padding:25px;
//           margin-bottom:25px;
//         }

//         .close-btn{
//           width:100%;
//           height:60px;
//           border:none;
//           border-radius:18px;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           font-size:18px;
//           font-weight:700;
//           cursor:pointer;
//           margin-top:15px;
//         }

//         @media(max-width:900px){
//           .dashboard{
//             padding:20px;
//           }
//           .current-visit{
//             grid-template-columns:1fr;
//           }
//           .top-left h1{
//             font-size:28px;
//           }
//           .visit-ring{
//             width:190px;
//             height:190px;
//           }
//           .ring-inner{
//             width:145px;
//             height:145px;
//           }
//           .ring-inner h1{
//             font-size:42px;
//           }
//         }
//       `}</style>

//       <div className="dashboard">

//         {/* TOPBAR */}
//         <div className="topbar">
//           <div className="top-left">
//             <h1>Smart Loyalty Dashboard</h1>
//             <p>Welcome, <b>{customer?.name || "User"}</b> | Tracking for <b>{merchant?.business_name || "Merchant"}</b></p>
//           </div>

//           <div className="top-right">
//             <button className="nav-btn" onClick={() => navigate("/feedback")}>Feedback</button>
//             <button className="nav-btn" onClick={() => navigate("/user-feed")}>My Profile</button>
//             <button className="nav-btn" onClick={() => navigate("/merchantrules")}>Merchant Rules</button>
//             <button className="nav-btn" onClick={() => navigate("/merchantanalytics")}>Analytics</button>
//             <div className="profile">
//               {(customer?.name || "U").charAt(0).toUpperCase()}
//             </div>
//           </div>
//         </div>

//         {/* TABS */}
//         <div className="tabs">
//           <button
//             className={`tab-btn ${activeTab === "current" ? "active" : ""}`}
//             onClick={() => setActiveTab("current")}
//           >
//             Current Visit
//           </button>
//           <button
//             className={`tab-btn ${activeTab === "passes" ? "active" : ""}`}
//             onClick={() => setActiveTab("passes")}
//           >
//             My All Passes ({all_passes.length})
//           </button>
//         </div>

//         {/* CURRENT VISIT TAB */}
//         {activeTab === "current" && (
//           <div>
            
//             {/* NEW SWIPEABLE TIMELINE FEATURE */}
//             <div className="timeline-card">
//               <h3>🎁 Loyalty Passes Roadmap</h3>
//               <div className="timeline-slider">
//                 {all_passes.map((pass) => {
//                   // Determine status based on current visit
//                   const isNextTarget = next_reward && next_reward.pass_id === pass.id;
//                   const isCompleted = current_visit >= pass.total_visits;

//                   return (
//                     <div 
//                       key={pass.id} 
//                       className={`timeline-item ${isNextTarget ? "next-up" : ""}`}
//                     >
//                       <h5>🎯 On {pass.total_visits} {pass.total_visits === 1 ? "Visit" : "Visits"}</h5>
//                       <p>{pass.reward}</p>
                      
//                       {isCompleted ? (
//                         <span className="timeline-badge" style={{ background: "#ecfdf5", color: "#059669" }}>
//                           Unlocked 🎉
//                         </span>
//                       ) : isNextTarget ? (
//                         <span className="timeline-badge" style={{ background: "#ffea2c", color: "#111827" }}>
//                           Next Target 🎯
//                         </span>
//                       ) : (
//                         <span className="timeline-badge" style={{ background: "#e5e7eb", color: "#6b7280" }}>
//                           Locked 🔒
//                         </span>
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>

//             <div className="current-visit">
//               {/* VISIT RING CARD */}
//               <div className="card">
//                 <h3>Your Current Visit</h3>
                
//                 <div 
//                   className="visit-ring"
//                   style={{
//                     background: `conic-gradient(#ff8c42 0% ${progressPercentage}%, #e5e7eb ${progressPercentage}% 100%)`
//                   }}
//                 >
//                   <div className="ring-inner">
//                     <h1>{current_visit}</h1>
//                     <p>Visits Done</p>
//                   </div>
//                 </div>

//                 {next_reward ? (
//                   <div className="milestone">
//                     <h4>Next Milestone: {next_reward.title}</h4>
//                     <div className="progress">
//                       <div className="progress-fill" style={{ width: `${progressPercentage}%` }}></div>
//                     </div>
//                     <p>
//                       Only <b>{next_reward.remaining_visits}</b> visit left to unlock reward worth <b>₹{next_reward.reward}</b> 🎉
//                     </p>
//                   </div>
//                 ) : (
//                   <div className="milestone">
//                     <p>Woohoo! All loyalty targets reached! 🏁</p>
//                   </div>
//                 )}
//               </div>

//               {/* UNLOCKED REWARDS CARD */}
//               <div className="reward-card">
//                 {unlocked_rewards && unlocked_rewards.length > 0 ? (
//                   <>
//                     <div className="reward-tag">Reward Unlocked</div>
//                     <h2>{unlocked_rewards[0].title || "Discount Coupon"}</h2>
//                     <p>Show this code at counter and enjoy your reward: {unlocked_rewards[0].reward}</p>
//                     <div className="coupon">UNLOCKED</div>
//                   </>
//                 ) : (
//                   <>
//                     <div className="reward-tag" style={{ background: "#6b7280" }}>No Rewards Unlocked</div>
//                     <h2>Keep Visiting!</h2>
//                     <p>Once your current visits match any pass criteria, your active claims/coupons will appear here.</p>
//                     <div className="coupon" style={{ background: "#374151", letterSpacing: "normal", fontSize: "16px" }}>
//                       LOCK 🔒
//                     </div>
//                   </>
//                 )}

//                 <button className="feedback-btn" onClick={() => navigate("/feedback")}>
//                   Give Feedback →
//                 </button>
//               </div>
//             </div>

//           </div>
//         )}

//         {/* ALL PASSES TAB */}
//         {activeTab === "passes" && (
//           <div>
//             <div className="search-box">
//               <input
//                 type="text"
//                 placeholder="Search Passes..."
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//               />
//             </div>

//             <div className="grid">
//               {filteredPasses.map((item) => {
//                 const itemProgress = Math.min((current_visit / item.total_visits) * 100, 100);
//                 const isItemCompleted = current_visit >= item.total_visits;

//                 return (
//                   <div
//                     key={item.id}
//                     className="restaurant-card"
//                     onClick={() => setSelectedRestaurant(item)}
//                   >
//                     <div className="restaurant-top">
//                       <div className="restaurant-logo">🎫</div>
//                       <div className="status" style={{ backgroundColor: isItemCompleted ? "#ecfdf5" : "#fef3c7", color: isItemCompleted ? "#059669" : "#d97706" }}>
//                         {isItemCompleted ? "Completed" : "In Progress"}
//                       </div>
//                     </div>

//                     <h3>{item.title}</h3>
//                     <p>Reward: <b>{item.reward}</b></p>
//                     <p style={{ fontSize: "14px" }}>Target Required: {item.total_visits} Visits</p>

//                     <div className="small-progress">
//                       <div
//                         className="small-fill"
//                         style={{ width: `${itemProgress}%` }}
//                       ></div>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         )}

//         {/* DETAILS MODAL */}
//         {selectedRestaurant && (
//           <div className="modal-overlay">
//             <div className="modal">
//               <h2>🎫 {selectedRestaurant.title}</h2>
//               <p>Loyalty Rule Details & Reward Tracking</p>

//               <div className="rule-box">
//                 <h3>Reward: {selectedRestaurant.reward}</h3>
//                 <p style={{ marginTop: "10px" }}>
//                   Required Total Visits: <b>{selectedRestaurant.total_visits}</b>
//                 </p>
//                 <p>
//                   Your Current Visits: <b>{current_visit}</b>
//                 </p>
//               </div>

//               <button className="close-btn" onClick={() => navigate("/feedback")}>
//                 Give Feedback
//               </button>

//               <button className="close-btn" style={{ background: "#374151" }} onClick={() => setSelectedRestaurant(null)}>
//                 Close
//               </button>
//             </div>
//           </div>
//         )}

//       </div>
//     </>
//   );
// }


// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// export default function VisitDashboard() {
//   const navigate = useNavigate();

//   const [activeTab, setActiveTab] = useState("current");
//   const [search, setSearch] = useState("");
//   const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  
//   // API States
//   const [dashboardData, setDashboardData] = useState(null);
//   const [rewardsList, setRewardsList] = useState([]); // my_rewards API data
//   const [loading, setLoading] = useState(true);
//   const [actionLoading, setActionLoading] = useState(false);
//   const [error, setError] = useState(null);

//   // Helper function to clean text responses from PHP APIs
//   const cleanAndParseJson = (text) => {
//     const cleanString = text.replace("DATABASE CONNECTED", "").trim();
//     return JSON.parse(cleanString);
//   };

//   // Core function to load complete dashboard information
//   const fetchDashboardData = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", "CMVC497B3A688");
//       formdata.append("merchant_id", "CMV9A117EAC");

//       const response = await fetch("https://countmyvisit.com/Apis/customer_dashboard.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         setDashboardData(data);
//       } else {
//         setError("Failed to fetch dashboard data.");
//       }
//     } catch (err) {
//       console.error(err);
//       setError("Something went wrong while fetching dashboard data.");
//     }
//   };

//   // Function to load all historical or current rewards/coupons for the customer
//   const fetchRewardsList = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", "CMVC497B3A688");
//       formdata.append("merchant_id", "CMV9A117EAC");

//       const response = await fetch("https://countmyvisit.com/Apis/my_rewards.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         setRewardsList(data.rewards || []);
//       }
//     } catch (err) {
//       console.error("Error fetching rewards history:", err);
//     }
//   };

//   // Initial load hook
//   useEffect(() => {
//     async function loadAllData() {
//       setLoading(true);
//       await fetchDashboardData();
//       await fetchRewardsList();
//       setLoading(false);
//     }
//     loadAllData();
//   }, []);

//   // Action: Add a new visit log dynamically
//   const handleAddVisit = async () => {
//     setActionLoading(true);
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", "CMVC497B3A688");
//       formdata.append("merchant_id", "CMV9A117EAC");

//       const response = await fetch("https://countmyvisit.com/Apis/add_visit.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         alert(`Visit marked successfully! Current visits: ${data.current_visit}`);
//         await fetchDashboardData();
//         await fetchRewardsList();
//       } else {
//         alert("Unable to register visit at this moment.");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Error executing visit update routing.");
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   // Action: Instantly burn/redeem an active code at the counter
//   const handleRedeemReward = async (couponCode) => {
//     if (!window.confirm(`Are you sure you want to redeem coupon code: ${couponCode}?`)) return;
//     setActionLoading(true);
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", "CMVC497B3A688");
//       formdata.append("merchant_id", "CMV9A117EAC");
//       formdata.append("coupon_code", couponCode);

//       const response = await fetch("https://countmyvisit.com/Apis/redeem_reward.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         alert(data.message || "Reward Redeemed Successfully! 🎁");
//         await fetchDashboardData();
//         await fetchRewardsList();
//       } else {
//         alert("Failed to process point redemption validation.");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Network exception occurred during counter redemption check.");
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "Poppins, sans-serif", fontSize: "20px", fontWeight: "600", color: "#ff8c42" }}>
//         Loading Dashboard Assets...
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "Poppins, sans-serif", fontSize: "18px", color: "red" }}>
//         {error}
//       </div>
//     );
//   }

//   const { current_visit, next_reward, unlocked_rewards, all_passes, merchant, customer } = dashboardData;

//   // Global standard text filter
//   const filteredPasses = all_passes.filter((item) =>
//     item.title.toLowerCase().includes(search.toLowerCase()) || 
//     item.reward.toLowerCase().includes(search.toLowerCase())
//   );

//   const maxVisitsForProgress = next_reward ? next_reward.required_visits : 1;
//   const progressPercentage = Math.min((current_visit / maxVisitsForProgress) * 100, 100);

//   return (
//     <>
//       <style>{`
//         *{
//           margin:0;
//           padding:0;
//           box-sizing:border-box;
//           font-family:'Poppins',sans-serif;
//         }

//         body{
//           background:#f4f7fb;
//         }

//         .dashboard{
//           min-height:100vh;
//           padding:35px;
//           background: linear-gradient(135deg,#fff7ed,#fff,#f3f7ff);
//         }

//         /* TOP BAR */
//         .topbar{
//           display:flex;
//           justify-content:space-between;
//           align-items:center;
//           margin-bottom:35px;
//           flex-wrap:wrap;
//           gap:20px;
//         }

//         .top-left h1{
//           font-size:38px;
//           font-weight:800;
//           color:#111827;
//         }

//         .top-left p{
//           color:#6b7280;
//           margin-top:8px;
//           font-size:15px;
//         }

//         .top-right{
//           display:flex;
//           align-items:center;
//           gap:12px;
//           flex-wrap:wrap;
//         }

//         .profile{
//           width:58px;
//           height:58px;
//           border-radius:50%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           font-size:24px;
//           font-weight:700;
//           box-shadow:0 10px 30px rgba(255,94,98,0.3);
//         }

//         .nav-btn{
//           border:none;
//           padding:14px 20px;
//           border-radius:16px;
//           background:linear-gradient(135deg,#111827,#374151);
//           color:white;
//           font-size:14px;
//           font-weight:700;
//           cursor:pointer;
//           transition:0.3s;
//         }

//         .nav-btn.special{
//           background:linear-gradient(135deg,#2563eb,#1d4ed8);
//         }

//         .nav-btn.action-trigger{
//           background:linear-gradient(135deg,#10b981,#059669);
//         }

//         .nav-btn:hover, .redeem-btn:hover{
//           transform:translateY(-3px);
//           opacity:0.95;
//         }

//         /* TABS */
//         .tabs{
//           display:flex;
//           gap:15px;
//           margin-bottom:35px;
//           flex-wrap:wrap;
//         }

//         .tab-btn{
//           padding:15px 28px;
//           border:none;
//           border-radius:18px;
//           font-size:16px;
//           font-weight:700;
//           background:white;
//           color:#555;
//           cursor:pointer;
//           transition:0.3s;
//           box-shadow:0 5px 20px rgba(0,0,0,0.05);
//         }

//         .tab-btn.active{
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           transform:translateY(-2px);
//         }

//         /* TIMELINE SLIDER CARD */
//         .timeline-card{
//           background: white;
//           border-radius: 30px;
//           padding: 30px;
//           margin-bottom: 30px;
//           box-shadow: 0 10px 35px rgba(0,0,0,0.06);
//         }

//         .timeline-card h3{
//           font-size: 22px;
//           color: #111827;
//           margin-bottom: 15px;
//         }

//         .timeline-slider{
//           display: flex;
//           gap: 20px;
//           overflow-x: auto;
//           padding: 10px 5px 20px 5px;
//           scroll-behavior: smooth;
//         }

//         .timeline-slider::-webkit-scrollbar {
//           height: 8px;
//         }
//         .timeline-slider::-webkit-scrollbar-thumb {
//           background: #ff8c42;
//           border-radius: 10px;
//         }
//         .timeline-slider::-webkit-scrollbar-track {
//           background: #f3f4f6;
//         }

//         .timeline-item {
//           min-width: 240px;
//           background: #fff8f5;
//           border: 2px dashed #ffdcd0;
//           border-radius: 20px;
//           padding: 20px;
//           position: relative;
//           transition: 0.3s;
//         }

//         .timeline-item.next-up {
//           background: #fff7ed;
//           border: 2px solid #ff8c42;
//           box-shadow: 0 8px 25px rgba(255,140,66,0.15);
//         }

//         .timeline-item h5 {
//           font-size: 14px;
//           color: #ff6b35;
//           text-transform: uppercase;
//           margin-bottom: 5px;
//           font-weight: 700;
//         }

//         .timeline-item p {
//           font-size: 16px;
//           font-weight: 700;
//           color: #111827;
//         }

//         .timeline-badge {
//           display: inline-block;
//           font-size: 11px;
//           padding: 4px 10px;
//           border-radius: 20px;
//           font-weight: 700;
//           margin-top: 10px;
//         }

//         /* GRID LAYOUTS */
//         .current-visit{
//           display:grid;
//           grid-template-columns:1fr 1fr;
//           gap:30px;
//         }

//         .card{
//           background:white;
//           border-radius:30px;
//           padding:35px;
//           box-shadow:0 10px 35px rgba(0,0,0,0.06);
//         }

//         .card h3{
//           font-size:26px;
//           margin-bottom:25px;
//           color:#111827;
//         }

//         .visit-ring{
//           width:230px;
//           height:230px;
//           margin:auto;
//           border-radius:50%;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           animation:spin 1s ease;
//         }

//         .ring-inner{
//           width:180px;
//           height:180px;
//           background:white;
//           border-radius:50%;
//           display:flex;
//           flex-direction:column;
//           align-items:center;
//           justify-content:center;
//         }

//         .ring-inner h1{
//           font-size:52px;
//           color:#ff6b35;
//           font-weight:800;
//         }

//         .ring-inner p{
//           color:#6b7280;
//           font-size:17px;
//           font-weight:600;
//         }

//         @keyframes spin{
//           from{ transform:scale(0.7) rotate(-100deg); opacity:0; }
//           to{ transform:scale(1) rotate(0deg); opacity:1; }
//         }

//         /* REWARD CARD */
//         .reward-card{
//           background: linear-gradient(135deg,#111827,#1f2937);
//           border-radius:28px;
//           padding:35px;
//           color:white;
//           position:relative;
//           overflow:hidden;
//         }

//         .reward-card::before{
//           content:'';
//           position:absolute;
//           width:180px;
//           height:180px;
//           background:rgba(255,255,255,0.05);
//           border-radius:50%;
//           top:-50px;
//           right:-40px;
//         }

//         .reward-tag{
//           display:inline-block;
//           background:#22c55e;
//           color:white;
//           padding:8px 18px;
//           border-radius:30px;
//           font-size:14px;
//           font-weight:700;
//           margin-bottom:20px;
//         }

//         .reward-card h2{
//           font-size:34px;
//           margin-bottom:18px;
//         }

//         .reward-card p{
//           color:#d1d5db;
//           line-height:1.7;
//         }

//         .coupon{
//           background:#ff8c42;
//           padding:16px;
//           border-radius:18px;
//           text-align:center;
//           font-size:24px;
//           font-weight:800;
//           letter-spacing:2px;
//           margin-top:25px;
//         }

//         .feedback-btn{
//           margin-top:25px;
//           width:100%;
//           height:60px;
//           border:none;
//           border-radius:18px;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           font-size:17px;
//           font-weight:700;
//           cursor:pointer;
//           transition:0.3s;
//         }

//         .feedback-btn:hover{
//           transform:translateY(-3px);
//         }

//         /* MILESTONE */
//         .milestone{
//           margin-top:30px;
//         }

//         .milestone h4{
//           margin-bottom:15px;
//           font-size:18px;
//           color:#111827;
//         }

//         .progress{
//           height:16px;
//           border-radius:30px;
//           background:#e5e7eb;
//           overflow:hidden;
//         }

//         .progress-fill{
//           height:100%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           border-radius:30px;
//         }

//         .milestone p{
//           margin-top:12px;
//           color:#6b7280;
//           font-weight:500;
//         }

//         /* REWARDS HISTORY TABLE / GRID */
//         .rewards-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
//           gap: 25px;
//         }

//         .coupon-card {
//           background: white;
//           border-radius: 24px;
//           padding: 25px;
//           box-shadow: 0 10px 30px rgba(0,0,0,0.04);
//           border: 1px solid #eef2f6;
//           display: flex;
//           flex-direction: column;
//           justify-content: space-between;
//         }

//         .coupon-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 15px;
//         }

//         .coupon-code-txt {
//           font-family: monospace;
//           background: #f3f4f6;
//           padding: 6px 12px;
//           border-radius: 8px;
//           font-weight: 700;
//           font-size: 16px;
//           color: #374151;
//         }

//         .redeem-btn {
//           width: 100%;
//           padding: 14px;
//           border: none;
//           background: linear-gradient(135deg, #10b981, #059669);
//           color: white;
//           border-radius: 14px;
//           font-size: 15px;
//           font-weight: 700;
//           cursor: pointer;
//           margin-top: 15px;
//           transition: 0.2s;
//         }

//         /* SEARCH & GRID */
//         .search-box{
//           margin-bottom:30px;
//         }

//         .search-box input{
//           width:100%;
//           height:68px;
//           border:none;
//           border-radius:20px;
//           padding:0 25px;
//           font-size:17px;
//           background:white;
//           box-shadow:0 10px 30px rgba(0,0,0,0.05);
//           outline:none;
//         }

//         .grid{
//           display:grid;
//           grid-template-columns:repeat(auto-fit,minmax(280px,1fr));
//           gap:25px;
//         }

//         .restaurant-card{
//           background:white;
//           border-radius:28px;
//           padding:30px;
//           box-shadow:0 10px 30px rgba(0,0,0,0.05);
//           transition:0.3s;
//           cursor:pointer;
//           position:relative;
//         }

//         .restaurant-card:hover{
//           transform:translateY(-8px);
//         }

//         .restaurant-top{
//           display:flex;
//           justify-content:space-between;
//           align-items:center;
//           margin-bottom:20px;
//         }

//         .restaurant-logo{
//           width:65px;
//           height:65px;
//           border-radius:20px;
//           background:#fff4eb;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           font-size:34px;
//         }

//         .status{
//           padding:10px 15px;
//           border-radius:30px;
//           font-size:13px;
//           font-weight:700;
//         }

//         .restaurant-card h3{
//           font-size:24px;
//           margin-bottom:12px;
//         }

//         .restaurant-card p{
//           color:#6b7280;
//           margin-bottom:18px;
//         }

//         .small-progress{
//           height:12px;
//           background:#eee;
//           border-radius:20px;
//           overflow:hidden;
//         }

//         .small-fill{
//           height:100%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//         }

//         /* MODAL */
//         .modal-overlay{
//           position:fixed;
//           top:0;
//           left:0;
//           width:100%;
//           height:100%;
//           background:rgba(0,0,0,0.5);
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           z-index:999;
//           padding:20px;
//         }

//         .modal{
//           background:white;
//           width:100%;
//           max-width:520px;
//           border-radius:35px;
//           padding:40px;
//           animation:popup 0.3s ease;
//         }

//         @keyframes popup{
//           from{ transform:scale(0.8); opacity:0; }
//           to{ transform:scale(1); opacity:1; }
//         }

//         .close-btn{
//           width:100%;
//           height:60px;
//           border:none;
//           border-radius:18px;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           font-size:18px;
//           font-weight:700;
//           cursor:pointer;
//           margin-top:15px;
//         }

//         @media(max-width:900px){
//           .dashboard{ padding:20px; }
//           .current-visit{ grid-template-columns:1fr; }
//           .top-left h1{ font-size:28px; }
//           .visit-ring{ width:190px; height:190px; }
//           .ring-inner{ width:145px; height:145px; }
//           .ring-inner h1{ font-size:42px; }
//         }
//       `}</style>

//       <div className="dashboard">

//         {/* TOPBAR */}
//         <div className="topbar">
//           <div className="top-left">
//             <h1>Smart Loyalty Dashboard</h1>
//             <p>Welcome, <b>{customer?.name || "User"}</b> | Tracking for <b>{merchant?.business_name || "Merchant"}</b></p>
//           </div>

//           <div className="top-right">
//             {/* NEW BUTTONS REQUESTED */}
//             <button className="nav-btn special" onClick={() => navigate("/my-restaurants")}>My Restaurants</button>
//             <button className="nav-btn action-trigger" disabled={actionLoading} onClick={handleAddVisit}>
//               {actionLoading ? "Processing..." : "+ Add Visit Check-In"}
//             </button>
//              <button className="nav-btn" onClick={() => navigate("/MyQRScreen")}>MY QR</button>
//             <button className="nav-btn" onClick={() => navigate("/feedback")}>Feedback</button>
//             <button className="nav-btn" onClick={() => navigate("/user-feed")}>My Profile</button>
//             {/* <button className="nav-btn" onClick={() => navigate("/merchantrules")}>Merchant Rules</button>
//             <button className="nav-btn" onClick={() => navigate("/merchantanalytics")}>Analytics</button> */}
//             <div className="profile">
//               {(customer?.name || "U").charAt(0).toUpperCase()}
//             </div>
//           </div>
//         </div>

//         {/* TABS */}
//         <div className="tabs">
//           <button
//             className={`tab-btn ${activeTab === "current" ? "active" : ""}`}
//             onClick={() => setActiveTab("current")}
//           >
//             Current Visit
//           </button>
//           <button
//             className={`tab-btn ${activeTab === "passes" ? "active" : ""}`}
//             onClick={() => setActiveTab("passes")}
//           >
//             My All Passes ({all_passes.length})
//           </button>
//           <button
//             className={`tab-btn ${activeTab === "my_rewards" ? "active" : ""}`}
//             onClick={() => setActiveTab("my_rewards")}
//           >
//             My Unlocked Rewards ({rewardsList.length})
//           </button>
//         </div>

//         {/* CURRENT VISIT TAB */}
//         {activeTab === "current" && (
//           <div>
//             {/* SWIPEABLE TIMELINE FEATURE */}
//             <div className="timeline-card">
//               <h3>🎁 Loyalty Passes Roadmap</h3>
//               <div className="timeline-slider">
//                 {all_passes.map((pass) => {
//                   const isNextTarget = next_reward && next_reward.pass_id === pass.id;
//                   const isCompleted = current_visit >= pass.total_visits;

//                   return (
//                     <div 
//                       key={pass.id} 
//                       className={`timeline-item ${isNextTarget ? "next-up" : ""}`}
//                     >
//                       <h5>🎯 On {pass.total_visits} {pass.total_visits === 1 ? "Visit" : "Visits"}</h5>
//                       <p>{pass.reward}</p>
                      
//                       {isCompleted ? (
//                         <span className="timeline-badge" style={{ background: "#ecfdf5", color: "#059669" }}>
//                           Unlocked 🎉
//                         </span>
//                       ) : isNextTarget ? (
//                         <span className="timeline-badge" style={{ background: "#ffea2c", color: "#111827" }}>
//                           Next Target 🎯
//                         </span>
//                       ) : (
//                         <span className="timeline-badge" style={{ background: "#e5e7eb", color: "#6b7280" }}>
//                           Locked 🔒
//                         </span>
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>

//             <div className="current-visit">
//               {/* VISIT RING CARD */}
//               <div className="card">
//                 <h3>Your Current Visit</h3>
                
//                 <div 
//                   className="visit-ring"
//                   style={{
//                     background: `conic-gradient(#ff8c42 0% ${progressPercentage}%, #e5e7eb ${progressPercentage}% 100%)`
//                   }}
//                 >
//                   <div className="ring-inner">
//                     <h1>{current_visit}</h1>
//                     <p>Visits Done</p>
//                   </div>
//                 </div>

//                 {next_reward ? (
//                   <div className="milestone">
//                     <h4>Next Milestone: {next_reward.title}</h4>
//                     <div className="progress">
//                       <div className="progress-fill" style={{ width: `${progressPercentage}%` }}></div>
//                     </div>
//                     <p>
//                       Only <b>{next_reward.remaining_visits}</b> visit left to unlock reward worth <b>₹{next_reward.reward}</b> 🎉
//                     </p>
//                   </div>
//                 ) : (
//                   <div className="milestone">
//                     <p>Woohoo! All loyalty targets reached! 🏁</p>
//                   </div>
//                 )}
//               </div>

//               {/* UNLOCKED REWARDS QUICK CARD */}
//               <div className="reward-card">
//                 {unlocked_rewards && unlocked_rewards.length > 0 ? (
//                   <>
//                     <div className="reward-tag">Reward Ready!</div>
//                     <h2>{unlocked_rewards[0].title || "Discount Coupon"}</h2>
//                     <p>Value/Reward: {unlocked_rewards[0].reward}</p>
//                     <div className="coupon" style={{ fontSize: "16px" }}> Go to "My Unlocked Rewards" tab to redeem</div>
//                   </>
//                 ) : (
//                   <>
//                     <div className="reward-tag" style={{ background: "#6b7280" }}>No Instant Rewards</div>
//                     <h2>Keep Visiting!</h2>
//                     <p>Once your current visits match any pass criteria, your active claims/coupons will appear here.</p>
//                     <div className="coupon" style={{ background: "#374151", letterSpacing: "normal", fontSize: "16px" }}>
//                       LOCK 🔒
//                     </div>
//                   </>
//                 )}

//                 <button className="feedback-btn" onClick={() => navigate("/feedback")}>
//                   Give Feedback →
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* ALL PASSES TAB */}
//         {activeTab === "passes" && (
//           <div>
//             <div className="search-box">
//               <input
//                 type="text"
//                 placeholder="Search Passes..."
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//               />
//             </div>

//             <div className="grid">
//               {filteredPasses.map((item) => {
//                 const itemProgress = Math.min((current_visit / item.total_visits) * 100, 100);
//                 const isItemCompleted = current_visit >= item.total_visits;

//                 return (
//                   <div
//                     key={item.id}
//                     className="restaurant-card"
//                     onClick={() => setSelectedRestaurant(item)}
//                   >
//                     <div className="restaurant-top">
//                       <div className="restaurant-logo">🎫</div>
//                       <div className="status" style={{ backgroundColor: isItemCompleted ? "#ecfdf5" : "#fef3c7", color: isItemCompleted ? "#059669" : "#d97706" }}>
//                         {isItemCompleted ? "Completed" : "In Progress"}
//                       </div>
//                     </div>

//                     <h3>{item.title}</h3>
//                     <p>Reward: <b>{item.reward}</b></p>
//                     <p style={{ fontSize: "14px" }}>Target Required: {item.total_visits} Visits</p>

//                     <div className="small-progress">
//                       <div className="small-fill" style={{ width: `${itemProgress}%` }}></div>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         )}

//         {/* NEW TAB: MY REWARDS LIST & REDEMPTION SYSTEM */}
//         {activeTab === "my_rewards" && (
//           <div>
//             <h2 style={{ marginBottom: "20px", color: "#111827" }}>Your Earned Unlocked Rewards</h2>
//             {rewardsList.length === 0 ? (
//               <p style={{ color: "#6b7280" }}>No rewards claimed or unlocked yet. Keep scanning your visits! ✨</p>
//             ) : (
//               <div className="rewards-grid">
//                 {rewardsList.map((rewardItem) => (
//                   <div key={rewardItem.id} className="coupon-card">
//                     <div>
//                       <div className="coupon-header">
//                         <span style={{ fontSize: "28px" }}>🎁</span>
//                         <span className="status" style={{ 
//                           backgroundColor: rewardItem.status === "used" ? "#f3f4f6" : "#ecfdf5", 
//                           color: rewardItem.status === "used" ? "#6b7280" : "#059669" 
//                         }}>
//                           {rewardItem.status.toUpperCase()}
//                         </span>
//                       </div>
//                       <h3 style={{ fontSize: "20px", color: "#111827", marginBottom: "8px" }}>Reward Worth: ₹{rewardItem.reward}</h3>
//                       <p style={{ fontSize: "13px", color: "#9ca3af", marginBottom: "15px" }}>Earned on: {rewardItem.created_at}</p>
//                     </div>
//                     <div>
//                       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                         <span style={{ fontSize: "14px", color: "#4b5563" }}>Code:</span>
//                         <span className="coupon-code-txt">{rewardItem.coupon_code}</span>
//                       </div>
//                       {rewardItem.status !== "used" && (
//                         <button 
//                           className="redeem-btn" 
//                           disabled={actionLoading}
//                           onClick={() => handleRedeemReward(rewardItem.coupon_code)}
//                         >
//                           {actionLoading ? "Processing..." : "Redeem At Counter 🔓"}
//                         </button>
//                       )}
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         )}

//         {/* DETAILS MODAL */}
//         {selectedRestaurant && (
//           <div className="modal-overlay">
//             <div className="modal">
//               <h2>🎫 {selectedRestaurant.title}</h2>
//               <p style={{ color: "#6b7280", margin: "15px 0" }}>Loyalty Rule Details & Reward Tracking</p>

//               <div className="rule-box">
//                 <h3>Reward: {selectedRestaurant.reward}</h3>
//                 <p style={{ marginTop: "10px" }}>Required Total Visits: <b>{selectedRestaurant.total_visits}</b></p>
//                 <p>Your Current Visits: <b>{current_visit}</b></p>
//               </div>

//               <button className="close-btn" onClick={() => navigate("/feedback")}>Give Feedback</button>
//               <button className="close-btn" style={{ background: "#374151" }} onClick={() => setSelectedRestaurant(null)}>Close</button>
//             </div>
//           </div>
//         )}

//       </div>
//     </>
//   );
// }


// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// export default function VisitDashboard() {
//   const navigate = useNavigate();

//   // Tab management: "current", "passes", "my_rewards", "restaurants"
//   const [activeTab, setActiveTab] = useState("current");
//   const [search, setSearch] = useState("");
//   const [selectedPass, setSelectedPass] = useState(null);
  
//   // State for IDs (Dynamic switching when user clicks another restaurant)
//   const [customerId, setCustomerId] = useState("CMVC497B3A688");
//   const [merchantId, setMerchantId] = useState("CMV9A117EAC");

//   // API Data States
//   const [dashboardData, setDashboardData] = useState(null);
//   const [rewardsList, setRewardsList] = useState([]); 
//   const [restaurantsList, setRestaurantsList] = useState([]);
  
//   // Status States
//   const [loading, setLoading] = useState(true);
//   const [actionLoading, setActionLoading] = useState(false);
//   const [error, setError] = useState(null);

//   // Helper function to clean text responses from PHP APIs
//   const cleanAndParseJson = (text) => {
//     try {
//       const cleanString = text.replace("DATABASE CONNECTED", "").trim();
//       return JSON.parse(cleanString);
//     } catch (e) {
//       console.error("JSON Parsing failed for response: ", text);
//       throw new Error("Invalid server response format.");
//     }
//   };

//   // Core function to load complete dashboard information
//   const fetchDashboardData = async (mId = merchantId) => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", customerId);
//       formdata.append("merchant_id", mId);

//       const response = await fetch("https://countmyvisit.com/Apis/customer_dashboard.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         setDashboardData(data);
//       } else {
//         setError("Failed to fetch dashboard data.");
//       }
//     } catch (err) {
//       console.error(err);
//       setError("Something went wrong while fetching dashboard data.");
//     }
//   };

//   // Function to load all historical or current rewards/coupons for the customer
//   const fetchRewardsList = async (mId = merchantId) => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", customerId);
//       formdata.append("merchant_id", mId);

//       const response = await fetch("https://countmyvisit.com/Apis/my_rewards.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         setRewardsList(data.rewards || []);
//       }
//     } catch (err) {
//       console.error("Error fetching rewards history:", err);
//     }
//   };

//   // New Function to load all restaurants connected to this customer
//   const fetchRestaurantsList = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", customerId);

//       const response = await fetch("https://countmyvisit.com/Apis/my_restaurants.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         setRestaurantsList(data.restaurants || []);
//       }
//     } catch (err) {
//       console.error("Error fetching restaurants list:", err);
//     }
//   };

//   // Initial data loading trigger
//   useEffect(() => {
//     async function loadAllInitialData() {
//       setLoading(true);
//       setError(null);
//       await fetchDashboardData(merchantId);
//       await fetchRewardsList(merchantId);
//       await fetchRestaurantsList();
//       setLoading(false);
//     }
//     loadAllInitialData();
//   }, [merchantId]); // Automatically re-runs when merchantId changes

//   // Action: Switch Merchant / Restaurant View
//   const handleSelectRestaurant = (mId) => {
//     setMerchantId(mId);
//     setActiveTab("current"); // Switch back to overview tab for the selected restaurant
//   };

//   // Action: Add a new visit log dynamically
//   const handleAddVisit = async () => {
//     setActionLoading(true);
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", customerId);
//       formdata.append("merchant_id", merchantId);

//       const response = await fetch("https://countmyvisit.com/Apis/add_visit.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         alert(`Visit marked successfully! Current visits: ${data.current_visit}`);
//         await fetchDashboardData(merchantId);
//         await fetchRewardsList(merchantId);
//         await fetchRestaurantsList(); // Refresh restaurant visit counter too
//       } else {
//         alert(data.message || "Unable to register visit at this moment.");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Error executing visit update routing.");
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   // Action: Instantly burn/redeem an active code at the counter
//   const handleRedeemReward = async (couponCode) => {
//     if (!window.confirm(`Are you sure you want to redeem coupon code: ${couponCode}?`)) return;
//     setActionLoading(true);
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", customerId);
//       formdata.append("merchant_id", merchantId);
//       formdata.append("coupon_code", couponCode);

//       const response = await fetch("https://countmyvisit.com/Apis/redeem_reward.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         alert(data.message || "Reward Redeemed Successfully! 🎁");
//         await fetchDashboardData(merchantId);
//         await fetchRewardsList(merchantId);
//       } else {
//         alert(data.message || "Failed to process point redemption validation.");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Network exception occurred during counter redemption check.");
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "Poppins, sans-serif", fontSize: "20px", Richmond: "600", color: "#ff8c42" }}>
//         <div style={{ textAlign: "center" }}>
//           <div>🔄 Loading Dashboard Assets...</div>
//           <p style={{ fontSize: "14px", color: "#6b7280", marginTop: "8px", fontWeight: "400" }}>Setting up premium UI elements</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "Poppins, sans-serif", fontSize: "18px", color: "red", flexDirection: "column", gap: "15px" }}>
//         <span>⚠️ {error}</span>
//         <button className="nav-btn special" onClick={() => window.location.reload()}>Retry Loading</button>
//       </div>
//     );
//   }

//   const { current_visit, next_reward, unlocked_rewards, all_passes, merchant, customer } = dashboardData;

//   // Global filtering for passes
//   const filteredPasses = all_passes.filter((item) =>
//     item.title.toLowerCase().includes(search.toLowerCase()) || 
//     item.reward.toLowerCase().includes(search.toLowerCase())
//   );

//   // Global filtering for restaurants
//   const filteredRestaurants = restaurantsList.filter((res) => 
//     res.business_name.toLowerCase().includes(search.toLowerCase()) ||
//     res.address.toLowerCase().includes(search.toLowerCase())
//   );

//   const maxVisitsForProgress = next_reward ? parseInt(next_reward.required_visits) : 1;
//   const progressPercentage = Math.min((parseInt(current_visit) / maxVisitsForProgress) * 100, 100);

//   return (
//     <>
//       <style>{`
//         *{
//           margin:0;
//           padding:0;
//           box-sizing:border-box;
//           font-family:'Poppins',sans-serif;
//         }

//         body{
//           background:#f4f7fb;
//         }

//         .dashboard{
//           min-height:100vh;
//           padding:35px;
//           background: linear-gradient(135deg,#fff7ed,#fff,#f3f7ff);
//         }

//         /* TOP BAR */
//         .topbar{
//           display:flex;
//           justify-content:space-between;
//           align-items:center;
//           margin-bottom:35px;
//           flex-wrap:wrap;
//           gap:20px;
//         }

//         .top-left h1{
//           font-size:38px;
//           font-weight:800;
//           color:#111827;
//         }

//         .top-left p{
//           color:#6b7280;
//           margin-top:8px;
//           font-size:15px;
//          }

//         .top-right{
//           display:flex;
//           align-items:center;
//           gap:12px;
//           flex-wrap:wrap;
//         }

//         .profile{
//           width:58px;
//           height:58px;
//           border-radius:50%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           font-size:24px;
//           font-weight:700;
//           box-shadow:0 10px 30px rgba(255,94,98,0.3);
//         }

//         .nav-btn{
//           border:none;
//           padding:14px 20px;
//           border-radius:16px;
//           background:linear-gradient(135deg,#111827,#374151);
//           color:white;
//           font-size:14px;
//           font-weight:700;
//           cursor:pointer;
//           transition:0.3s;
//         }

//         .nav-btn.special{
//           background:linear-gradient(135deg,#2563eb,#1d4ed8);
//         }

//         .nav-btn.action-trigger{
//           background:linear-gradient(135deg,#10b981,#059669);
//         }

//         .nav-btn:hover, .redeem-btn:hover, .select-shop-btn:hover{
//           transform:translateY(-3px);
//           opacity:0.95;
//           box-shadow: 0 5px 15px rgba(0,0,0,0.1);
//         }

//         /* TABS */
//         .tabs{
//           display:flex;
//           gap:15px;
//           margin-bottom:35px;
//           flex-wrap:wrap;
//         }

//         .tab-btn{
//           padding:15px 28px;
//           border:none;
//           border-radius:18px;
//           font-size:16px;
//           font-weight:700;
//           background:white;
//           color:#555;
//           cursor:pointer;
//           transition:0.3s;
//           box-shadow:0 5px 20px rgba(0,0,0,0.05);
//         }

//         .tab-btn.active{
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           transform:translateY(-2px);
//         }

//         /* TIMELINE SLIDER CARD */
//         .timeline-card{
//           background: white;
//           border-radius: 30px;
//           padding: 30px;
//           margin-bottom: 30px;
//           box-shadow: 0 10px 35px rgba(0,0,0,0.06);
//         }

//         .timeline-card h3{
//           font-size: 22px;
//           color: #111827;
//           margin-bottom: 15px;
//         }

//         .timeline-slider{
//           display: flex;
//           gap: 20px;
//           overflow-x: auto;
//           padding: 10px 5px 20px 5px;
//           scroll-behavior: smooth;
//         }

//         .timeline-slider::-webkit-scrollbar {
//           height: 8px;
//         }
//         .timeline-slider::-webkit-scrollbar-thumb {
//           background: #ff8c42;
//           border-radius: 10px;
//         }
//         .timeline-slider::-webkit-scrollbar-track {
//           background: #f3f4f6;
//         }

//         .timeline-item {
//           min-width: 240px;
//           background: #fff8f5;
//           border: 2px dashed #ffdcd0;
//           border-radius: 20px;
//           padding: 20px;
//           position: relative;
//           transition: 0.3s;
//         }

//         .timeline-item.next-up {
//           background: #fff7ed;
//           border: 2px solid #ff8c42;
//           box-shadow: 0 8px 25px rgba(255,140,66,0.15);
//         }

//         .timeline-item h5 {
//           font-size: 14px;
//           color: #ff6b35;
//           text-transform: uppercase;
//           margin-bottom: 5px;
//           font-weight: 700;
//         }

//         .timeline-item p {
//           font-size: 16px;
//           font-weight: 700;
//           color: #111827;
//         }

//         .timeline-badge {
//           display: inline-block;
//           font-size: 11px;
//           padding: 4px 10px;
//           border-radius: 20px;
//           font-weight: 700;
//           margin-top: 10px;
//         }

//         /* GRID LAYOUTS */
//         .current-visit{
//           display:grid;
//           grid-template-columns:1fr 1fr;
//           gap:30px;
//         }

//         .card{
//           background:white;
//           border-radius:30px;
//           padding:35px;
//           box-shadow:0 10px 35px rgba(0,0,0,0.06);
//         }

//         .card h3{
//           font-size:26px;
//           margin-bottom:25px;
//           color:#111827;
//         }

//         .visit-ring{
//           width:230px;
//           height:230px;
//           margin:auto;
//           border-radius:50%;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           animation:spin 1s ease;
//         }

//         .ring-inner{
//           width:180px;
//           height:180px;
//           background:white;
//           border-radius:50%;
//           display:flex;
//           flex-direction:column;
//           align-items:center;
//           justify-content:center;
//         }

//         .ring-inner h1{
//           font-size:52px;
//           color:#ff6b35;
//           font-weight:800;
//         }

//         .ring-inner p{
//           color:#6b7280;
//           font-size:17px;
//           font-weight:600;
//         }

//         @keyframes spin{
//           from{ transform:scale(0.7) rotate(-100deg); opacity:0; }
//           to{ transform:scale(1) rotate(0deg); opacity:1; }
//         }

//         /* REWARD CARD */
//         .reward-card{
//           background: linear-gradient(135deg,#111827,#1f2937);
//           border-radius:28px;
//           padding:35px;
//           color:white;
//           position:relative;
//           overflow:hidden;
//           display: flex;
//           flex-direction: column;
//           justify-content: space-between;
//         }

//         .reward-card::before{
//           content:'';
//           position:absolute;
//           width:180px;
//           height:180px;
//           background:rgba(255,255,255,0.05);
//           border-radius:50%;
//           top:-50px;
//           right:-40px;
//         }

//         .reward-tag{
//           display:inline-block;
//           background:#22c55e;
//           color:white;
//           padding:8px 18px;
//           border-radius:30px;
//           font-size:14px;
//           font-weight:700;
//           margin-bottom:20px;
//           width: max-content;
//         }

//         .reward-card h2{
//           font-size:34px;
//           margin-bottom:18px;
//         }

//         .reward-card p{
//           color:#d1d5db;
//           line-height:1.7;
//         }

//         .coupon{
//           background:#ff8c42;
//           padding:16px;
//           border-radius:18px;
//           text-align:center;
//           font-size:24px;
//           font-weight:800;
//           letter-spacing:2px;
//           margin-top:25px;
//         }

//         .feedback-btn{
//           margin-top:25px;
//           width:100%;
//           height:60px;
//           border:none;
//           border-radius:18px;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           font-size:17px;
//           font-weight:700;
//           cursor:pointer;
//           transition:0.3s;
//         }

//         .feedback-btn:hover{
//           transform:translateY(-3px);
//         }

//         /* MILESTONE */
//         .milestone{
//           margin-top:30px;
//         }

//         .milestone h4{
//           margin-bottom:15px;
//           font-size:18px;
//           color:#111827;
//         }

//         .progress{
//           height:16px;
//           border-radius:30px;
//           background:#e5e7eb;
//           overflow:hidden;
//         }

//         .progress-fill{
//           height:100%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           border-radius:30px;
//         }

//         .milestone p{
//           margin-top:12px;
//           color:#6b7280;
//           font-weight:500;
//         }

//         /* REWARDS HISTORY TABLE / GRID */
//         .rewards-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
//           gap: 25px;
//         }

//         .coupon-card {
//           background: white;
//           border-radius: 24px;
//           padding: 25px;
//           box-shadow: 0 10px 30px rgba(0,0,0,0.04);
//           border: 1px solid #eef2f6;
//           display: flex;
//           flex-direction: column;
//           justify-content: space-between;
//         }

//         .coupon-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 15px;
//         }

//         .coupon-code-txt {
//           font-family: monospace;
//           background: #f3f4f6;
//           padding: 6px 12px;
//           border-radius: 8px;
//           font-weight: 700;
//           font-size: 16px;
//           color: #374151;
//         }

//         .redeem-btn, .select-shop-btn {
//           width: 100%;
//           padding: 14px;
//           border: none;
//           background: linear-gradient(135deg, #10b981, #059669);
//           color: white;
//           border-radius: 14px;
//           font-size: 15px;
//           font-weight: 700;
//           cursor: pointer;
//           margin-top: 15px;
//           transition: 0.2s;
//         }

//         .select-shop-btn {
//           background: linear-gradient(135deg, #2563eb, #1d4ed8);
//         }

//         /* SEARCH & GRID */
//         .search-box{
//           margin-bottom:30px;
//         }

//         .search-box input{
//           width:100%;
//           height:68px;
//           border:none;
//           border-radius:20px;
//           padding:0 25px;
//           font-size:17px;
//           background:white;
//           box-shadow:0 10px 30px rgba(0,0,0,0.05);
//           outline:none;
//         }

//         .grid{
//           display:grid;
//           grid-template-columns:repeat(auto-fit,minmax(280px,1fr));
//           gap:25px;
//         }

//         .restaurant-card{
//           background:white;
//           border-radius:28px;
//           padding:30px;
//           box-shadow:0 10px 30px rgba(0,0,0,0.05);
//           transition:0.3s;
//           cursor:pointer;
//           position:relative;
//         }

//         .restaurant-card:hover{
//           transform:translateY(-8px);
//         }

//         .restaurant-top{
//           display:flex;
//           justify-content:space-between;
//           align-items:center;
//           margin-bottom:20px;
//         }

//         .restaurant-logo{
//           width:65px;
//           height:65px;
//           border-radius:20px;
//           background:#fff4eb;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           font-size:34px;
//         }

//         .status{
//           padding:10px 15px;
//           border-radius:30px;
//           font-size:13px;
//           font-weight:700;
//         }

//         .restaurant-card h3{
//           font-size:24px;
//           margin-bottom:12px;
//         }

//         .restaurant-card p{
//           color:#6b7280;
//           margin-bottom:18px;
//         }

//         .small-progress{
//           height:12px;
//           background:#eee;
//           border-radius:20px;
//           overflow:hidden;
//         }

//         .small-fill{
//           height:100%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//         }

//         /* MODAL */
//         .modal-overlay{
//           position:fixed;
//           top:0;
//           left:0;
//           width:100%;
//           height:100%;
//           background:rgba(0,0,0,0.5);
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           z-index:999;
//           padding:20px;
//         }

//         .modal{
//           background:white;
//           width:100%;
//           max-width:520px;
//           border-radius:35px;
//           padding:40px;
//           animation:popup 0.3s ease;
//         }

//         .rule-box {
//           background: #f9fafb;
//           border: 1px solid #e5e7eb;
//           padding: 20px;
//           border-radius: 20px;
//           margin-top: 15px;
//         }

//         @keyframes popup{
//           from{ transform:scale(0.8); opacity:0; }
//           to{ transform:scale(1); opacity:1; }
//         }

//         .close-btn{
//           width:100%;
//           height:60px;
//           border:none;
//           border-radius:18px;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           font-size:18px;
//           font-weight:700;
//           cursor:pointer;
//           margin-top:15px;
//         }

//         @media(max-width:900px){
//           .dashboard{ padding:20px; }
//           .current-visit{ grid-template-columns:1fr; }
//           .top-left h1{ font-size:28px; }
//           .visit-ring{ width:190px; height:190px; }
//           .ring-inner{ width:145px; height:145px; }
//           .ring-inner h1{ font-size:42px; }
//         }
//       `}</style>

//       <div className="dashboard">

//         {/* TOPBAR */}
//         <div className="topbar">
//           <div className="top-left">
//             <h1>Smart Loyalty Dashboard</h1>
//             <p>Welcome, <b>{customer?.name || "User"}</b> | Tracking for <b>{merchant?.business_name || "Merchant"}</b></p>
//           </div>

//           <div className="top-right">
//             <button className="nav-btn special" onClick={() => setActiveTab("restaurants")}>My Restaurants 🍽️</button>
//             <button className="nav-btn action-trigger" disabled={actionLoading} onClick={handleAddVisit}>
//               {actionLoading ? "Processing..." : "+ Add Visit Check-In"}
//             </button>
//             <button className="nav-btn" onClick={() => navigate("/MyQRScreen")}>MY QR</button>
//             <button className="nav-btn" onClick={() => navigate("/feedback")}>Feedback</button>
//             <button className="nav-btn" onClick={() => navigate("/user-feed")}>My Profile</button>
//             <div className="profile">
//               {(customer?.name || "U").charAt(0).toUpperCase()}
//             </div>
//           </div>
//         </div>

//         {/* TABS CONTROLLER */}
//         <div className="tabs">
//           <button
//             className={`tab-btn ${activeTab === "current" ? "active" : ""}`}
//             onClick={() => setActiveTab("current")}
//           >
//             Current Visit
//           </button>
//           <button
//             className={`tab-btn ${activeTab === "passes" ? "active" : ""}`}
//             onClick={() => setActiveTab("passes")}
//           >
//             My All Passes ({all_passes?.length || 0})
//           </button>
//           <button
//             className={`tab-btn ${activeTab === "my_rewards" ? "active" : ""}`}
//             onClick={() => setActiveTab("my_rewards")}
//           >
//             My Unlocked Rewards ({rewardsList?.length || 0})
//           </button>
//           <button
//             className={`tab-btn ${activeTab === "restaurants" ? "active" : ""}`}
//             onClick={() => setActiveTab("restaurants")}
//           >
//             All Restaurants ({restaurantsList?.length || 0})
//           </button>
//         </div>

//         {/* 1. CURRENT VISIT TAB */}
//         {activeTab === "current" && (
//           <div>
//             <div className="timeline-card">
//               <h3>🎁 Loyalty Passes Roadmap</h3>
//               <div className="timeline-slider">
//                 {all_passes?.map((pass) => {
//                   const isNextTarget = next_reward && next_reward.pass_id === pass.id;
//                   const isCompleted = parseInt(current_visit) >= parseInt(pass.total_visits);

//                   return (
//                     <div 
//                       key={pass.id} 
//                       className={`timeline-item ${isNextTarget ? "next-up" : ""}`}
//                     >
//                       <h5>🎯 On {pass.total_visits} Visits</h5>
//                       <p>{pass.reward}</p>
                      
//                       {isCompleted ? (
//                         <span className="timeline-badge" style={{ background: "#ecfdf5", color: "#059669" }}>
//                           Unlocked 🎉
//                         </span>
//                       ) : isNextTarget ? (
//                         <span className="timeline-badge" style={{ background: "#ffea2c", color: "#111827" }}>
//                           Next Target 🎯
//                         </span>
//                       ) : (
//                         <span className="timeline-badge" style={{ background: "#e5e7eb", color: "#6b7280" }}>
//                           Locked 🔒
//                         </span>
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>

//             <div className="current-visit">
//               {/* VISIT RING CARD */}
//               <div className="card">
//                 <h3>Your Current Visit Progress</h3>
//                 <div 
//                   className="visit-ring"
//                   style={{
//                     background: `conic-gradient(#ff8c42 0% ${progressPercentage}%, #e5e7eb ${progressPercentage}% 100%)`
//                   }}
//                 >
//                   <div className="ring-inner">
//                     <h1>{current_visit}</h1>
//                     <p>Visits Done</p>
//                   </div>
//                 </div>

//                 {next_reward ? (
//                   <div className="milestone">
//                     <h4>Next Milestone: {next_reward.title}</h4>
//                     <div className="progress">
//                       <div className="progress-fill" style={{ width: `${progressPercentage}%` }}></div>
//                     </div>
//                     <p>
//                       Only <b>{next_reward.remaining_visits}</b> visit left to unlock reward worth <b>₹{next_reward.reward}</b> 🎉
//                     </p>
//                   </div>
//                 ) : (
//                   <div className="milestone">
//                     <p style={{ color: "#10b981", fontWeight: "700" }}>Woohoo! All loyalty targets reached! 🏁</p>
//                   </div>
//                 )}
//               </div>

//               {/* UNLOCKED REWARDS QUICK VIEW */}
//               <div className="reward-card">
//                 <div>
//                   {unlocked_rewards && unlocked_rewards.length > 0 ? (
//                     <>
//                       <div className="reward-tag">Reward Ready!</div>
//                       <h2>{unlocked_rewards[0].title || "Discount Coupon"}</h2>
//                       <p>Value/Reward: <b>₹{unlocked_rewards[0].reward}</b></p>
//                       <div className="coupon" style={{ fontSize: "14px", letterSpacing: "normal" }}> 
//                         Go to "My Unlocked Rewards" tab to redeem 
//                       </div>
//                     </>
//                   ) : (
//                     <>
//                       <div className="reward-tag" style={{ background: "#6b7280" }}>No Instant Claims</div>
//                       <h2>Keep Visiting!</h2>
//                       <p>Once your target completes, your active coupon codes will unlock instantly right here.</p>
//                       <div className="coupon" style={{ background: "#374151", letterSpacing: "normal", fontSize: "16px" }}>
//                         LOCKED 🔒
//                       </div>
//                     </>
//                   )}
//                 </div>

//                 <button className="feedback-btn" onClick={() => navigate("/feedback")}>
//                   Give Feedback →
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* 2. ALL PASSES TAB */}
//         {activeTab === "passes" && (
//           <div>
//             <div className="search-box">
//               <input
//                 type="text"
//                 placeholder="Search specific rules or passes..."
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//               />
//             </div>

//             <div className="grid">
//               {filteredPasses.map((item) => {
//                 const itemProgress = Math.min((parseInt(current_visit) / parseInt(item.total_visits)) * 100, 100);
//                 const isItemCompleted = parseInt(current_visit) >= parseInt(item.total_visits);

//                 return (
//                   <div
//                     key={item.id}
//                     className="restaurant-card"
//                     onClick={() => setSelectedPass(item)}
//                   >
//                     <div className="restaurant-top">
//                       <div className="restaurant-logo">🎫</div>
//                       <div className="status" style={{ backgroundColor: isItemCompleted ? "#ecfdf5" : "#fef3c7", color: isItemCompleted ? "#059669" : "#d97706" }}>
//                         {isItemCompleted ? "Completed" : "In Progress"}
//                       </div>
//                     </div>

//                     <h3>{item.title}</h3>
//                     <p>Reward: <b>{item.reward}</b></p>
//                     <p style={{ fontSize: "14px" }}>Required Goal: {item.total_visits} Visits</p>

//                     <div className="small-progress">
//                       <div className="small-fill" style={{ width: `${itemProgress}%` }}></div>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         )}

//         {/* 3. MY UNLOCKED REWARDS TAB */}
//         {activeTab === "my_rewards" && (
//           <div>
//             <h2 style={{ marginBottom: "20px", color: "#111827" }}>Your Earned Unlocked Rewards</h2>
//             {rewardsList.length === 0 ? (
//               <p style={{ color: "#6b7280" }}>No rewards claimed or unlocked yet. Keep scanning your visits! ✨</p>
//             ) : (
//               <div className="rewards-grid">
//                 {rewardsList.map((rewardItem) => (
//                   <div key={rewardItem.id} className="coupon-card">
//                     <div>
//                       <div className="coupon-header">
//                         <span style={{ fontSize: "28px" }}>🎁</span>
//                         <span className="status" style={{ 
//                           backgroundColor: rewardItem.status === "used" ? "#f3f4f6" : "#ecfdf5", 
//                           color: rewardItem.status === "used" ? "#6b7280" : "#059669" 
//                         }}>
//                           {rewardItem.status.toUpperCase()}
//                         </span>
//                       </div>
//                       <h3 style={{ fontSize: "20px", color: "#111827", marginBottom: "8px" }}>Reward Worth: ₹{rewardItem.reward}</h3>
//                       <p style={{ fontSize: "13px", color: "#9ca3af", marginBottom: "15px" }}>Earned on: {rewardItem.created_at}</p>
//                     </div>
//                     <div>
//                       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                         <span style={{ fontSize: "14px", color: "#4b5563" }}>Code:</span>
//                         <span className="coupon-code-txt">{rewardItem.coupon_code}</span>
//                       </div>
//                       {rewardItem.status !== "used" && (
//                         <button 
//                           className="redeem-btn" 
//                           disabled={actionLoading}
//                           onClick={() => handleRedeemReward(rewardItem.coupon_code)}
//                         >
//                           {actionLoading ? "Processing..." : "Redeem At Counter 🔓"}
//                         </button>
//                       )}
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         )}

//         {/* 4. NEW TAB: ALL CONNECTED RESTAURANTS LIST */}
//         {activeTab === "restaurants" && (
//           <div>
//             <div className="search-box">
//               <input
//                 type="text"
//                 placeholder="Search restaurant by name or location..."
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//               />
//             </div>

//             <div className="grid">
//               {filteredRestaurants.map((res) => {
//                 const isCurrentlySelected = res.merchant_id === merchantId;
//                 return (
//                   <div key={res.merchant_id} className="restaurant-card" style={{ border: isCurrentlySelected ? "2px solid #ff8c42" : "1px solid transparent" }}>
//                     <div className="restaurant-top">
//                       <div className="restaurant-logo">🍽️</div>
//                       <div className="status" style={{ backgroundColor: isCurrentlySelected ? "#ffebdb" : "#f3f4f6", color: isCurrentlySelected ? "#ff6b35" : "#4b5563" }}>
//                         {isCurrentlySelected ? "Active Tracking" : "Connected Shop"}
//                       </div>
//                     </div>
//                     <h3>{res.business_name}</h3>
//                     <p style={{ textTransform: "capitalize", fontSize: "14px", color: "#9ca3af" }}>Type: {res.business_type} | Owner: {res.owner_name}</p>
//                     <p>📍 <b>{res.address}</b></p>
                    
//                     <div style={{ background: "#f9fafb", padding: "12px", borderRadius: "12px", textAlign: "center" }}>
//                       <span style={{ fontSize: "15px", fontWeight: "700", color: "#ff6b35" }}>{res.visits} Total Visits Done</span>
//                     </div>

//                     {!isCurrentlySelected && (
//                       <button className="select-shop-btn" onClick={() => handleSelectRestaurant(res.merchant_id)}>
//                         Switch to Dashboard View 🔄
//                       </button>
//                     )}
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         )}

//         {/* DETAILS MODAL FOR PASSES */}
//         {selectedPass && (
//           <div className="modal-overlay">
//             <div className="modal">
//               <h2>🎫 {selectedPass.title}</h2>
//               <p style={{ color: "#6b7280", margin: "15px 0" }}>Loyalty Rule Details & Reward Tracking</p>

//               <div className="rule-box">
//                 <h3>Reward: {selectedPass.reward}</h3>
//                 <p style={{ marginTop: "10px" }}>Required Total Visits: <b>{selectedPass.total_visits}</b></p>
//                 <p>Your Current Visits at this Restaurant: <b>{current_visit}</b></p>
//               </div>

//               <button className="close-btn" onClick={() => navigate("/feedback")}>Give Feedback</button>
//               <button className="close-btn" style={{ background: "#374151" }} onClick={() => setSelectedPass(null)}>Close Window</button>
//             </div>
//           </div>
//         )}

//       </div>
//     </>
//   );
// }


// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import QRCode from "react-qr-code";
// export default function VisitDashboard() {
//   const navigate = useNavigate();

//   // Tab management: "current", "passes", "my_rewards", "restaurants"
//   const [activeTab, setActiveTab] = useState("current");
//   const [search, setSearch] = useState("");
//   const [selectedPass, setSelectedPass] = useState(null);
  
//   // State for IDs (Dynamic switching when user clicks another restaurant)
//   const [customerId, setCustomerId] = useState("CMVC497B3A688");
//   const [merchantId, setMerchantId] = useState("CMV9A117EAC");

//   // API Data States
//   const [dashboardData, setDashboardData] = useState(null);
//   const [rewardsList, setRewardsList] = useState([]); 
//   const [restaurantsList, setRestaurantsList] = useState([]);
  
//   // Status States
//   const [loading, setLoading] = useState(true);
//   const [actionLoading, setActionLoading] = useState(false);
//   const [error, setError] = useState(null);

//   // Helper function to clean text responses from PHP APIs
//   const cleanAndParseJson = (text) => {
//     try {
//       const cleanString = text.replace("DATABASE CONNECTED", "").trim();
//       return JSON.parse(cleanString);
//     } catch (e) {
//       console.error("JSON Parsing failed for response: ", text);
//       throw new Error("Invalid server response format.");
//     }
//   };

//   // Core function to load complete dashboard information
//   const fetchDashboardData = async (mId = merchantId) => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", customerId);
//       formdata.append("merchant_id", mId);

//       const response = await fetch("https://countmyvisit.com/Apis/customer_dashboard.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         setDashboardData(data);
//       } else {
//         setError("Failed to fetch dashboard data.");
//       }
//     } catch (err) {
//       console.error(err);
//       setError("Something went wrong while fetching dashboard data.");
//     }
//   };

//   // Function to load historical or current rewards for the CURRENT SELECTED merchant
//   const fetchRewardsList = async (mId = merchantId) => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", customerId);
//       formdata.append("merchant_id", mId); // Passing dynamic merchant id here

//       const response = await fetch("https://countmyvisit.com/Apis/my_rewards.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         setRewardsList(data.rewards || []);
//       }
//     } catch (err) {
//       console.error("Error fetching rewards history:", err);
//     }
//   };

//   // New Function to load all restaurants connected to this customer
//   const fetchRestaurantsList = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", customerId);

//       const response = await fetch("https://countmyvisit.com/Apis/my_restaurants.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         setRestaurantsList(data.restaurants || []);
//       }
//     } catch (err) {
//       console.error("Error fetching restaurants list:", err);
//     }
//   };

//   // Initial data loading trigger
//   useEffect(() => {
//     async function loadAllInitialData() {
//       setLoading(true);
//       setError(null);
//       await fetchDashboardData(merchantId);
//       await fetchRewardsList(merchantId); // Refreshes and fetches rewards only for this merchantId
//       await fetchRestaurantsList();
//       setLoading(false);
//     }
//     loadAllInitialData();
//   }, [merchantId]); // Automatically re-runs and filters when merchantId changes

//   // Action: Switch Merchant / Restaurant View
//   const handleSelectRestaurant = (mId) => {
//     setMerchantId(mId);
//     setActiveTab("current"); // Switch back to overview tab for the selected restaurant
//   };

//   // Action: Add a new visit log dynamically
//   const handleAddVisit = async () => {
//     setActionLoading(true);
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", customerId);
//       formdata.append("merchant_id", merchantId);

//       const response = await fetch("https://countmyvisit.com/Apis/add_visit.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         alert(`Visit marked successfully! Current visits: ${data.current_visit}`);
//         await fetchDashboardData(merchantId);
//         await fetchRewardsList(merchantId);
//         await fetchRestaurantsList(); // Refresh restaurant visit counter too
//       } else {
//         alert(data.message || "Unable to register visit at this moment.");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Error executing visit update routing.");
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   // Action: Instantly burn/redeem an active code at the counter
//   const handleRedeemReward = async (couponCode) => {
//     if (!window.confirm(`Are you sure you want to redeem coupon code: ${couponCode} at ${dashboardData?.merchant?.business_name}?`)) return;
//     setActionLoading(true);
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", customerId);
//       formdata.append("merchant_id", merchantId);
//       formdata.append("coupon_code", couponCode);

//       const response = await fetch("https://countmyvisit.com/Apis/redeem_reward.php", {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         alert(data.message || "Reward Redeemed Successfully! 🎁");
//         await fetchDashboardData(merchantId);
//         await fetchRewardsList(merchantId);
//       } else {
//         alert(data.message || "Failed to process point redemption validation.");
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Network exception occurred during counter redemption check.");
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "Poppins, sans-serif", fontSize: "20px", fontWeight: "600", color: "#ff8c42" }}>
//         <div style={{ textAlign: "center" }}>
//           <div>🔄 Loading Dashboard Assets...</div>
//           <p style={{ fontSize: "14px", color: "#6b7280", marginTop: "8px", fontWeight: "400" }}>Setting up premium UI elements</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "Poppins, sans-serif", fontSize: "18px", color: "red", flexDirection: "column", gap: "15px" }}>
//         <span>⚠️ {error}</span>
//         <button className="nav-btn special" onClick={() => window.location.reload()}>Retry Loading</button>
//       </div>
//     );
//   }

//   const { current_visit, next_reward, unlocked_rewards, all_passes, merchant, customer } = dashboardData;

//   // Filter rewards array specifically for this restaurant to ensure absolute validation accuracy
//   const filteredRewards = rewardsList.filter((reward) => {
//     const matchesSearch = reward.coupon_code.toLowerCase().includes(search.toLowerCase());
//     // Safe-fallback filter in case API returns mixed restaurant array
//     if (reward.merchant_id) {
//       return reward.merchant_id === merchantId && matchesSearch;
//     }
//     return matchesSearch;
//   });

//   const filteredPasses = all_passes.filter((item) =>
//     item.title.toLowerCase().includes(search.toLowerCase()) || 
//     item.reward.toLowerCase().includes(search.toLowerCase())
//   );

//   const filteredRestaurants = restaurantsList.filter((res) => 
//     res.business_name.toLowerCase().includes(search.toLowerCase()) ||
//     res.address.toLowerCase().includes(search.toLowerCase())
//   );

//   const maxVisitsForProgress = next_reward ? parseInt(next_reward.required_visits) : 1;
//   const progressPercentage = Math.min((parseInt(current_visit) / maxVisitsForProgress) * 100, 100);

//   return (
//     <>
//       <style>{`
//         *{
//           margin:0;
//           padding:0;
//           box-sizing:border-box;
//           font-family:'Poppins',sans-serif;
//         }

//         body{
//           background:#f4f7fb;
//         }

//         .dashboard{
//           min-height:100vh;
//           padding:35px;
//           background: linear-gradient(135deg,#fff7ed,#fff,#f3f7ff);
//         }

//         /* TOP BAR */
//         .topbar{
//           display:flex;
//           justify-content:space-between;
//           align-items:center;
//           margin-bottom:35px;
//           flex-wrap:wrap;
//           gap:20px;
//         }

//         .top-left h1{
//           font-size:38px;
//           font-weight:800;
//           color:#111827;
//         }

//         .top-left p{
//           color:#6b7280;
//           margin-top:8px;
//           font-size:15px;
//          }

//         .top-right{
//           display:flex;
//           align-items:center;
//           gap:12px;
//           flex-wrap:wrap;
//         }

//         .profile{
//           width:58px;
//           height:58px;
//           border-radius:50%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           font-size:24px;
//           font-weight:700;
//           box-shadow:0 10px 30px rgba(255,94,98,0.3);
//         }

//         .nav-btn{
//           border:none;
//           padding:14px 20px;
//           border-radius:16px;
//           background:linear-gradient(135deg,#111827,#374151);
//           color:white;
//           font-size:14px;
//           font-weight:700;
//           cursor:pointer;
//           transition:0.3s;
//         }

//         .nav-btn.special{
//           background:linear-gradient(135deg,#2563eb,#1d4ed8);
//         }

//         .nav-btn.action-trigger{
//           background:linear-gradient(135deg,#10b981,#059669);
//         }

//         .nav-btn:hover, .redeem-btn:hover, .select-shop-btn:hover{
//           transform:translateY(-3px);
//           opacity:0.95;
//           box-shadow: 0 5px 15px rgba(0,0,0,0.1);
//         }

//         /* TABS */
//         .tabs{
//           display:flex;
//           gap:15px;
//           margin-bottom:35px;
//           flex-wrap:wrap;
//         }

//         .tab-btn{
//           padding:15px 28px;
//           border:none;
//           border-radius:18px;
//           font-size:16px;
//           font-weight:700;
//           background:white;
//           color:#555;
//           cursor:pointer;
//           transition:0.3s;
//           box-shadow:0 5px 20px rgba(0,0,0,0.05);
//         }

//         .tab-btn.active{
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           transform:translateY(-2px);
//         }

//         /* TIMELINE SLIDER CARD */
//         .timeline-card{
//           background: white;
//           border-radius: 30px;
//           padding: 30px;
//           margin-bottom: 30px;
//           box-shadow: 0 10px 35px rgba(0,0,0,0.06);
//         }

//         .timeline-card h3{
//           font-size: 22px;
//           color: #111827;
//           margin-bottom: 15px;
//         }

//         .timeline-slider{
//           display: flex;
//           gap: 20px;
//           overflow-x: auto;
//           padding: 10px 5px 20px 5px;
//           scroll-behavior: smooth;
//         }

//         .timeline-slider::-webkit-scrollbar {
//           height: 8px;
//         }
//         .timeline-slider::-webkit-scrollbar-thumb {
//           background: #ff8c42;
//           border-radius: 10px;
//         }
//         .timeline-slider::-webkit-scrollbar-track {
//           background: #f3f4f6;
//         }

//         .timeline-item {
//           min-width: 240px;
//           background: #fff8f5;
//           border: 2px dashed #ffdcd0;
//           border-radius: 20px;
//           padding: 20px;
//           position: relative;
//           transition: 0.3s;
//         }

//         .timeline-item.next-up {
//           background: #fff7ed;
//           border: 2px solid #ff8c42;
//           box-shadow: 0 8px 25px rgba(255,140,66,0.15);
//         }

//         .timeline-item h5 {
//           font-size: 14px;
//           color: #ff6b35;
//           text-transform: uppercase;
//           margin-bottom: 5px;
//           font-weight: 700;
//         }

//         .timeline-item p {
//           font-size: 16px;
//           font-weight: 700;
//           color: #111827;
//         }

//         .timeline-badge {
//           display: inline-block;
//           font-size: 11px;
//           padding: 4px 10px;
//           border-radius: 20px;
//           font-weight: 700;
//           margin-top: 10px;
//         }

//         /* GRID LAYOUTS */
//         .current-visit{
//           display:grid;
//           grid-template-columns:1fr 1fr;
//           gap:30px;
//         }

//         .card{
//           background:white;
//           border-radius:30px;
//           padding:35px;
//           box-shadow:0 10px 35px rgba(0,0,0,0.06);
//         }

//         .card h3{
//           font-size:26px;
//           margin-bottom:25px;
//           color:#111827;
//         }

//         .visit-ring{
//           width:230px;
//           height:230px;
//           margin:auto;
//           border-radius:50%;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//         }

//         .ring-inner{
//           width:180px;
//           height:180px;
//           background:white;
//           border-radius:50%;
//           display:flex;
//           flex-direction:column;
//           align-items:center;
//           justify-content:center;
//         }

//         .ring-inner h1{
//           font-size:52px;
//           color:#ff6b35;
//           font-weight:800;
//         }

//         .ring-inner p{
//           color:#6b7280;
//           font-size:17px;
//           font-weight:600;
//         }

//         /* REWARD CARD */
//         .reward-card{
//           background: linear-gradient(135deg,#111827,#1f2937);
//           border-radius:28px;
//           padding:35px;
//           color:white;
//           position:relative;
//           overflow:hidden;
//           display: flex;
//           flex-direction: column;
//           justify-content: space-between;
//         }

//         .reward-card::before{
//           content:'';
//           position:absolute;
//           width:180px;
//           height:180px;
//           background:rgba(255,255,255,0.05);
//           border-radius:50%;
//           top:-50px;
//           right:-40px;
//         }

//         .reward-tag{
//           display:inline-block;
//           background:#22c55e;
//           color:white;
//           padding:8px 18px;
//           border-radius:30px;
//           font-size:14px;
//           font-weight:700;
//           margin-bottom:20px;
//           width: max-content;
//         }

//         .reward-card h2{
//           font-size:34px;
//           margin-bottom:18px;
//         }

//         .reward-card p{
//           color:#d1d5db;
//           line-height:1.7;
//         }

//         .coupon{
//           background:#ff8c42;
//           padding:16px;
//           border-radius:18px;
//           text-align:center;
//           font-size:24px;
//           font-weight:800;
//           letter-spacing:2px;
//           margin-top:25px;
//         }

//         .feedback-btn{
//           margin-top:25px;
//           width:100%;
//           height:60px;
//           border:none;
//           border-radius:18px;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           font-size:17px;
//           font-weight:700;
//           cursor:pointer;
//           transition:0.3s;
//         }

//         .feedback-btn:hover{
//           transform:translateY(-3px);
//         }

//         /* MILESTONE */
//         .milestone{
//           margin-top:30px;
//         }

//         .milestone h4{
//           margin-bottom:15px;
//           font-size:18px;
//           color:#111827;
//         }

//         .progress{
//           height:16px;
//           border-radius:30px;
//           background:#e5e7eb;
//           overflow:hidden;
//         }

//         .progress-fill{
//           height:100%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           border-radius:30px;
//         }

//         .milestone p{
//           margin-top:12px;
//           color:#6b7280;
//           font-weight:500;
//         }

//         /* REWARDS HISTORY TABLE / GRID */
//         .rewards-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
//           gap: 25px;
//         }

//         .coupon-card {
//           background: white;
//           border-radius: 24px;
//           padding: 25px;
//           box-shadow: 0 10px 30px rgba(0,0,0,0.04);
//           border: 1px solid #eef2f6;
//           display: flex;
//           flex-direction: column;
//           justify-content: space-between;
//         }

//         .coupon-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 15px;
//         }

//         .coupon-code-txt {
//           font-family: monospace;
//           background: #f3f4f6;
//           padding: 6px 12px;
//           border-radius: 8px;
//           font-weight: 700;
//           font-size: 16px;
//           color: #374151;
//         }

//         .shop-badge {
//           font-size: 12px;
//           font-weight: 700;
//           background: #eff6ff;
//           color: #2563eb;
//           padding: 6px 14px;
//           border-radius: 12px;
//           border: 1px solid #bfdbfe;
//         }

//         .redeem-btn, .select-shop-btn {
//           width: 100%;
//           padding: 14px;
//           border: none;
//           background: linear-gradient(135deg, #10b981, #059669);
//           color: white;
//           border-radius: 14px;
//           font-size: 15px;
//           font-weight: 700;
//           cursor: pointer;
//           margin-top: 15px;
//           transition: 0.2s;
//         }

//         .select-shop-btn {
//           background: linear-gradient(135deg, #2563eb, #1d4ed8);
//         }

//         /* SEARCH & GRID */
//         .search-box{
//           margin-bottom:30px;
//         }

//         .search-box input{
//           width:100%;
//           height:68px;
//           border:none;
//           border-radius:20px;
//           padding:0 25px;
//           font-size:17px;
//           background:white;
//           box-shadow:0 10px 30px rgba(0,0,0,0.05);
//           outline:none;
//         }

//         .grid{
//           display:grid;
//           grid-template-columns:repeat(auto-fit,minmax(280px,1fr));
//           gap:25px;
//         }

//         .restaurant-card{
//           background:white;
//           border-radius:28px;
//           padding:30px;
//           box-shadow:0 10px 30px rgba(0,0,0,0.05);
//           transition:0.3s;
//           cursor:pointer;
//           position:relative;
//         }

//         .restaurant-card:hover{
//           transform:translateY(-8px);
//         }

//         .restaurant-top{
//           display:flex;
//           justify-content:space-between;
//           align-items:center;
//           margin-bottom:20px;
//         }

//         .restaurant-logo{
//           width:65px;
//           height:65px;
//           border-radius:20px;
//           background:#fff4eb;
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           font-size:34px;
//         }

//         .status{
//           padding:10px 15px;
//           border-radius:30px;
//           font-size:13px;
//           font-weight:700;
//         }

//         .restaurant-card h3{
//           font-size:24px;
//           margin-bottom:12px;
//         }

//         .restaurant-card p{
//           color:#6b7280;
//           margin-bottom:18px;
//         }

//         .small-progress{
//           height:12px;
//           background:#eee;
//           border-radius:20px;
//           overflow:hidden;
//         }

//         .small-fill{
//           height:100%;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//         }

//         /* MODAL */
//         .modal-overlay{
//           position:fixed;
//           top:0;
//           left:0;
//           width:100%;
//           height:100%;
//           background:rgba(0,0,0,0.5);
//           display:flex;
//           align-items:center;
//           justify-content:center;
//           z-index:999;
//           padding:20px;
//         }

//         .modal{
//           background:white;
//           width:100%;
//           max-width:520px;
//           border-radius:35px;
//           padding:40px;
//         }

//         .rule-box {
//           background: #f9fafb;
//           border: 1px solid #e5e7eb;
//           padding: 20px;
//           border-radius: 20px;
//           margin-top: 15px;
//         }

//         .close-btn{
//           width:100%;
//           height:60px;
//           border:none;
//           border-radius:18px;
//           background:linear-gradient(135deg,#ff8c42,#ff5e62);
//           color:white;
//           font-size:18px;
//           font-weight:700;
//           cursor:pointer;
//           margin-top:15px;
//         }

//         @media(max-width:900px){
//           .dashboard{ padding:20px; }
//           .current-visit{ grid-template-columns:1fr; }
//           .top-left h1{ font-size:28px; }
//           .visit-ring{ width:190px; height:190px; }
//           .ring-inner{ width:145px; height:145px; }
//           .ring-inner h1{ font-size:42px; }
//         }
//       `}</style>

//       <div className="dashboard">

//         {/* TOPBAR */}
//         <div className="topbar">
//           <div className="top-left">
//             <h1>Smart Loyalty Dashboard</h1>
//             <p>Welcome, <b>{customer?.name || "User"}</b> | Tracking for <b>{merchant?.business_name || "Merchant"}</b></p>
//           </div>

//           <div className="top-right">
//             <button className="nav-btn special" onClick={() => setActiveTab("restaurants")}>My Restaurants 🍽️</button>
//             <button className="nav-btn action-trigger" disabled={actionLoading} onClick={handleAddVisit}>
//               {actionLoading ? "Processing..." : "+ Add Visit Check-In"}
//             </button>
//             <button className="nav-btn" onClick={() => navigate("/MyQRScreen")}>MY QR</button>
//             <button className="nav-btn" onClick={() => navigate("/feedback")}>Feedback</button>
//             <button className="nav-btn" onClick={() => navigate("/user-feed")}>My Profile</button>
//             <div className="profile">
//               {(customer?.name || "U").charAt(0).toUpperCase()}
//             </div>
//           </div>
//         </div>

//         {/* TABS CONTROLLER */}
//         <div className="tabs">
//           <button
//             className={`tab-btn ${activeTab === "current" ? "active" : ""}`}
//             onClick={() => setActiveTab("current")}
//           >
//             Current Visit
//           </button>
//           <button
//             className={`tab-btn ${activeTab === "passes" ? "active" : ""}`}
//             onClick={() => setActiveTab("passes")}
//           >
//             My All Passes ({all_passes?.length || 0})
//           </button>
//           <button
//             className={`tab-btn ${activeTab === "my_rewards" ? "active" : ""}`}
//             onClick={() => setActiveTab("my_rewards")}
//           >
//             My Unlocked Rewards ({filteredRewards?.length || 0})
//           </button>
//           <button
//             className={`tab-btn ${activeTab === "restaurants" ? "active" : ""}`}
//             onClick={() => setActiveTab("restaurants")}
//           >
//             All Restaurants ({restaurantsList?.length || 0})
//           </button>
//         </div>

//         {/* 1. CURRENT VISIT TAB */}
//         {activeTab === "current" && (
//           <div>
//             <div className="timeline-card">
//               <h3>🎁 Loyalty Passes Roadmap</h3>
//               <div className="timeline-slider">
//                 {all_passes?.map((pass) => {
//                   const isNextTarget = next_reward && next_reward.pass_id === pass.id;
//                   const isCompleted = parseInt(current_visit) >= parseInt(pass.total_visits);

//                   return (
//                     <div key={pass.id} className={`timeline-item ${isNextTarget ? "next-up" : ""}`}>
//                       <h5>🎯 On {pass.total_visits} Visits</h5>
//                       <p>{pass.reward}</p>
//                       {isCompleted ? (
//                         <span className="timeline-badge" style={{ background: "#ecfdf5", color: "#059669" }}>Unlocked 🎉</span>
//                       ) : isNextTarget ? (
//                         <span className="timeline-badge" style={{ background: "#ffea2c", color: "#111827" }}>Next Target 🎯</span>
//                       ) : (
//                         <span className="timeline-badge" style={{ background: "#e5e7eb", color: "#6b7280" }}>Locked 🔒</span>
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>

//             <div className="current-visit">
//               <div className="card">
//                 <h3>Your Current Visit Progress</h3>
//                 <div 
//                   className="visit-ring"
//                   style={{ background: `conic-gradient(#ff8c42 0% ${progressPercentage}%, #e5e7eb ${progressPercentage}% 100%)` }}
//                 >
//                   <div className="ring-inner">
//                     <h1>{current_visit}</h1>
//                     <p>Visits Done</p>
//                   </div>
//                 </div>

//                 {next_reward ? (
//                   <div className="milestone">
//                     <h4>Next Milestone: {next_reward.title}</h4>
//                     <div className="progress">
//                       <div className="progress-fill" style={{ width: `${progressPercentage}%` }}></div>
//                     </div>
//                     <p>Only <b>{next_reward.remaining_visits}</b> visit left to unlock reward worth <b>₹{next_reward.reward}</b> 🎉</p>
//                   </div>
//                 ) : (
//                   <div className="milestone">
//                     <p style={{ color: "#10b981", fontWeight: "700" }}>Woohoo! All loyalty targets reached! 🏁</p>
//                   </div>
//                 )}
//               </div>

//               <div className="reward-card">
//                 <div>
//                   {unlocked_rewards && unlocked_rewards.length > 0 ? (
//                     <>
//                       <div className="reward-tag">Reward Ready!</div>
//                       <h2>{unlocked_rewards[0].title || "Discount Coupon"}</h2>
//                       <p>Value/Reward: <b>₹{unlocked_rewards[0].reward}</b></p>
//                       <div className="coupon" style={{ fontSize: "14px", letterSpacing: "normal" }}> 
//                         Go to "My Unlocked Rewards" tab to redeem 
//                       </div>
//                     </>
//                   ) : (
//                     <>
//                       <div className="reward-tag" style={{ background: "#6b7280" }}>No Instant Claims</div>
//                       <h2>Keep Visiting!</h2>
//                       <p>Once your target completes, your active coupon codes will unlock instantly right here.</p>
//                       <div className="coupon" style={{ background: "#374151", letterSpacing: "normal", fontSize: "16px" }}>
//                         LOCKED 🔒
//                       </div>
//                     </>
//                   )}
//                 </div>
//                 <button className="feedback-btn" onClick={() => navigate("/feedback")}>Give Feedback →</button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* 2. ALL PASSES TAB */}
//         {activeTab === "passes" && (
//           <div>
//             <div className="search-box">
//               <input type="text" placeholder="Search specific rules or passes..." value={search} onChange={(e) => setSearch(e.target.value)} />
//             </div>
//             <div className="grid">
//               {filteredPasses.map((item) => {
//                 const itemProgress = Math.min((parseInt(current_visit) / parseInt(item.total_visits)) * 100, 100);
//                 const isItemCompleted = parseInt(current_visit) >= parseInt(item.total_visits);

//                 return (
//                   <div key={item.id} className="restaurant-card" onClick={() => setSelectedPass(item)}>
//                     <div className="restaurant-top">
//                       <div className="restaurant-logo">🎫</div>
//                       <div className="status" style={{ backgroundColor: isItemCompleted ? "#ecfdf5" : "#fef3c7", color: isItemCompleted ? "#059669" : "#d97706" }}>
//                         {isItemCompleted ? "Completed" : "In Progress"}
//                       </div>
//                     </div>
//                     <h3>{item.title}</h3>
//                     <p>Reward: <b>{item.reward}</b></p>
//                     <p style={{ fontSize: "14px" }}>Required Goal: {item.total_visits} Visits</p>
//                     <div className="small-progress">
//                       <div className="small-fill" style={{ width: `${itemProgress}%` }}></div>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         )}
// {/* 3. MY UNLOCKED REWARDS TAB (FILTERED WITH AGENCY-GRADE DESIGN) */}
// {activeTab === "my_rewards" && (
//   <div style={{ fontFamily: "Inter, system-ui, sans-serif" }}>
    
//     {/* Tab Header Section */}
//     <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", flexWrap: "wrap", gap: "15px" }}>
//       <div>
//         <h2 style={{ color: "#111827", fontSize: "28px", fontWeight: "800", letterSpacing: "-0.5px", margin: 0 }}>
//           Available Rewards 🎁
//         </h2>
//         <p style={{ color: "#6b7280", fontSize: "14px", marginTop: "4px", margin: 0 }}>
//           Redeem unlocked vouchers at <b>{merchant?.business_name || "Active Shop"}</b>
//         </p>
//       </div>
//       <span style={{ fontSize: "12px", fontWeight: "700", background: "#f0fdf4", color: "#15803d", padding: "8px 16px", borderRadius: "100px", border: "1px solid #bbf7d0", letterSpacing: "0.5px", uppercase: "true" }}>
//         ● LIVE VERIFIED SHOP
//       </span>
//     </div>

//     {filteredRewards.length === 0 ? (
//       <div style={{ padding: "60px 40px", background: "#ffffff", borderRadius: "24px", textAlign: "center", border: "1px dashed #e5e7eb" }}>
//         <div style={{ fontSize: "40px", marginBottom: "15px" }}>🎫</div>
//         <h3 style={{ fontSize: "18px", color: "#111827", fontWeight: "700", marginBottom: "6px" }}>No Unlocked Vouchers</h3>
//         <p style={{ color: "#6b7280", fontSize: "14px", maxWidth: "400px", margin: "0 auto", lineHeight: "1.5" }}>
//           No active coupons found for this merchant. Switch your active restaurant from the <b>"My Restaurants"</b> tab to check others.
//         </p>
//       </div>
//     ) : (
//       <div className="rewards-grid" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))", gap: "30px" }}>
//         {filteredRewards.map((rewardItem) => {
//           const isUsed = rewardItem.status === "used";
          
//           // CRUCIAL UPDATE: Structured data passing Customer ID & Coupon Code perfectly together for scanner
//           const qrPayload = JSON.stringify({
//             action: "redeem_reward",
//             coupon_code: rewardItem.coupon_code,
//             customer_id: customerId, // Customer ID injected
//             merchant_id: merchantId,
//             reward_type: rewardItem.reward // "50% off on bill" etc.
//           });

//           // Check if reward value is just a number or a text description
//           const isNumericReward = !isNaN(rewardItem.reward);

//           return (
//             <div 
//               key={rewardItem.id} 
//               className="coupon-card" 
//               style={{ 
//                 background: "#ffffff", 
//                 borderRadius: "24px", 
//                 boxShadow: "0 20px 40px rgba(0, 0, 0, 0.03)", 
//                 border: "1px solid #eef2f6", 
//                 position: "relative",
//                 overflow: "hidden",
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "space-between",
//                 transition: "transform 0.2s ease, box-shadow 0.2s ease"
//               }}
//             >
              
//               {/* Top Branding Half */}
//               <div style={{ padding: "24px 24px 20px 24px" }}>
//                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
//                   <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                     <span style={{ fontSize: "12px", fontWeight: "700", background: "#eff6ff", color: "#2563eb", padding: "6px 14px", borderRadius: "12px", border: "1px solid #bfdbfe" }}>
//                       🏪 {merchant?.business_name || "Partner Store"}
//                     </span>
//                   </div>
//                   <span style={{ 
//                     padding: "6px 14px",
//                     borderRadius: "100px",
//                     fontSize: "11px",
//                     fontWeight: "800",
//                     letterSpacing: "0.5px",
//                     backgroundColor: isUsed ? "#f3f4f6" : "#dcfce7", 
//                     color: isUsed ? "#6b7280" : "#15803d" 
//                   }}>
//                     {rewardItem.status.toUpperCase()}
//                   </span>
//                 </div>
                
//                 <p style={{ fontSize: "13px", color: "#6b7280", margin: "0 0 4px 0", textTransform: "uppercase", fontWeight: "600", letterSpacing: "0.5px" }}>
//                   Cashback / Value
//                 </p>
                
//                 {/* Clean dynamic adjustment for Text offers like "50% off on bill" or "Free Coffee" */}
//                 <h3 style={{ fontSize: isNumericReward ? "32px" : "22px", color: "#111827", margin: "0 0 6px 0", fontWeight: "900", display: "flex", alignItems: isNumericReward ? "baseline" : "center", gap: "4px", lineHeight: "1.3" }}>
//                   {isNumericReward && <span style={{ fontSize: "20px", fontWeight: "700" }}>₹</span>}
//                   {rewardItem.reward}
//                 </h3>
                
//                 <p style={{ fontSize: "12px", color: "#9ca3af", margin: 0 }}>Issued: {rewardItem.created_at}</p>
//               </div>

//               {/* PREMIUM TICKET PUNCH DIVIDER CUTS */}
//               <div style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 12px" }}>
//                 {/* Left Side Hole */}
//                 <div style={{ position: "absolute", left: "-20px", width: "16px", height: "16px", borderRadius: "50%", background: "#f8fafc", borderRight: "1px solid #eef2f6", zIndex: 2 }}></div>
//                 {/* Dashed Line */}
//                 <div style={{ width: "100%", borderTop: "2px dashed #e2e8f0", height: "0" }}></div>
//                 {/* Right Side Hole */}
//                 <div style={{ position: "absolute", right: "-20px", width: "16px", height: "16px", borderRadius: "50%", background: "#f8fafc", borderLeft: "1px solid #eef2f6", zIndex: 2 }}></div>
//               </div>

//               {/* Bottom Interactive Half */}
//               <div style={{ padding: "20px 24px 24px 24px", background: "#fafafa", borderBottomLeftRadius: "24px", borderBottomRightRadius: "24px" }}>
                
//                 {/* QR Generation Layer */}
//                 {!isUsed ? (
//                   <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "20px" }}>
//                     <div style={{ 
//                       background: "#ffffff", 
//                       padding: "16px", 
//                       borderRadius: "20px", 
//                       boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
//                       border: "1px solid #e2e8f0",
//                       display: "inline-block",
//                       marginBottom: "12px"
//                     }}>
//                       <QRCode 
//                         value={qrPayload}
//                         size={140}
//                         level="H"
//                         includeMargin={false}
//                       />
//                     </div>
//                     <p style={{ fontSize: "12px", color: "#4b5563", fontWeight: "600", margin: 0, display: "flex", alignItems: "center", gap: "6px" }}>
//                       <span>⚡</span> Present QR code to partner at checkout
//                     </p>
//                   </div>
//                 ) : (
//                   <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "180px", marginBottom: "20px" }}>
//                     <div style={{ fontSize: "32px", marginBottom: "10px", opacity: "0.4" }}>🔒</div>
//                     <p style={{ fontSize: "14px", color: "#9ca3af", fontWeight: "700", margin: 0 }}>
//                       Voucher Cleared & Spent
//                     </p>
//                   </div>
//                 )}

//                 {/* Technical Code & Fallback CTA */}
//                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: "#ffffff", padding: "12px 16px", borderRadius: "14px", border: "1px solid #e5e7eb" }}>
//                   <span style={{ fontSize: "12px", color: "#6b7280", fontWeight: "600" }}>Voucher Pin:</span>
//                   <span style={{ fontFamily: "'Courier New', Courier, monospace", fontWeight: "800", fontSize: "16px", color: "#111827", letterSpacing: "1px" }}>
//                     {rewardItem.coupon_code}
//                   </span>
//                 </div>
                
//                 {!isUsed && (
//                   <button 
//                     disabled={actionLoading}
//                     onClick={() => handleRedeemReward(rewardItem.coupon_code)}
//                     style={{ 
//                       width: "100%", 
//                       padding: "15px", 
//                       border: "none", 
//                       background: "linear-gradient(135deg, #111827 0%, #1f2937 100%)", 
//                       color: "#ffffff", 
//                       borderRadius: "14px", 
//                       fontSize: "14px", 
//                       fontWeight: "700", 
//                       cursor: "pointer", 
//                       marginTop: "16px", 
//                       boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//                       letterSpacing: "0.3px"
//                     }}
//                   >
//                     {actionLoading ? "Processing..." : "Verify Manually (Self-Redeem)"}
//                   </button>
//                 )}
//               </div>

//             </div>
//           );
//         })}
//       </div>
//     )}
//   </div>
// )}
//         {/* 3. MY UNLOCKED REWARDS TAB (FILTERED DYNAMICALLY ACCORDING TO SELECTED RESTAURANT) */}
//         {/* {activeTab === "my_rewards" && (
//           <div>
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
//               <h2 style={{ color: "#111827" }}>Rewards for {merchant?.business_name || "Current Restaurant"} 🎁</h2>
//               <span className="shop-badge">Filtered Active Shop</span>
//             </div>

//             {filteredRewards.length === 0 ? (
//               <div style={{ padding: "40px", background: "white", borderRadius: "24px", textAlign: "center", boxShadow: "0 5px 20px rgba(0,0,0,0.02)" }}>
//                 <p style={{ color: "#6b7280", fontSize: "16px" }}>No unlocked coupons found for <b>{merchant?.business_name}</b>. Change the restaurant from "My Restaurants" tab to view others! ✨</p>
//               </div>
//             ) : (
//               <div className="rewards-grid">
//                 {filteredRewards.map((rewardItem) => (
//                   <div key={rewardItem.id} className="coupon-card">
//                     <div>
//                       <div className="coupon-header">
//                         <span className="shop-badge">📍 {merchant?.business_name || "Verified Merchant"}</span>
//                         <span className="status" style={{ 
//                           backgroundColor: rewardItem.status === "used" ? "#f3f4f6" : "#ecfdf5", 
//                           color: rewardItem.status === "used" ? "#6b7280" : "#059669" 
//                         }}>
//                           {rewardItem.status.toUpperCase()}
//                         </span>
//                       </div>
//                       <h3 style={{ fontSize: "20px", color: "#111827", marginBottom: "8px" }}>Reward Worth: ₹{rewardItem.reward}</h3>
//                       <p style={{ fontSize: "13px", color: "#9ca3af", marginBottom: "15px" }}>Earned on: {rewardItem.created_at}</p>
//                     </div>
//                     <div>
//                       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                         <span style={{ fontSize: "14px", color: "#4b5563" }}>Shopkeeper Code:</span>
//                         <span className="coupon-code-txt">{rewardItem.coupon_code}</span>
//                       </div>
//                       {rewardItem.status !== "used" && (
//                         <button 
//                           className="redeem-btn" 
//                           disabled={actionLoading}
//                           onClick={() => handleRedeemReward(rewardItem.coupon_code)}
//                         >
//                           {actionLoading ? "Processing..." : "Redeem At Counter 🔓"}
//                         </button>
//                       )}
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         )} */}

//         {/* 4. ALL CONNECTED RESTAURANTS LIST */}
//         {activeTab === "restaurants" && (
//           <div>
//             <div className="search-box">
//               <input type="text" placeholder="Search restaurant by name or location..." value={search} onChange={(e) => setSearch(e.target.value)} />
//             </div>

//             <div className="grid">
//               {filteredRestaurants.map((res) => {
//                 const isCurrentlySelected = res.merchant_id === merchantId;
//                 return (
//                   <div key={res.merchant_id} className="restaurant-card" style={{ border: isCurrentlySelected ? "2px solid #ff8c42" : "1px solid transparent" }}>
//                     <div className="restaurant-top">
//                       <div className="restaurant-logo">🍽️</div>
//                       <div className="status" style={{ backgroundColor: isCurrentlySelected ? "#ffebdb" : "#f3f4f6", color: isCurrentlySelected ? "#ff6b35" : "#4b5563" }}>
//                         {isCurrentlySelected ? "Active Tracking" : "Connected Shop"}
//                       </div>
//                     </div>
//                     <h3>{res.business_name}</h3>
//                     <p style={{ textTransform: "capitalize", fontSize: "14px", color: "#9ca3af" }}>Type: {res.business_type} | Owner: {res.owner_name}</p>
//                     <p>📍 <b>{res.address}</b></p>
                    
//                     <div style={{ background: "#f9fafb", padding: "12px", borderRadius: "12px", textAlign: "center" }}>
//                       <span style={{ fontSize: "15px", fontWeight: "700", color: "#ff6b35" }}>{res.visits} Total Visits Done</span>
//                     </div>

//                     {!isCurrentlySelected && (
//                       <button className="select-shop-btn" onClick={() => handleSelectRestaurant(res.merchant_id)}>
//                         Switch to Dashboard View 🔄
//                       </button>
//                     )}
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         )}

//         {/* DETAILS MODAL FOR PASSES */}
//         {selectedPass && (
//           <div className="modal-overlay">
//             <div className="modal">
//               <h2>🎫 {selectedPass.title}</h2>
//               <p style={{ color: "#6b7280", margin: "15px 0" }}>Loyalty Rule Details & Reward Tracking</p>
//               <div className="rule-box">
//                 <h3>Reward: {selectedPass.reward}</h3>
//                 <p style={{ marginTop: "10px" }}>Required Total Visits: <b>{selectedPass.total_visits}</b></p>
//                 <p>Your Current Visits at this Restaurant: <b>{current_visit}</b></p>
//               </div>
//               <button className="close-btn" onClick={() => navigate("/feedback")}>Give Feedback</button>
//               <button className="close-btn" style={{ background: "#374151" }} onClick={() => setSelectedPass(null)}>Close Window</button>
//             </div>
//           </div>
//         )}

//       </div>
//     </>
//   );
// }


// pls scan  qr of shop pls  when it sacn then it have  tw0 ids  when  again he come then  i walill 
// get list of resturnt of this customers 
// import React, { useRef,useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import ActiveOverview from "./ActiveOverview";
// import RewardsManager from "./RewardsManager";
// import { Html5QrcodeScanner } from "html5-qrcode";
// export default function VisitDashboard() {
//   const navigate = useNavigate();

//   const [activeTab, setActiveTab] = useState("current");
//   const [search, setSearch] = useState("");
//   const [selectedPass, setSelectedPass] = useState(null);
  
//   // const [customerId, setCustomerId] = useState("CMVC497B3A688");
//   // const [merchantId, setMerchantId] = useState("CMV9A117EAC");
// const [customerId, setCustomerId] = useState("");
// const [merchantId, setMerchantId] = useState("");
// const [openScanner, setOpenScanner] = useState(false);

// const scannerRef = useRef(null);

// useEffect(() => {

//     if (!openScanner) return;

//     const scanner = new Html5QrcodeScanner(
//         "reader",
//         {
//             fps: 10,
//             qrbox: 250,
//         },
//         false
//     );

//     scanner.render(

//         (decodedText) => {

//             console.log(decodedText);

//             try {

//                 const data = JSON.parse(decodedText);

//                 if (data.merchant_id) {

//                     localStorage.setItem(
//                         "merchantId",
//                         data.merchant_id
//                     );

//                     alert("Merchant Connected");

//                     setOpenScanner(false);

//                     scanner.clear();

//                 } else {

//                     alert("Invalid QR");

//                 }

//             } catch {

//                 alert("Invalid QR Code");

//             }

//         },

//         () => {}

//     );

//     scannerRef.current = scanner;

//     return () => {

//         scanner.clear().catch(() => {});

//     };

// }, [openScanner]);
// useEffect(() => {
//   const userData = JSON.parse(localStorage.getItem("userData") || "{}");

//   if (userData?.merchant) {
//     setCustomerId(userData.merchant.user_id);
//     setMerchantId(userData.merchant.user_id);
//   }
// }, []);
//   const [dashboardData, setDashboardData] = useState(null);
//   const [rewardsList, setRewardsList] = useState([]); 
//   const [restaurantsList, setRestaurantsList] = useState([]);
  
//   const [loading, setLoading] = useState(true);
//   const [actionLoading, setActionLoading] = useState(false);
//   const [error, setError] = useState(null);

 

// const [user,setUser]=useState(null);

// useEffect(()=>{

//     const login=localStorage.getItem("isLoggedIn");

//     const userData=localStorage.getItem("userData");

//     if(login!=="true"){

//         navigate("/");

//         return;

//     }

//     if(userData){

//         setUser(JSON.parse(userData));

//     }

// },[]);
//   const cleanAndParseJson = (text) => {
//     try {
//       const cleanString = text.replace("DATABASE CONNECTED", "").trim();
//       return JSON.parse(cleanString);
//     } catch (e) {
//       console.error("JSON Parsing failed: ", text);
//       throw new Error("Invalid server response format.");
//     }
//   };

//   const fetchDashboardData = async (mId = merchantId) => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", customerId);
//       formdata.append("merchant_id", mId);

//       const response = await fetch("https://countmyvisit.com/Apis/customer_dashboard.php", {
//         method: "POST", body: formdata, redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) setDashboardData(data);
//       else setError("Failed to fetch dashboard data.");
//     } catch (err) {
//       setError("Something went wrong while fetching dashboard data.");
//     }
//   };

//   const fetchRewardsList = async (mId = merchantId) => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", customerId);
//       formdata.append("merchant_id", mId);
//       const response = await fetch("https://countmyvisit.com/Apis/my_rewards.php", {
//         method: "POST", body: formdata, redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) setRewardsList(data.rewards || []);
//     } catch (err) {
//       console.error("Error fetching rewards:", err);
//     }
//   };

//   const fetchRestaurantsList = async () => {
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", customerId);
//       const response = await fetch("https://countmyvisit.com/Apis/my_restaurants.php", {
//         method: "POST", body: formdata, redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) setRestaurantsList(data.restaurants || []);
//     } catch (err) {
//       console.error("Error fetching restaurants:", err);
//     }
//   };

//   useEffect(() => {
//     async function loadAllInitialData() {
//       setLoading(true);
//       setError(null);
//       await fetchDashboardData(merchantId);
//       await fetchRewardsList(merchantId);
//       await fetchRestaurantsList();
//       setLoading(false);
//     }
//     loadAllInitialData();
//   }, [merchantId]);

//   const handleSelectRestaurant = (mId) => {
//     setMerchantId(mId);
//     setActiveTab("current");
//   };

//   const handleAddVisit = async () => {
//     setActionLoading(true);
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", customerId);
//       formdata.append("merchant_id", merchantId);
//       const response = await fetch("https://countmyvisit.com/Apis/add_visit.php", {
//         method: "POST", body: formdata, redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         alert(`Visit marked successfully! Current visits: ${data.current_visit}`);
//         await fetchDashboardData(merchantId);
//         await fetchRewardsList(merchantId);
//         await fetchRestaurantsList();
//       } else {
//         alert(data.message || "Unable to register visit.");
//       }
//     } catch (err) {
//       alert("Error executing visit update routing.");
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   const handleRedeemReward = async (couponCode) => {
//     if (!window.confirm(`Redeem voucher: ${couponCode}?`)) return;
//     setActionLoading(true);
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", customerId);
//       formdata.append("merchant_id", merchantId);
//       formdata.append("coupon_code", couponCode);

//       const response = await fetch("https://countmyvisit.com/Apis/redeem_reward.php", {
//         method: "POST", body: formdata, redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         alert(data.message || "Reward Redeemed Successfully! 🎁");
//         await fetchDashboardData(merchantId);
//         await fetchRewardsList(merchantId);
//       } else {
//         alert(data.message || "Failed point validation.");
//       }
//     } catch (err) {
//       alert("Network exception occurred.");
//     } finally {
//       setActionLoading(false);
//     }
//   };
//  const  handleLogout =()=>{

//     localStorage.removeItem("user");

//     localStorage.removeItem("isLoggedIn");

//     navigate("/WelcomeGateway",{
//         replace:true
//     });

// }
//   if (loading) {
//     return (
//       <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "Poppins, sans-serif", fontSize: "20px", fontWeight: "600", color: "#ff8c42" }}>
//         <div style={{ textAlign: "center" }}>
//           <div>🔄 Loading Dashboard Assets...</div>
//           <p style={{ fontSize: "14px", color: "#6b7280", marginTop: "8px", fontWeight: "400" }}>Setting up premium UI elements</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontFamily: "Poppins, sans-serif", fontSize: "18px", color: "red", flexDirection: "column", gap: "15px" }}>
//         <span>⚠️ {error}</span>
//         <button className="nav-btn special" onClick={() => window.location.reload()}>Retry Loading</button>
//       </div>
//     );
//   }

//   const { current_visit, next_reward, all_passes, merchant, customer } = dashboardData;

//   const filteredRewards = rewardsList.filter((reward) => {
//     const matchesSearch = reward.coupon_code.toLowerCase().includes(search.toLowerCase());
//     return reward.merchant_id ? (reward.merchant_id === merchantId && matchesSearch) : matchesSearch;
//   });

//   const filteredPasses = all_passes.filter((item) =>
//     item.title.toLowerCase().includes(search.toLowerCase()) || 
//     item.reward.toLowerCase().includes(search.toLowerCase())
//   );

//   const filteredRestaurants = restaurantsList.filter((res) => 
//     res.business_name.toLowerCase().includes(search.toLowerCase()) || res.address.toLowerCase().includes(search.toLowerCase())
//   );

//   const maxVisitsForProgress = next_reward ? parseInt(next_reward.required_visits) : 1;
//   const progressPercentage = Math.min((parseInt(current_visit) / maxVisitsForProgress) * 100, 100);

//   return (
//     <>
//       <style>{`
//         *{ margin:0; padding:0; box-sizing:border-box; font-family:'Poppins',sans-serif; }
//         @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
//         body{ background:#f4f7fb; }
//         .dashboard{ min-height:100vh; padding:35px; background: linear-gradient(135deg,#fff7ed,#fff,#f3f7ff); }
//         .topbar{ display:flex; justify-content:space-between; align-items:center; margin-bottom:35px; flex-wrap:wrap; gap:20px; }
//         .top-left h1{ font-size:38px; font-weight:800; color:#111827; }
//         .top-left p{ color:#6b7280; margin-top:8px; font-size:15px; }
//         .top-right{ display:flex; align-items:center; gap:12px; flex-wrap:wrap; }
//         .profile{ width:58px; height:58px; border-radius:50%; background:linear-gradient(135deg,#ff8c42,#ff5e62); color:white; display:flex; align-items:center; justify-content:center; font-size:24px; font-weight:700; box-shadow:0 10px 30px rgba(255,94,98,0.3); }
//         .nav-btn{ border:none; padding:14px 20px; border-radius:16px; background:linear-gradient(135deg,#111827,#374151); color:white; font-size:14px; font-weight:700; cursor:pointer; transition:0.3s; }
//         .nav-btn.special{ background:linear-gradient(135deg,#2563eb,#1d4ed8); }
//         .nav-btn.action-trigger{ background:linear-gradient(135deg,#10b981,#059669); }
//         .nav-btn:hover, .redeem-btn:hover, .select-shop-btn:hover{ transform:translateY(-3px); opacity:0.95; box-shadow: 0 5px 15px rgba(0,0,0,0.1); }
//         .tabs{ display:flex; gap:15px; margin-bottom:35px; flex-wrap:wrap; }
//         .tab-btn{ padding:15px 28px; border:none; border-radius:18px; font-size:16px; font-weight:700; background:white; color:#555; cursor:pointer; transition:0.3s; box-shadow:0 5px 20px rgba(0,0,0,0.05); }
//         .tab-btn.active{ background:linear-gradient(135deg,#ff8c42,#ff5e62); color:white; transform:translateY(-2px); }
//         .timeline-card{ background: white; border-radius: 30px; padding: 30px; margin-bottom: 30px; box-shadow: 0 10px 35px rgba(0,0,0,0.06); }
//         .timeline-card h3{ font-size: 22px; color: #111827; margin-bottom: 15px; }
//         .timeline-slider{ display: flex; gap: 20px; overflow-x: auto; padding: 10px 5px 20px 5px; scroll-behavior: smooth; }
//         .timeline-slider::-webkit-scrollbar { height: 8px; }
//         .timeline-slider::-webkit-scrollbar-thumb { background: #ff8c42; border-radius: 10px; }
//         .timeline-slider::-webkit-scrollbar-track { background: #f3f4f6; }
//         .timeline-item { min-width: 240px; background: #fff8f5; border: 2px dashed #ffdcd0; border-radius: 20px; padding: 20px; position: relative; transition: 0.3s; }
//         .timeline-item.next-up { background: #fff7ed; border: 2px solid #ff8c42; box-shadow: 0 8px 25px rgba(255,140,66,0.15); }
//         .timeline-item h5 { font-size: 14px; color: #ff6b35; text-transform: uppercase; margin-bottom: 5px; font-weight: 700; }
//         .timeline-item p { font-size: 16px; font-weight: 700; color: #111827; }
//         .timeline-badge { display: inline-block; font-size: 11px; padding: 4px 10px; border-radius: 20px; font-weight: 700; margin-top: 10px; }
//         .current-visit{ display:grid; grid-template-columns:1fr 1fr; gap:30px; }
//         .card{ background:white; border-radius:30px; padding:35px; box-shadow:0 10px 35px rgba(0,0,0,0.06); }
//         .card h3{ font-size:26px; margin-bottom:25px; color:#111827; }
//         .visit-ring{ width:230px; height:230px; margin:auto; border-radius:50%; display:flex; align-items:center; justify-content:center; }
//         .ring-inner{ width:180px; height:180px; background:white; border-radius:50%; display:flex; flex-direction:column; align-items:center; justify-content:center; }
//         .ring-inner h1{ font-size:52px; color:#ff6b35; font-weight:800; }
//         .ring-inner p{ color:#6b7280; font-size:17px; font-weight:600; }
//         .reward-card{ background: linear-gradient(135deg,#111827,#1f2937); border-radius:28px; padding:35px; color:white; position:relative; overflow:hidden; display: flex; flex-direction: column; justify-content: space-between; }
//         .reward-tag{ display:inline-block; background:#22c55e; color:white; padding:8px 18px; border-radius:30px; font-size:14px; font-weight:700; margin-bottom:20px; width: max-content; }
//         .reward-card h2{ font-size:34px; margin-bottom:18px; }
//         .reward-card p{ color:#d1d5db; line-height:1.7; }
//         .coupon{ background:#ff8c42; padding:16px; border-radius:18px; text-align:center; font-size:24px; font-weight:800; letter-spacing:2px; margin-top:25px; }
//         .feedback-btn{ margin-top:25px; width:100%; height:60px; border:none; border-radius:18px; background:linear-gradient(135deg,#ff8c42,#ff5e62); color:white; font-size:17px; font-weight:700; cursor:pointer; transition:0.3s; }
//         .milestone{ margin-top:30px; }
//         .milestone h4{ margin-bottom:15px; font-size:18px; color:#111827; }
//         .progress{ height:16px; border-radius:30px; background:#e5e7eb; overflow:hidden; }
//         .progress-fill{ height:100%; background:linear-gradient(135deg,#ff8c42,#ff5e62); border-radius:30px; }
//         .milestone p{ margin-top:12px; color:#6b7280; font-weight:500; }
//         .coupon-card { background: white; border-radius: 24px; padding: 25px; box-shadow: 0 10px 30px rgba(0,0,0,0.04); border: 1px solid #eef2f6; display: flex; flex-direction: column; justify-content: space-between; }
//         .coupon-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px; }
//         .coupon-code-txt { font-family: monospace; background: #f3f4f6; padding: 6px 12px; border-radius: 8px; font-weight: 700; font-size: 16px; color: #374151; }
//         .shop-badge { font-size: 12px; font-weight: 700; background: #eff6ff; color: #2563eb; padding: 6px 14px; border-radius: 12px; border: 1px solid #bfdbfe; }
//         .redeem-btn, .select-shop-btn { width: 100%; padding: 14px; border: none; background: linear-gradient(135deg, #10b981, #059669); color: white; border-radius: 14px; font-size: 15px; font-weight: 700; cursor: pointer; margin-top: 15px; transition: 0.2s; }
//         .select-shop-btn { background: linear-gradient(135deg, #2563eb, #1d4ed8); }
//         .search-box{ margin-bottom:30px; }
//         .search-box input{ width:100%; height:68px; border:none; border-radius:20px; padding:0 25px; font-size:17px; background:white; box-shadow:0 10px 30px rgba(0,0,0,0.05); outline:none; }
//         .grid{ display:grid; grid-template-columns:repeat(auto-fit,minmax(280px,1fr)); gap:25px; }
//         .restaurant-card{ background:white; border-radius:28px; padding:30px; box-shadow:0 10px 30px rgba(0,0,0,0.05); transition:0.3s; cursor:pointer; position:relative; }
//         .restaurant-card:hover{ transform:translateY(-8px); }
//         .restaurant-top{ display:flex; justify-content:space-between; align-items:center; margin-bottom:20px; }
//         .restaurant-logo{ width:65px; height:65px; border-radius:20px; background:#fff4eb; display:flex; align-items:center; justify-content:center; font-size:34px; }
//         .status{ padding:10px 15px; border-radius:30px; font-size:13px; font-weight:700; }
//         .restaurant-card h3{ font-size:24px; margin-bottom:12px; }
//         .restaurant-card p{ color:#6b7280; margin-bottom:18px; }

//         .scanner-popup{

// position:fixed;
// top:0;
// left:0;
// right:0;
// bottom:0;
// background:rgba(0,0,0,.75);
// display:flex;
// justify-content:center;
// align-items:center;
// z-index:999999;

// }

// .scanner-box{

// width:95%;
// max-width:420px;
// background:#fff;
// padding:20px;
// border-radius:20px;
// text-align:center;

// }

// .close-btn{

// margin-top:15px;
// padding:12px 30px;
// background:#ff4d4d;
// border:none;
// color:#fff;
// border-radius:10px;
// cursor:pointer;

// }

// #reader{

// width:100%;

// }
//         .small-progress{ height:12px; background:#eee; border-radius:20px; overflow:hidden; }
//         .small-fill{ height:100%; background:linear-gradient(135deg,#ff8c42,#ff5e62); }
//         .modal-overlay{ position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5); display:flex; align-items:center; justify-content:center; z-index:999; padding:20px; }
//         .modal{ background:white; width:100%; max-width:520px; border-radius:35px; padding:40px; }
//         .rule-box { background: #f9fafb; border: 1px solid #e5e7eb; padding: 20px; border-radius: 20px; margin-top: 15px; }
//         .close-btn{ width:100%; height:60px; border:none; border-radius:18px; background:linear-gradient(135deg,#ff8c42,#ff5e62); color:white; font-size:18px; font-weight:700; cursor:pointer; margin-top:15px; }
//         @media(max-width:900px){ .dashboard{ padding:20px; } .current-visit{ grid-template-columns:1fr; } .top-left h1{ font-size:28px; } .visit-ring{ width:190px; height:190px; } .ring-inner{ width:145px; height:145px; } .ring-inner h1{ font-size:42px; } }
//       `}</style>
//   <div className="dashboard">
//         {/* Navigation Head */}
//         <div className="topbar">
//           <div className="top-left">
//             <h1>Count My Visit Dashboard</h1>
//             <p>Welcome, <b>{customer?.name || "User"}</b> | Tracking for <b>{merchant?.business_name || "Merchant"}</b></p>
//           </div>
//           <div className="top-right">
//             <button className="nav-btn special" onClick={() => setActiveTab("restaurants")}>My Restaurants 🍽️</button>
//             <button className="nav-btn" onClick={() => navigate("/MyQRScreen")}>MY QR</button>
//              <button className="nav-btn"   onClick={() => setOpenScanner(true)} >Scan Shop QR</button>
 
//            {
// openScanner && (

// <div className="scanner-popup">

//     <div className="scanner-box">

//         <h3>Scan Shop QR</h3>

//         <div id="reader"></div>

//         <button
//             className="close-btn"
//             onClick={() => {

//                 if (scannerRef.current) {

//                     scannerRef.current.clear();

//                 }

//                 setOpenScanner(false);

//             }}
//         >
//             Close
//         </button>

//     </div>

// </div>

// )}
//              <button className="nav-btn" onClick={handleLogout} >Logout</button>
             

      
//             <div className="profile">{(customer?.name || "U").charAt(0).toUpperCase()}</div>
//           </div>
//         </div>

//         {/* Tab Controllers */}
//         <div className="tabs">
//           {["current", "passes", "my_rewards", "restaurants"].map((tab) => (
//             <button
//               key={tab}
//               className={`tab-btn ${activeTab === tab ? "active" : ""}`}
//               onClick={() => { setActiveTab(tab); setSearch(""); }}
//             >
//               {tab === "current" && "Current Visit"}
//               {tab === "passes" && `My All Passes (${all_passes?.length || 0})`}
//               {tab === "my_rewards" && `My Unlocked Rewards (${filteredRewards?.length || 0})`}
//               {tab === "restaurants" && `All Restaurants (${restaurantsList?.length || 0})`}
//             </button>
//           ))}
//         </div>

//         {/* Tab 1: Current Overview */}
//         {activeTab === "current" && (
//           <ActiveOverview 
//             dashboardData={dashboardData} 
//             progressPercentage={progressPercentage} 
//             onNavigate={navigate} 
//           />
//         )}

//         {/* Tab 2: Roadmap Pass List */}
//         {activeTab === "passes" && (
//           <div>
//             <div className="search-box">
//               <input type="text" placeholder="Search specific rules or passes..." value={search} onChange={(e) => setSearch(e.target.value)} />
//             </div>
//             <div className="grid">
//               {filteredPasses.map((item) => {
//                 const itemProgress = Math.min((parseInt(current_visit) / parseInt(item.total_visits)) * 100, 100);
//                 const isItemCompleted = parseInt(current_visit) >= parseInt(item.total_visits);
//                 return (
//                   <div key={item.id} className="restaurant-card" onClick={() => setSelectedPass(item)}>
//                     <div className="restaurant-top">
//                       <div className="restaurant-logo">🎫</div>
//                       <div className="status" style={{ backgroundColor: isItemCompleted ? "#ecfdf5" : "#fef3c7", color: isItemCompleted ? "#059669" : "#d97706" }}>
//                         {isItemCompleted ? "Completed" : "In Progress"}
//                       </div>
//                     </div>
//                     <h3>{item.title}</h3>
//                     <p>Reward: <b>{item.reward}</b></p>
//                     <p style={{ fontSize: "14px" }}>Required Goal: {item.total_visits} Visits</p>
//                     <div className="small-progress">
//                       <div className="small-fill" style={{ width: `${itemProgress}%` }}></div>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         )}

//         {/* Tabs 3 & 4: Managed Rewards & Multi-location Search */}
//         {(activeTab === "my_rewards" || activeTab === "restaurants") && (
//           <div>
//             {activeTab === "restaurants" && (
//               <div className="search-box">
//                 <input type="text" placeholder="Search restaurant by name or location..." value={search} onChange={(e) => setSearch(e.target.value)} />
//               </div>
//             )}
//             <RewardsManager 
//               activeTab={activeTab}
//               filteredRewards={filteredRewards}
//               merchant={merchant}
//               customerId={customerId}
//               merchantId={merchantId}
//               actionLoading={actionLoading}
//               handleRedeemReward={handleRedeemReward}
//               filteredRestaurants={filteredRestaurants}
//               handleSelectRestaurant={handleSelectRestaurant}
              
//               /* 🌟 YAHAN HUMNE FUNCTION KO BIND KAR DIYA JO REWARDS MANAGER KE ANDAR USE HO PAYEGA */
//               onAddReviewClick={(restaurantItem) => {
//                 const mId = restaurantItem?.merchant_id || restaurantItem?.user_id || merchantId || "";
//                 const cId = customerId || "";
//                 navigate(`/feedback?merchant_id=${mId}&customer_id=${cId}`);
//               }}
//             />
//           </div>
//         )}

//         {/* Pop-up Info Modal overlay */}
//         {selectedPass && (
//           <div className="modal-overlay">
//             <div className="modal">
//               <h2>🎫 {selectedPass.title}</h2>
//               <p style={{ color: "#6b7280", margin: "15px 0" }}>Loyalty Rule Details & Reward Tracking</p>
//               <div className="rule-box">
//                 <h3>Reward: {selectedPass.reward}</h3>
//                 <p style={{ marginTop: "10px" }}>Required Total Visits: <b>{selectedPass.total_visits}</b></p>
//                 <p>Your Current Visits at this Restaurant: <b>{current_visit}</b></p>
//               </div>
//               <button className="close-btn" onClick={() => navigate("/feedback")}>Give Feedback</button>
//               <button className="close-btn" style={{ background: "#374151" }} onClick={() => setSelectedPass(null)}>Close Window</button>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// }
 
// import React, { useRef, useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import ActiveOverview from "./ActiveOverview";
// import RewardsManager from "./RewardsManager";
// import { Html5QrcodeScanner } from "html5-qrcode";

// export default function VisitDashboard() {
//   const navigate = useNavigate();
//   const savedDataString = localStorage.getItem("userData");
//      const parsedData = JSON.parse(savedDataString);
//      const user_id = parsedData.user_id;
     
//   const [activeTab, setActiveTab] = useState("current");
//   const [search, setSearch] = useState("");
//   const [selectedPass, setSelectedPass] = useState(null);
  
//   const [customerId, setCustomerId] = useState(user_id);
//  console.log('i am user_id',customerId)
 

   
//   const [merchantId, setMerchantId] = useState(" ");
//    //   const [customerId, setCustomerId] = useState("CMVC497B3A688");
//   // const [merchantId, setMerchantId] = useState("CMV9A117EAC");
//   const [openScanner, setOpenScanner] = useState(false);



//   const scannerRef = useRef(null);
// useEffect(() => {
//   console.log("State Update Ho Gayi -> Current MerchantId is:", merchantId);
// }, [merchantId]);
//   // QR Scanner logic with Smart URL & JSON Parsing Flow
//   useEffect(() => {
//     if (!openScanner) return;

//     const qrboxSize = window.innerWidth < 600 ? 210 : 260;

//     const scanner = new Html5QrcodeScanner(
//       "reader",
//       {
//         fps: 15,
//         qrbox: qrboxSize,
//         aspectRatio: 1.0,
//       },
//       false
//     );

//     scanner.render(
//        (decodedText) => {
//         console.log("Scanned Text: ", decodedText);
//         let extractedMerchantId = "";

//         // 1. Try checking if it's a standard web URL containing query parameters
//         if (decodedText.startsWith("http://") || decodedText.startsWith("https://")) {
//           try {
//             const urlObj = new URL(decodedText);
//             const params = new URLSearchParams(urlObj.search);
//             extractedMerchantId = params.get("merchant_id");
//             //console.log('i am id',extractedMerchantId)
//             setMerchantId(extractedMerchantId)
//           } catch (urlErr) {
//             console.error("URL parsing fallback error:", urlErr);
//           }
//         }

//         // 2. If it wasn't a standard URL or extraction failed, try parsing as JSON
//         if (!extractedMerchantId) {
//           try {
//             const data = JSON.parse(decodedText);
//             if (data && data.merchant_id) {
//               extractedMerchantId = data.merchant_id;
//             }
//           } catch (jsonErr) {
//             console.log("Not a valid JSON format either.");
//           }
//         }

//         // 3. Final validation and UI workflow triggering
//         if (extractedMerchantId) {
//           const cleanId = extractedMerchantId.trim();
//           localStorage.setItem("merchantId", cleanId);
//           setMerchantId(cleanId); 
//           setOpenScanner(false);
//           setActiveTab("current"); // Automatically switch back to see live updates
          
//           // Instantly trigger APIs with the freshly fetched merchant ID
//           fetchDashboardData(cleanId);
//           fetchRewardsList(cleanId);

//           try {
//             scanner.clear();
//           } catch (e) {
//             console.error("Scanner clear error:", e);
//           }
//         } else {
//           alert("Invalid QR Code: Please Scan vaild QR.");
//         }
//       },
//       () => {}
//     );

//     scannerRef.current = scanner;

//     return () => {
//       scanner.clear().catch(() => {});
//     };
//   }, [openScanner, customerId]);

//   // Load user details & check initial merchant session
//   useEffect(() => {
//     const userData = JSON.parse(localStorage.getItem("userData") || "{}");
//     if (userData?.merchant) {
//       setCustomerId(userData.merchant.user_id);
//       const savedMerchantId = localStorage.getItem("merchantId");
//       if (savedMerchantId) {
//         setMerchantId(savedMerchantId);
//       }
//     }
//   }, []);

//   const [dashboardData, setDashboardData] = useState(null);
//   const [rewardsList, setRewardsList] = useState([]); 
//   const [restaurantsList, setRestaurantsList] = useState([]);
  
//   const [loading, setLoading] = useState(true);
//   const [actionLoading, setActionLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [user, setUser] = useState(null);

//   // Auth Guard
//  useEffect(() => {
//   const login = localStorage.getItem("isLoggedIn");
//   const userData = localStorage.getItem("userData");

//   // Agar logged in nahi hai, to direct login page par bhej do aur history clear kar do
//   if (login !== "true") {
//     navigate("/", { replace: true });
//     return;
//   }

//   // Safe parsing: Agar userData milta hai, tabhi state set karo
//   if (userData) {
//     try {
//       setUser(JSON.parse(userData));
//     } catch (error) {
//       console.error("Error parsing userData from localStorage:", error);
//     }
//   }
// }, [navigate]);
//   const cleanAndParseJson = (text) => {
//     try {
//       const cleanString = text.replace("DATABASE CONNECTED", "").trim();
//       return JSON.parse(cleanString);
//     } catch (e) {
//       console.error("JSON Parsing failed: ", text);
//       throw new Error("Invalid response format.");
//     }
//   };

//   const fetchDashboardData = async (mId = merchantId) => {
//     if (!mId) return;
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", customerId);
//       formdata.append("merchant_id", mId);

//       const response = await fetch("https://countmyvisit.com/Apis/customer_dashboard.php", {
//         method: "POST", body: formdata, redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) {
//         setError(null);
//         setDashboardData(data);
//       } else {
//         setError("Failed to fetch dashboard data.");
//       }
//     } catch (err) {
//       setError("Something went wrong while fetching dashboard data.");
//     }
//   };

//   const fetchRewardsList = async (mId = merchantId) => {
//     if (!mId) return;
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", customerId);
//       formdata.append("merchant_id", mId);
//       const response = await fetch("https://countmyvisit.com/Apis/my_rewards.php", {
//         method: "POST", body: formdata, redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) setRewardsList(data.rewards || []);
//     } catch (err) {
//       console.error("Error fetching rewards:", err);
//     }
//   };

//   const fetchRestaurantsList = async () => {
//     if (!customerId) return;
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", customerId);
//       const response = await fetch("https://countmyvisit.com/Apis/my_restaurants.php", {
//         method: "POST", body: formdata, redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);
//       if (data.success) setRestaurantsList(data.restaurants || []);
//     } catch (err) {
//       console.error("Error fetching restaurants:", err);
//     }
//   };

//   useEffect(() => {
//     async function loadAllInitialData() {
//       setLoading(true);
//       await fetchRestaurantsList();
//       if (merchantId) {
//         await fetchDashboardData(merchantId);
//         await fetchRewardsList(merchantId);
//       }
//       setLoading(false);
//     }
//     if (customerId) {
//       loadAllInitialData();
//     } else {
//       setLoading(false);
//     }
//   }, [merchantId, customerId]);

//   const handleSelectRestaurant = (mId) => {
//     setMerchantId(mId);
//     localStorage.setItem("merchantId", mId);
//     setActiveTab("current");
//   };

//   const handleLogout = () => {
//     localStorage.clear();
//     navigate("/", { replace: true });
//   };

//   const handleRedeemReward = async (couponCode) => {
//     if (!window.confirm(`Redeem voucher: ${couponCode}?`)) return;
//     setActionLoading(true);
//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", customerId);
//       formdata.append("merchant_id", merchantId);
//       formdata.append("coupon_code", couponCode);

//       const response = await fetch("https://countmyvisit.com/Apis/redeem_reward.php", {
//         method: "POST", body: formdata, redirect: "follow"
//       });
//       const resText = await response.text();
//       const data = cleanAndParseJson(resText);

//       if (data.success) {
//         alert(data.message || "Reward Redeemed Successfully! 🎁");
//         await fetchDashboardData(merchantId);
//         await fetchRewardsList(merchantId);
//       } else {
//         alert(data.message || "Failed point validation.");
//       }
//     } catch (err) {
//       alert("Network exception occurred.");
//     } finally {
//       setActionLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", background: "#f8fafc", fontFamily: "Poppins, sans-serif" }}>
//         <div style={{ textAlign: "center" }}>
//           <div style={{ fontSize: "42px", marginBottom: "15px", animation: "spin 1.5s linear infinite" }}>🔄</div>
//           <div style={{ fontSize: "19px", fontWeight: "700", color: "#0f172a" }}>Syncing Premium Dashboard Modules...</div>
//           <p style={{ fontSize: "13px", color: "#64748b", marginTop: "6px" }}>Optimizing loyalty vectors</p>
//         </div>
//         <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
//       </div>
//     );
//   }

//   const current_visit = dashboardData?.current_visit || "0";
//   const next_reward = dashboardData?.next_reward || null;
//   const all_passes = dashboardData?.all_passes || [];
//   const merchant = dashboardData?.merchant || null;
//   const customer = dashboardData?.customer || null;

//   const filteredRewards = rewardsList.filter((reward) => {
//     const matchesSearch = reward.coupon_code.toLowerCase().includes(search.toLowerCase());
//     return reward.merchant_id ? (reward.merchant_id === merchantId && matchesSearch) : matchesSearch;
//   });

//   const filteredPasses = all_passes.filter((item) =>
//     item.title.toLowerCase().includes(search.toLowerCase()) || 
//     item.reward.toLowerCase().includes(search.toLowerCase())
//   );

//   const filteredRestaurants = restaurantsList.filter((res) => 
//     res.business_name.toLowerCase().includes(search.toLowerCase()) || res.address.toLowerCase().includes(search.toLowerCase())
//   );

//   const maxVisitsForProgress = next_reward ? parseInt(next_reward.required_visits) : 1;
//   const progressPercentage = Math.min((parseInt(current_visit) / maxVisitsForProgress) * 100, 100);

//   return (
//     <>
//        <style>{`
//         *{ margin:0; padding:0; box-sizing:border-box; font-family:'Poppins',sans-serif; }
//         @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
//         body{ background:#f4f7fb; }
//         .dashboard{ min-height:100vh; padding:35px; background: linear-gradient(135deg,#fff7ed,#fff,#f3f7ff); }
//         .topbar{ display:flex; justify-content:space-between; align-items:center; margin-bottom:35px; flex-wrap:wrap; gap:20px; }
//         .top-left h1{ font-size:38px; font-weight:800; color:#111827; }
//         .top-left p{ color:#6b7280; margin-top:8px; font-size:15px; }
//         .top-right{ display:flex; align-items:center; gap:12px; flex-wrap:wrap; }
//         .profile{ width:58px; height:58px; border-radius:50%; background:linear-gradient(135deg,#ff8c42,#ff5e62); color:white; display:flex; align-items:center; justify-content:center; font-size:24px; font-weight:700; box-shadow:0 10px 30px rgba(255,94,98,0.3); }
//         .nav-btn{ border:none; padding:14px 20px; border-radius:16px; background:linear-gradient(135deg,#111827,#374151); color:white; font-size:14px; font-weight:700; cursor:pointer; transition:0.3s; }
//         .nav-btn.special{ background:linear-gradient(135deg,#2563eb,#1d4ed8); }
//         .nav-btn.action-trigger{ background:linear-gradient(135deg,#10b981,#059669); }
//         .nav-btn:hover, .redeem-btn:hover, .select-shop-btn:hover{ transform:translateY(-3px); opacity:0.95; box-shadow: 0 5px 15px rgba(0,0,0,0.1); }
//         .tabs{ display:flex; gap:15px; margin-bottom:35px; flex-wrap:wrap; }
//         .tab-btn{ padding:15px 28px; border:none; border-radius:18px; font-size:16px; font-weight:700; background:white; color:#555; cursor:pointer; transition:0.3s; box-shadow:0 5px 20px rgba(0,0,0,0.05); }
//         .tab-btn.active{ background:linear-gradient(135deg,#ff8c42,#ff5e62); color:white; transform:translateY(-2px); }
//         .timeline-card{ background: white; border-radius: 30px; padding: 30px; margin-bottom: 30px; box-shadow: 0 10px 35px rgba(0,0,0,0.06); }
//         .timeline-card h3{ font-size: 22px; color: #111827; margin-bottom: 15px; }
//         .timeline-slider{ display: flex; gap: 20px; overflow-x: auto; padding: 10px 5px 20px 5px; scroll-behavior: smooth; }
//         .timeline-slider::-webkit-scrollbar { height: 8px; }
//         .timeline-slider::-webkit-scrollbar-thumb { background: #ff8c42; border-radius: 10px; }
//         .timeline-slider::-webkit-scrollbar-track { background: #f3f4f6; }
//         .timeline-item { min-width: 240px; background: #fff8f5; border: 2px dashed #ffdcd0; border-radius: 20px; padding: 20px; position: relative; transition: 0.3s; }
//         .timeline-item.next-up { background: #fff7ed; border: 2px solid #ff8c42; box-shadow: 0 8px 25px rgba(255,140,66,0.15); }
//         .timeline-item h5 { font-size: 14px; color: #ff6b35; text-transform: uppercase; margin-bottom: 5px; font-weight: 700; }
//         .timeline-item p { font-size: 16px; font-weight: 700; color: #111827; }
//         .timeline-badge { display: inline-block; font-size: 11px; padding: 4px 10px; border-radius: 20px; font-weight: 700; margin-top: 10px; }
//         .current-visit{ display:grid; grid-template-columns:1fr 1fr; gap:30px; }
//         .card{ background:white; border-radius:30px; padding:35px; box-shadow:0 10px 35px rgba(0,0,0,0.06); }
//         .card h3{ font-size:26px; margin-bottom:25px; color:#111827; }
//         .visit-ring{ width:230px; height:230px; margin:auto; border-radius:50%; display:flex; align-items:center; justify-content:center; }
//         .ring-inner{ width:180px; height:180px; background:white; border-radius:50%; display:flex; flex-direction:column; align-items:center; justify-content:center; }
//         .ring-inner h1{ font-size:52px; color:#ff6b35; font-weight:800; }
//         .ring-inner p{ color:#6b7280; font-size:17px; font-weight:600; }
//         .reward-card{ background: linear-gradient(135deg,#111827,#1f2937); border-radius:28px; padding:35px; color:white; position:relative; overflow:hidden; display: flex; flex-direction: column; justify-content: space-between; }
//         .reward-tag{ display:inline-block; background:#22c55e; color:white; padding:8px 18px; border-radius:30px; font-size:14px; font-weight:700; margin-bottom:20px; width: max-content; }
//         .reward-card h2{ font-size:34px; margin-bottom:18px; }
//         .reward-card p{ color:#d1d5db; line-height:1.7; }
//         .coupon{ background:#ff8c42; padding:16px; border-radius:18px; text-align:center; font-size:24px; font-weight:800; letter-spacing:2px; margin-top:25px; }
//         .feedback-btn{ margin-top:25px; width:100%; height:60px; border:none; border-radius:18px; background:linear-gradient(135deg,#ff8c42,#ff5e62); color:white; font-size:17px; font-weight:700; cursor:pointer; transition:0.3s; }
//         .milestone{ margin-top:30px; }
//         .milestone h4{ margin-bottom:15px; font-size:18px; color:#111827; }
//         .progress{ height:16px; border-radius:30px; background:#e5e7eb; overflow:hidden; }
//         .progress-fill{ height:100%; background:linear-gradient(135deg,#ff8c42,#ff5e62); border-radius:30px; }
//         .milestone p{ margin-top:12px; color:#6b7280; font-weight:500; }
//         .coupon-card { background: white; border-radius: 24px; padding: 25px; box-shadow: 0 10px 30px rgba(0,0,0,0.04); border: 1px solid #eef2f6; display: flex; flex-direction: column; justify-content: space-between; }
//         .coupon-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px; }
//         .coupon-code-txt { font-family: monospace; background: #f3f4f6; padding: 6px 12px; border-radius: 8px; font-weight: 700; font-size: 16px; color: #374151; }
//         .shop-badge { font-size: 12px; font-weight: 700; background: #eff6ff; color: #2563eb; padding: 6px 14px; border-radius: 12px; border: 1px solid #bfdbfe; }
//         .redeem-btn, .select-shop-btn { width: 100%; padding: 14px; border: none; background: linear-gradient(135deg, #10b981, #059669); color: white; border-radius: 14px; font-size: 15px; font-weight: 700; cursor: pointer; margin-top: 15px; transition: 0.2s; }
//         .select-shop-btn { background: linear-gradient(135deg, #2563eb, #1d4ed8); }
//         .search-box{ margin-bottom:30px; }
//         .search-box input{ width:100%; height:68px; border:none; border-radius:20px; padding:0 25px; font-size:17px; background:white; box-shadow:0 10px 30px rgba(0,0,0,0.05); outline:none; }
//         .grid{ display:grid; grid-template-columns:repeat(auto-fit,minmax(280px,1fr)); gap:25px; }
//         .restaurant-card{ background:white; border-radius:28px; padding:30px; box-shadow:0 10px 30px rgba(0,0,0,0.05); transition:0.3s; cursor:pointer; position:relative; }
//         .restaurant-card:hover{ transform:translateY(-8px); }
//         .restaurant-top{ display:flex; justify-content:space-between; align-items:center; margin-bottom:20px; }
//         .restaurant-logo{ width:65px; height:65px; border-radius:20px; background:#fff4eb; display:flex; align-items:center; justify-content:center; font-size:34px; }
//         .status{ padding:10px 15px; border-radius:30px; font-size:13px; font-weight:700; }
//         .restaurant-card h3{ font-size:24px; margin-bottom:12px; }
//         .restaurant-card p{ color:#6b7280; margin-bottom:18px; }

//         .scanner-popup{

// position:fixed;
// top:0;
// left:0;
// right:0;
// bottom:0;
// background:rgba(0,0,0,.75);
// display:flex;
// justify-content:center;
// align-items:center;
// z-index:999999;

// }

// .scanner-box{

// width:95%;
// max-width:420px;
// background:#fff;
// padding:20px;
// border-radius:20px;
// text-align:center;

// }

// .close-btn{

// margin-top:15px;
// padding:12px 30px;
// background:#ff4d4d;
// border:none;
// color:#fff;
// border-radius:10px;
// cursor:pointer;

// }

// #reader{

// width:100%;

// }
//         .small-progress{ height:12px; background:#eee; border-radius:20px; overflow:hidden; }
//         .small-fill{ height:100%; background:linear-gradient(135deg,#ff8c42,#ff5e62); }
//         .modal-overlay{ position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5); display:flex; align-items:center; justify-content:center; z-index:999; padding:20px; }
//         .modal{ background:white; width:100%; max-width:520px; border-radius:35px; padding:40px; }
//         .rule-box { background: #f9fafb; border: 1px solid #e5e7eb; padding: 20px; border-radius: 20px; margin-top: 15px; }
//         .close-btn{ width:100%; height:60px; border:none; border-radius:18px; background:linear-gradient(135deg,#ff8c42,#ff5e62); color:white; font-size:18px; font-weight:700; cursor:pointer; margin-top:15px; }
//         @media(max-width:900px){ .dashboard{ padding:20px; } .current-visit{ grid-template-columns:1fr; } .top-left h1{ font-size:28px; } .visit-ring{ width:190px; height:190px; } .ring-inner{ width:145px; height:145px; } .ring-inner h1{ font-size:42px; } }
//       `}</style>

//       <div className="dashboard">
//         {/* Navigation Head ALWAYS VISIBLE */}
//         <div className="topbar">
//           <div className="top-left">
//             <h1>Count My Visit</h1>
//             <p>Welcome, <b>{customer?.name || "User"}</b> | Tracking for {merchant?.business_name || "Active Session"}</p>
//           </div>
//           <div className="top-right">
//             <button className="nav-btn special" onClick={() => setActiveTab("restaurants")}>🍽️ My Restaurants</button>
//             <button className="nav-btn" onClick={() => navigate("/MyQRScreen")}>🔲 MY QR</button>
//             <button className="nav-btn action-trigger" onClick={() => setOpenScanner(true)}>📷 Scan Shop QR</button>

//             {/* Camera Scanner View Trigger */}
//             {openScanner && (
//               <div className="scanner-popup">
//                 <div className="scanner-box">
//                   <h3 style={{fontSize:"22px", fontWeight:"700", marginBottom:"6px"}}>Scan Shop QR</h3>
//                   <p style={{ fontSize: "13px", color: "#64748b", marginBottom: "20px" }}>Scan restaurant code to immediately load live dynamic roadmap</p>
//                   <div id="reader"></div>
//                   <button
//                     className="close-btn"
//                     onClick={() => {
//                       if (scannerRef.current) {
//                         scannerRef.current.clear().catch(() => {});
//                       }
//                       setOpenScanner(false);
//                     }}
//                   >
//                     Cancel Scan
//                   </button>
//                 </div>
//               </div>
//             )}
//             <button className="nav-btn" style={{background: "#ef4444"}} onClick={handleLogout}>Logout</button>
//             <div className="profile">{(customer?.name || "U").charAt(0).toUpperCase()}</div>
//           </div>
//         </div>

//         {/* Tab Controllers ALWAYS VISIBLE */}
//         <div className="tabs">
//           {["current", "passes", "my_rewards", "restaurants"].map((tab) => (
//             <button
//               key={tab}
//               className={`tab-btn ${activeTab === tab ? "active" : ""}`}
//               onClick={() => { setActiveTab(tab); setSearch(""); }}
//             >
//               {tab === "current" && "Current Visit"}
//               {tab === "passes" && `My All Passes (${merchantId ? all_passes?.length : 0})`}
//               {tab === "my_rewards" && `My Unlocked Rewards (${merchantId ? filteredRewards?.length : 0})`}
//               {tab === "restaurants" && `All Restaurants (${restaurantsList?.length || 0})`}
//             </button>
//           ))}
//         </div>

//         {/* CONDITION-1: IF TAB IS "RESTAURANTS" -> ALWAYS LOAD HISTORY (NO MERCHANT_ID NEEDED) */}
//         {activeTab === "restaurants" ? (
//           <div>
//             <div className="search-box" style={{ marginBottom: "25px" }}>
//               <input type="text" placeholder="Search restaurant by name or location..." value={search} onChange={(e) => setSearch(e.target.value)} />
//             </div>
//             <RewardsManager 
//               activeTab="restaurants"
//               filteredRewards={[]}
//               merchant={null}
//               customerId={customerId}
//               merchantId=""
//               actionLoading={actionLoading}
//               handleRedeemReward={handleRedeemReward}
//               filteredRestaurants={filteredRestaurants}
//               handleSelectRestaurant={handleSelectRestaurant}
//               onAddReviewClick={(restaurantItem) => {
//                 const mId = restaurantItem?.merchant_id || restaurantItem?.user_id || "";
//                 navigate(`/feedback?merchant_id=${mId}&customer_id=${customerId}`);
//               }}
//             />
//           </div>
//         ) : (
//           /* CONDITION-2: FOR OTHER LOYALTY TABS, IF NO MERCHANT_ID -> SHOW ATTRACIVE PLACEHOLDER INSIDE THE DASHBOARD FRAME */
//           !merchantId ? (
//             <div className="placeholder-card">
//               <span className="placeholder-icon">✨</span>
//               <h3 style={{ fontSize: "20px", fontWeight: "700", marginBottom: "8px", color: "#0f172a" }}>Roadmap is Currently Locked</h3>
//               <p style={{ fontSize: "14px", color: "#64748b", lineHeight: "1.6", marginBottom: "20px" }}>
//                 Koi purana data ya empty error screen nahi dikhega! Live metrics aur rewards check karne ke liye upar diye gaye <b>"Scan Shop QR"</b> button se store scan karein ya <b>"All Restaurants"</b> tab se select karein.
//               </p>
//               <button className="nav-btn action-trigger" style={{ margin: "0 auto", padding: "12px 26px" }} onClick={() => setOpenScanner(true)}>
//                 📷 Open Scanner Now
//               </button>
//             </div>
//           ) : (
//             /* CONDITION-3: IF MERCHANT_ID EXISTS -> POPULATE LIVE SERVER DATA ASSETS */
//             <>
//               {/* Tab 1: Current Overview */}
//               {activeTab === "current" && dashboardData && (
//                 <ActiveOverview 
//                   dashboardData={dashboardData} 
//                   progressPercentage={progressPercentage} 
//                   onNavigate={navigate} 
//                 />
//               )}

//               {/* Tab 2: Roadmap Pass List */}
//               {activeTab === "passes" && (
//                 <div>
//                   <div className="search-box" style={{ marginBottom: "25px" }}>
//                     <input type="text" placeholder="Search specific rules or passes..." value={search} onChange={(e) => setSearch(e.target.value)} />
//                   </div>
//                   <div className="grid">
//                     {filteredPasses.map((item) => {
//                       const itemProgress = Math.min((parseInt(current_visit) / parseInt(item.total_visits)) * 100, 100);
//                       const isItemCompleted = parseInt(current_visit) >= parseInt(item.total_visits);
//                       return (
//                         <div key={item.id} className="restaurant-card" onClick={() => setSelectedPass(item)}>
//                           <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "15px", alignItems: "center" }}>
//                             <span style={{ fontSize: "24px" }}>🎫</span>
//                             <span style={{ fontSize: "12px", padding: "4px 10px", borderRadius: "8px", fontWeight: "700", backgroundColor: isItemCompleted ? "#d1fae5" : "#fef3c7", color: isItemCompleted ? "#065f46" : "#92400e" }}>
//                               {isItemCompleted ? "Unlocked 🎉" : "In Progress"}
//                             </span>
//                           </div>
//                           <h3 style={{ fontSize: "18px", fontWeight: "700", marginBottom: "8px" }}>{item.title}</h3>
//                           <p style={{ fontSize: "14px", color: "#475569" }}>Reward: <b>{item.reward}</b></p>
//                           <p style={{ fontSize: "13px", color: "#64748b", marginTop: "4px" }}>Goal: {item.total_visits} Visits</p>
//                           <div style={{ height: "6px", width: "100%", background: "#f1f5f9", borderRadius: "10px", marginTop: "14px", overflow: "hidden" }}>
//                             <div style={{ height: "100%", background: "linear-gradient(90deg, #ff8c42, #ff5e62)", width: `${itemProgress}%` }}></div>
//                           </div>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </div>
//               )}

//               {/* Tab 3: Unlocked Active Coupons */}
//               {activeTab === "my_rewards" && (
//                 <RewardsManager 
//                   activeTab="my_rewards"
//                   filteredRewards={filteredRewards}
//                   merchant={merchant}
//                   customerId={customerId}
//                   merchantId={merchantId}
//                   actionLoading={actionLoading}
//                   handleRedeemReward={handleRedeemReward}
//                   filteredRestaurants={filteredRestaurants}
//                   handleSelectRestaurant={handleSelectRestaurant}
//                   onAddReviewClick={(restaurantItem) => {
//                     const mId = restaurantItem?.merchant_id || restaurantItem?.user_id || merchantId || "";
//                     navigate(`/feedback?merchant_id=${mId}&customer_id=${customerId}`);
//                   }}
//                 />
//               )}
//             </>
//           )
//         )}

//         {/* Pop-up Info Modal overlay */}
//         {selectedPass && (
//           <div className="scanner-popup" style={{animation: "none"}}>
//             <div className="scanner-box" style={{ textAlign: "left" }}>
//               <h2 style={{ fontSize: "22px", fontWeight: "700" }}>🎫 {selectedPass.title}</h2>
//               <p style={{ color: "#64748b", margin: "10px 0 20px 0", fontSize: "14px" }}>Loyalty Rule Details & Reward Tracking</p>
//               <div style={{ background: "#f8fafc", padding: "20px", borderRadius: "16px", marginBottom: "20px", border: "1px solid #e2e8f0" }}>
//                 <h3 style={{ fontSize: "16px", color: "#0f172a" }}>Reward: <b>{selectedPass.reward}</b></h3>
//                 <p style={{ marginTop: "12px", fontSize: "14px" }}>Required Total Visits: <b>{selectedPass.total_visits}</b></p>
//                 <p style={{ fontSize: "14px", marginTop: "4px" }}>Your Current Visits: <b>{current_visit}</b></p>
//               </div>
//               <div style={{ display: "flex", gap: "10px" }}>
//                 <button className="nav-btn special" style={{ flex: 1, justifyContent: "center" }} onClick={() => navigate("/feedback")}>Give Feedback</button>
//                 <button className="close-btn" style={{ flex: 1, margin: 0, background: "#1e293b" }} onClick={() => setSelectedPass(null)}>Close</button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

 
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ActiveOverview from "../Customerscreen/ActiveOverview";
import RewardsManager from "../Customerscreen/RewardsManager";
import { Html5QrcodeScanner } from "html5-qrcode";

const API_BASE = "https://countmyvisit.com/Apis";

export default function VisitDashboard() {
  const navigate = useNavigate();
  const scannerRef = useRef(null);
  const scanLockedRef = useRef(false);

  /* =========================================================
     USER / AUTH
  ========================================================= */

  const [user, setUser] = useState(null);
  const [customerId, setCustomerId] = useState("");
  const [merchantId, setMerchantId] = useState("");

  /* =========================================================
     UI STATE
  ========================================================= */

  const [activeTab, setActiveTab] = useState("current");
  const [search, setSearch] = useState("");
  const [selectedPass, setSelectedPass] = useState(null);
  const [openScanner, setOpenScanner] = useState(false);

  /* =========================================================
     DATA STATE
  ========================================================= */

  const [dashboardData, setDashboardData] = useState(null);
  const [rewardsList, setRewardsList] = useState([]);
  const [restaurantsList, setRestaurantsList] = useState([]);

  /* =========================================================
     LOADING / ACTION STATE
  ========================================================= */

  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);
  const [error, setError] = useState("");

  /* =========================================================
     SAFE JSON PARSER
  ========================================================= */

  const cleanAndParseJson = (text) => {
    try {
      const cleaned = String(text || "")
        .replace(/DATABASE CONNECTED/gi, "")
        .trim();

      return JSON.parse(cleaned);
    } catch (err) {
      console.error("JSON parsing failed:", text);
      throw new Error("Invalid server response.");
    }
  };

  /* =========================================================
     AUTH GUARD + USER LOAD
  ========================================================= */

  useEffect(() => {
    const login = localStorage.getItem("isLoggedIn");
    const rawUser = localStorage.getItem("userData");

    if (login !== "true") {
      navigate("/", { replace: true });
      return;
    }

    try {
      const parsedUser = rawUser ? JSON.parse(rawUser) : null;

      if (!parsedUser) {
        navigate("/", { replace: true });
        return;
      }

      setUser(parsedUser);

      const detectedCustomerId =
        parsedUser?.user_id ||
        parsedUser?.id ||
        parsedUser?.customer_id ||
        parsedUser?.merchant?.user_id ||
        "";

      setCustomerId(String(detectedCustomerId));

      const savedMerchant = localStorage.getItem("merchantId");

      if (savedMerchant) {
        setMerchantId(savedMerchant);
      }
    } catch (err) {
      console.error("User data parsing error:", err);
      localStorage.removeItem("userData");
      localStorage.removeItem("isLoggedIn");
      navigate("/", { replace: true });
    }
  }, [navigate]);
   

  /* =========================================================
     1. AUTO-LOGIN & AUTH CHECK
  ========================================================= */
  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    if (!isLoggedIn) {
      // Agar logged in nahi hai toh direct WelcomeGateway par bhej do
      navigate("/WelcomeGateway", { replace: true });
    }
  }, [navigate]);

  /* =========================================================
     2. BLOCK BACK BUTTON (Back nahi aane dega)
  ========================================================= */
  useEffect(() => {
    // Current state ko browser history mein push karte hain
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      // Back press hone par wapas dashboard history state push kar do
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  /* =========================================================
     3. LOGOUT HANDLER (Wapas jane ka ek iklota tarika)
  ========================================================= */
  

  /* =========================================================
     DASHBOARD API
  ========================================================= */

  const fetchDashboardData = async (mId = merchantId) => {
    if (!customerId || !mId) return;

    try {
      const formData = new FormData();

      formData.append("customer_id", String(customerId));
      formData.append("merchant_id", String(mId));

      const response = await fetch(
        `${API_BASE}/customer_dashboard.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const result = await response.text();
      const data = cleanAndParseJson(result);

      if (data.success) {
        setDashboardData(data);
        setError("");
      } else {
        setDashboardData(null);
        setError(data.message || "Unable to load shop data.");
      }
    } catch (err) {
      console.error("Dashboard error:", err);
      setError("Unable to connect with the server.");
    }
  };

  /* =========================================================
     REWARDS API
  ========================================================= */

  const fetchRewardsList = async (mId = merchantId) => {
    if (!customerId || !mId) return;

    try {
      const formData = new FormData();

      formData.append("customer_id", String(customerId));
      formData.append("merchant_id", String(mId));

      const response = await fetch(
        `${API_BASE}/my_rewards.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const result = await response.text();
      const data = cleanAndParseJson(result);

      if (data.success) {
        setRewardsList(data.rewards || []);
      } else {
        setRewardsList([]);
      }
    } catch (err) {
      console.error("Rewards error:", err);
      setRewardsList([]);
    }
  };

  /* =========================================================
     RESTAURANTS API
  ========================================================= */

  const fetchRestaurantsList = async () => {
    if (!customerId) return;

    try {
      const formData = new FormData();

      formData.append("customer_id", String(customerId));

      const response = await fetch(
        `${API_BASE}/my_restaurants.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const result = await response.text();
      const data = cleanAndParseJson(result);

      if (data.success) {
        setRestaurantsList(data.restaurants || []);
      } else {
        setRestaurantsList([]);
      }
    } catch (err) {
      console.error("Restaurants error:", err);
      setRestaurantsList([]);
    }
  };

  /* =========================================================
     INITIAL DATA
  ========================================================= */

  useEffect(() => {
    if (!customerId) return;

    const loadData = async () => {
      setLoading(true);

      await fetchRestaurantsList();

      if (merchantId) {
        await Promise.all([
          fetchDashboardData(merchantId),
          fetchRewardsList(merchantId),
        ]);
      }

      setLoading(false);
    };

    loadData();
  }, [customerId, merchantId]);

  /* =========================================================
     QR SCANNER
  ========================================================= */

  useEffect(() => {
    if (!openScanner) return;

    scanLockedRef.current = false;

    const timer = setTimeout(() => {
      const scanner = new Html5QrcodeScanner(
        "reader",
        {
          fps: 10,
          qrbox: {
            width: window.innerWidth < 600 ? 220 : 270,
            height: window.innerWidth < 600 ? 220 : 270,
          },
          aspectRatio: 1,
          rememberLastUsedCamera: true,
        },
        false
      );

      scannerRef.current = scanner;

      scanner.render(
        async (decodedText) => {
          if (scanLockedRef.current) return;

          scanLockedRef.current = true;

          console.log("QR scanned:", decodedText);

          let extractedMerchantId = "";

          /* URL QR */

          if (
            decodedText.startsWith("http://") ||
            decodedText.startsWith("https://")
          ) {
            try {
              const url = new URL(decodedText);

              extractedMerchantId =
                url.searchParams.get("merchant_id") ||
                url.searchParams.get("merchantId") ||
                "";
            } catch (err) {
              console.error("URL parse error:", err);
            }
          }

          /* JSON QR */

          if (!extractedMerchantId) {
            try {
              const parsed = JSON.parse(decodedText);

              extractedMerchantId =
                parsed?.merchant_id ||
                parsed?.merchantId ||
                parsed?.user_id ||
                "";
            } catch {
              // Not JSON
            }
          }

          /* Plain merchant ID */

          if (!extractedMerchantId) {
            const plainValue = String(decodedText || "").trim();

            if (
              plainValue &&
              !plainValue.includes(" ") &&
              plainValue.length >= 5
            ) {
              extractedMerchantId = plainValue;
            }
          }

          if (!extractedMerchantId) {
            scanLockedRef.current = false;

            window.alert(
              "Invalid QR Code.\nPlease scan a valid Count My Visit shop QR."
            );

            return;
          }

          const cleanId = String(extractedMerchantId).trim();

          localStorage.setItem("merchantId", cleanId);

          setMerchantId(cleanId);
          setActiveTab("current");
          setSearch("");
          setOpenScanner(false);

          try {
            await scanner.clear();
          } catch (err) {
            console.log("Scanner cleanup:", err);
          }

          await Promise.all([
            fetchDashboardData(cleanId),
            fetchRewardsList(cleanId),
          ]);
        },
        () => {
          // Ignore continuous scanner errors
        }
      );
    }, 150);

    return () => {
      clearTimeout(timer);

      if (scannerRef.current) {
        scannerRef.current
          .clear()
          .catch(() => {});
        scannerRef.current = null;
      }
    };
  }, [openScanner]);

  /* =========================================================
     SELECT RESTAURANT
  ========================================================= */

  const handleSelectRestaurant = async (mId) => {
    if (!mId) return;

    const cleanId = String(mId).trim();

    setMerchantId(cleanId);
    localStorage.setItem("merchantId", cleanId);

    setActiveTab("current");
    setSearch("");
    setError("");

    setLoading(true);

    await Promise.all([
      fetchDashboardData(cleanId),
      fetchRewardsList(cleanId),
    ]);

    setLoading(false);
  };

  /* =========================================================
     REDEEM
  ========================================================= */

  const handleRedeemReward = async (couponCode) => {
    if (!couponCode || !merchantId || !customerId) return;

    const confirmed = window.confirm(
      `Redeem reward "${couponCode}"?`
    );

    if (!confirmed) return;

    setActionLoading(true);

    try {
      const formData = new FormData();

      formData.append("customer_id", String(customerId));
      formData.append("merchant_id", String(merchantId));
      formData.append("coupon_code", String(couponCode));

      const response = await fetch(
        `${API_BASE}/redeem_reward.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.text();
      const data = cleanAndParseJson(result);

      if (data.success) {
        window.alert(
          data.message || "Reward redeemed successfully! 🎉"
        );

        await Promise.all([
          fetchDashboardData(merchantId),
          fetchRewardsList(merchantId),
        ]);
      } else {
        window.alert(
          data.message || "Unable to redeem this reward."
        );
      }
    } catch (err) {
      console.error("Redeem error:", err);

      window.alert(
        "Network error. Please try again."
      );
    } finally {
      setActionLoading(false);
    }
  };

  /* =========================================================
     LOGOUT
  ========================================================= */

  const handleLogout = () => {
    localStorage.removeItem("userData");
    localStorage.removeItem("merchantId");
    localStorage.removeItem("isLoggedIn");

    navigate("/", { replace: true });
  };

  /* =========================================================
     DERIVED DATA
  ========================================================= */

  const currentVisit =
    Number(dashboardData?.current_visit || 0);

  const nextReward =
    dashboardData?.next_reward || null;

  const allPasses =
    dashboardData?.all_passes || [];

  const merchant =
    dashboardData?.merchant || null;

  const customer =
    dashboardData?.customer || user || null;

  const filteredRewards = rewardsList.filter((reward) => {
    const code = String(
      reward?.coupon_code || ""
    ).toLowerCase();

    const query = search.toLowerCase();

    const matchesSearch = code.includes(query);

    return reward?.merchant_id
      ? String(reward.merchant_id) === String(merchantId) &&
          matchesSearch
      : matchesSearch;
  });

  const filteredPasses = allPasses.filter((item) => {
    const title = String(item?.title || "").toLowerCase();
    const reward = String(item?.reward || "").toLowerCase();
    const query = search.toLowerCase();

    return (
      title.includes(query) ||
      reward.includes(query)
    );
  });

  const filteredRestaurants = restaurantsList.filter((restaurant) => {
    const name = String(
      restaurant?.business_name || ""
    ).toLowerCase();

    const address = String(
      restaurant?.address || ""
    ).toLowerCase();

    const query = search.toLowerCase();

    return (
      name.includes(query) ||
      address.includes(query)
    );
  });

  const maxVisitsForProgress = nextReward
    ? Number(nextReward.required_visits || 1)
    : 1;

  const progressPercentage = Math.min(
    (currentVisit / maxVisitsForProgress) * 100,
    100
  );

  const customerName =
    customer?.name ||
    customer?.full_name ||
    "User";

  const customerInitial =
    customerName.charAt(0).toUpperCase();

  /* =========================================================
     LOADING SCREEN
  ========================================================= */

  if (loading) {
    return (
      <>
        <style>{globalStyles}</style>

        <div className="cmv-loading-screen">
          <div className="cmv-loader-card">
            <div className="cmv-loader-logo">
              CMV
            </div>

            <div className="cmv-spinner" />

            <h2>Preparing your loyalty dashboard</h2>

            <p>
              Syncing visits, rewards and your favourite
              restaurants...
            </p>
          </div>
        </div>
      </>
    );
  }

  /* =========================================================
     MAIN UI
  ========================================================= */

  return (
    <>
      <style>{globalStyles}</style>

      <div className="cmv-app">

        {/* =====================================================
            HEADER
        ===================================================== */}

        <header className="cmv-header">

          <div className="cmv-brand-area">

            <div className="cmv-brand-logo">
              <span>CMV</span>
            </div>

            <div>
              <div className="cmv-brand-name">
                Count My Visit
              </div>

              <div className="cmv-brand-subtitle">
                Smart loyalty rewards
              </div>
            </div>

          </div>

          <div className="cmv-header-actions">

            <button
              className="cmv-header-btn"
              onClick={() =>
                setActiveTab("restaurants")
              }
            >
              <span>🏪</span>
              <span className="desktop-only">
                My Restaurants
              </span>
            </button>

            <button
              className="cmv-header-btn"
              onClick={() =>
                navigate("/MyQRScreen")
              }
            >
              <span>▦</span>
              <span className="desktop-only">
                My QR
              </span>
            </button>

            <button
              className="cmv-scan-btn"
              onClick={() =>
                setOpenScanner(true)
              }
            >
              <span className="scan-icon">⌁</span>
              <span className="desktop-only">
                Scan Shop
              </span>
            </button>
             <button
              className="cmv-scan-btn"
             onClick={handleLogout}
            > 
              <span className="desktop-only">
              Logout
              </span>
            </button>

            <div className="cmv-profile">

              <div className="cmv-avatar">
                {customerInitial}
              </div>

              <div className="cmv-profile-info">
                <strong>{customerName}</strong>
                <span>Customer</span>
              </div>

              {/* <button
                className="cmv-logout"
                onClick={handleLogout}
                title="Logout"
              >
                ↪
              </button> */}

            </div>

          </div>

        </header>

        {/* =====================================================
            PAGE INTRO
        ===================================================== */}

        <section className="cmv-page-intro">

          <div>
            <div className="cmv-eyebrow">
              CUSTOMER DASHBOARD
            </div>

            <h1>
              Welcome back,{" "}
              <span>{customerName.split(" ")[0]}</span> 👋
            </h1>

            <p>
              Track your visits, unlock rewards and discover
              your favourite places.
            </p>
          </div>

          {merchant && (
            <div className="cmv-active-shop">

              <div className="shop-live-dot" />

              <div>
                <span>ACTIVE SHOP</span>
                <strong>
                  {merchant.business_name ||
                    "Current Store"}
                </strong>
              </div>

            </div>
          )}

        </section>

        {/* =====================================================
            QUICK STATS
        ===================================================== */}

        <section className="cmv-stats">

          <div className="cmv-stat-card">

            <div className="cmv-stat-icon orange">
              👣
            </div>

            <div>
              <span>Current Visits</span>
              <strong>{currentVisit}</strong>
            </div>

          </div>

          <div className="cmv-stat-card">

            <div className="cmv-stat-icon purple">
              🎁
            </div>

            <div>
              <span>Available Rewards</span>
              <strong>
                {filteredRewards.length}
              </strong>
            </div>

          </div>

          <div className="cmv-stat-card">

            <div className="cmv-stat-icon blue">
              🎫
            </div>

            <div>
              <span>Available Passes</span>
              <strong>
                {allPasses.length}
              </strong>
            </div>

          </div>

          <div className="cmv-stat-card">

            <div className="cmv-stat-icon green">
              🏪
            </div>

            <div>
              <span>My Restaurants</span>
              <strong>
                {restaurantsList.length}
              </strong>
            </div>

          </div>

        </section>

        {/* =====================================================
            NAVIGATION
        ===================================================== */}

        <nav className="cmv-tabs">

          <button
            className={
              activeTab === "current"
                ? "active"
                : ""
            }
            onClick={() => {
              setActiveTab("current");
              setSearch("");
            }}
          >
            <span>◉</span>
            Overview
          </button>

          <button
            className={
              activeTab === "passes"
                ? "active"
                : ""
            }
            onClick={() => {
              setActiveTab("passes");
              setSearch("");
            }}
          >
            <span>🎫</span>
            My Passes
            <b>{allPasses.length}</b>
          </button>

          <button
            className={
              activeTab === "my_rewards"
                ? "active"
                : ""
            }
            onClick={() => {
              setActiveTab("my_rewards");
              setSearch("");
            }}
          >
            <span>🎁</span>
            Rewards
            <b>{filteredRewards.length}</b>
          </button>

          <button
            className={
              activeTab === "restaurants"
                ? "active"
                : ""
            }
            onClick={() => {
              setActiveTab("restaurants");
              setSearch("");
            }}
          >
            <span>🏪</span>
            Restaurants
            <b>{restaurantsList.length}</b>
          </button>

        </nav>

        {/* =====================================================
            SCANNER
        ===================================================== */}

        {openScanner && (
          <div className="cmv-modal-overlay">

            <div className="cmv-scanner-modal">

              <button
                className="cmv-modal-close"
                onClick={() => {
                  if (scannerRef.current) {
                    scannerRef.current
                      .clear()
                      .catch(() => {});
                  }

                  setOpenScanner(false);
                }}
              >
                ×
              </button>

              <div className="cmv-scanner-heading">

                <div className="cmv-scanner-icon">
                  ⌁
                </div>

                <div>
                  <div className="cmv-eyebrow">
                    QUICK CONNECT
                  </div>

                  <h2>
                    Scan Shop QR
                  </h2>

                  <p>
                    Scan the QR displayed by the
                    restaurant to start tracking your visits.
                  </p>
                </div>

              </div>

              <div className="cmv-scanner-frame">

                <div id="reader" />

                <div className="scanner-corners">
                  <i />
                  <i />
                  <i />
                  <i />
                </div>

              </div>

              <div className="cmv-scanner-tip">
                <span>💡</span>
                Keep the QR code inside the frame
              </div>

              <button
                className="cmv-cancel-btn"
                onClick={() => {
                  if (scannerRef.current) {
                    scannerRef.current
                      .clear()
                      .catch(() => {});
                  }

                  setOpenScanner(false);
                }}
              >
                Close Scanner
              </button>

            </div>

          </div>
        )}

        {/* =====================================================
            ERROR
        ===================================================== */}

        {error && merchantId && (
          <div className="cmv-error">

            <span>!</span>

            <div>
              <strong>
                Unable to refresh shop data
              </strong>

              <p>{error}</p>
            </div>

            <button
              onClick={() => {
                fetchDashboardData(merchantId);
                fetchRewardsList(merchantId);
              }}
            >
              Retry
            </button>

          </div>
        )}

        {/* =====================================================
            RESTAURANTS TAB
        ===================================================== */}

        {activeTab === "restaurants" && (
          <section className="cmv-section">

            <div className="cmv-section-heading">

              <div>
                <div className="cmv-eyebrow">
                  YOUR PLACES
                </div>

                <h2>
                  My Restaurants
                </h2>

                <p>
                  Select a restaurant to view your
                  loyalty progress.
                </p>
              </div>

              <button
                className="cmv-primary-btn"
                onClick={() =>
                  setOpenScanner(true)
                }
              >
                ⌁ Scan New Shop
              </button>

            </div>

            <div className="cmv-search">

              <span>⌕</span>

              <input
                type="text"
                placeholder="Search restaurant by name or location..."
                value={search}
                onChange={(e) =>
                  setSearch(e.target.value)
                }
              />

              {search && (
                <button
                  onClick={() => setSearch("")}
                >
                  ×
                </button>
              )}

            </div>

            {filteredRestaurants.length > 0 ? (
              <div className="cmv-restaurant-grid">

                {filteredRestaurants.map(
                  (restaurant, index) => {

                    const restaurantId =
                      restaurant?.merchant_id ||
                      restaurant?.user_id;

                    return (
                      <article
                        key={
                          restaurantId ||
                          index
                        }
                        className="cmv-restaurant-card"
                      >

                        <div className="restaurant-card-top">

                          <div className="restaurant-logo">
                            {String(
                              restaurant?.business_name ||
                                "R"
                            )
                              .charAt(0)
                              .toUpperCase()}
                          </div>

                          <span className="restaurant-status">
                            ● ACTIVE
                          </span>

                        </div>

                        <h3>
                          {restaurant?.business_name ||
                            "Restaurant"}
                        </h3>

                        <p className="restaurant-address">
                          📍{" "}
                          {restaurant?.address ||
                            "Location unavailable"}
                        </p>

                        <div className="restaurant-divider" />

                        <div className="restaurant-meta">

                          <span>
                            <b>LOYALTY</b>
                            <small>
                              Available
                            </small>
                          </span>

                          <span>
                            <b>VISITS</b>
                            <small>
                              {restaurant?.visits ||
                                0}
                            </small>
                          </span>

                        </div>

                        <button
                          className="restaurant-select"
                          onClick={() =>
                            handleSelectRestaurant(
                              restaurantId
                            )
                          }
                        >
                          View Loyalty
                          <span>→</span>
                        </button>

                        <button
                          className="restaurant-review"
                          onClick={() => {
                            navigate(
                              `/feedback?merchant_id=${restaurantId}&customer_id=${customerId}`
                            );
                          }}
                        >
                          ★ Give Feedback
                        </button>

                      </article>
                    );
                  }
                )}

              </div>
            ) : (
              <EmptyState
                icon="🏪"
                title="No restaurants found"
                text={
                  search
                    ? "Try another restaurant name or location."
                    : "Scan a shop QR to start your loyalty journey."
                }
                buttonText="Scan Shop QR"
                onClick={() =>
                  setOpenScanner(true)
                }
              />
            )}

          </section>
        )}

        {/* =====================================================
            OTHER TABS WITHOUT MERCHANT
        ===================================================== */}

        {activeTab !== "restaurants" &&
          !merchantId && (
            <section className="cmv-locked-card">

              <div className="locked-glow" />

              <div className="locked-icon">
                ⌁
              </div>

              <div className="cmv-eyebrow">
                NO ACTIVE SHOP
              </div>

              <h2>
                Start by scanning a shop QR
              </h2>

              <p>
                Choose a restaurant from your saved places
                or scan a Count My Visit QR to see your
                visits, loyalty passes and rewards.
              </p>

              <div className="locked-actions">

                <button
                  className="cmv-primary-btn large"
                  onClick={() =>
                    setOpenScanner(true)
                  }
                >
                  ⌁ Scan Shop QR
                </button>

                <button
                  className="cmv-secondary-btn"
                  onClick={() =>
                    setActiveTab("restaurants")
                  }
                >
                  🏪 My Restaurants
                </button>

              </div>

            </section>
          )}

        {/* =====================================================
            CURRENT OVERVIEW
        ===================================================== */}

        {activeTab === "current" &&
          merchantId &&
          dashboardData && (
            <section className="cmv-section">

              <div className="cmv-section-heading">

                <div>
                  <div className="cmv-eyebrow">
                    LIVE LOYALTY
                  </div>

                  <h2>
                    Your Progress
                  </h2>

                  <p>
                    Keep visiting to unlock your next
                    reward.
                  </p>
                </div>

                <div className="cmv-live">
                  <span />
                  Live
                </div>

              </div>

              <ActiveOverview
                dashboardData={dashboardData}
                progressPercentage={
                  progressPercentage
                }
                onNavigate={navigate}
              />

            </section>
          )}

        {/* =====================================================
            PASSES
        ===================================================== */}

        {activeTab === "passes" &&
          merchantId && (
            <section className="cmv-section">

              <div className="cmv-section-heading">

                <div>
                  <div className="cmv-eyebrow">
                    LOYALTY ROADMAP
                  </div>

                  <h2>
                    All Loyalty Passes
                  </h2>

                  <p>
                    Complete visit milestones and unlock
                    exclusive benefits.
                  </p>
                </div>

                <div className="cmv-count-pill">
                  {filteredPasses.length} Passes
                </div>

              </div>

              <div className="cmv-search">

                <span>⌕</span>

                <input
                  type="text"
                  placeholder="Search passes or rewards..."
                  value={search}
                  onChange={(e) =>
                    setSearch(e.target.value)
                  }
                />

                {search && (
                  <button
                    onClick={() => setSearch("")}
                  >
                    ×
                  </button>
                )}

              </div>

              {filteredPasses.length > 0 ? (
                <div className="cmv-pass-grid">

                  {filteredPasses.map((item) => {

                    const totalVisits = Math.max(
                      Number(item?.total_visits || 1),
                      1
                    );

                    const itemProgress = Math.min(
                      (currentVisit / totalVisits) *
                        100,
                      100
                    );

                    const completed =
                      currentVisit >=
                      totalVisits;

                    return (
                      <article
                        key={item.id}
                        className={`cmv-pass-card ${
                          completed
                            ? "completed"
                            : ""
                        }`}
                        onClick={() =>
                          setSelectedPass(item)
                        }
                      >

                        <div className="pass-top">

                          <div
                            className={`pass-icon ${
                              completed
                                ? "done"
                                : ""
                            }`}
                          >
                            {completed
                              ? "✓"
                              : "🎫"}
                          </div>

                          <span
                            className={`pass-status ${
                              completed
                                ? "unlocked"
                                : "progress"
                            }`}
                          >
                            {completed
                              ? "UNLOCKED"
                              : "IN PROGRESS"}
                          </span>

                        </div>

                        <div className="pass-number">
                          PASS #{item.id}
                        </div>

                        <h3>
                          {item.title ||
                            `Visit Pass #${item.id}`}
                        </h3>

                        <div className="pass-reward">

                          <span>
                            REWARD
                          </span>

                          <strong>
                            {item.reward ||
                              "Special Reward"}
                          </strong>

                        </div>

                        <div className="pass-progress-info">

                          <span>
                            Progress
                          </span>

                          <strong>
                            {Math.min(
                              currentVisit,
                              totalVisits
                            )}{" "}
                            / {totalVisits}
                          </strong>

                        </div>

                        <div className="cmv-progress">
                          <div
                            style={{
                              width: `${itemProgress}%`,
                            }}
                          />
                        </div>

                        <div className="pass-footer">

                          <span>
                            {completed
                              ? "Reward unlocked 🎉"
                              : `${
                                  totalVisits -
                                  currentVisit
                                } visits remaining`}
                          </span>

                          <span>
                            View →
                          </span>

                        </div>

                      </article>
                    );
                  })}

                </div>
              ) : (
                <EmptyState
                  icon="🎫"
                  title="No passes found"
                  text="There are no loyalty passes matching your search."
                />
              )}

            </section>
          )}

        {/* =====================================================
            REWARDS
        ===================================================== */}

        {activeTab === "my_rewards" &&
          merchantId && (
            <section className="cmv-section">

              <div className="cmv-section-heading">

                <div>
                  <div className="cmv-eyebrow">
                    YOUR BENEFITS
                  </div>

                  <h2>
                    Unlocked Rewards
                  </h2>

                  <p>
                    Your available coupons are ready to use.
                  </p>
                </div>

                <div className="reward-balance">
                  <span>AVAILABLE</span>
                  <strong>
                    {filteredRewards.length}
                  </strong>
                </div>

              </div>

              <div className="cmv-search">

                <span>⌕</span>

                <input
                  type="text"
                  placeholder="Search coupon code..."
                  value={search}
                  onChange={(e) =>
                    setSearch(e.target.value)
                  }
                />

                {search && (
                  <button
                    onClick={() => setSearch("")}
                  >
                    ×
                  </button>
                )}

              </div>

              <RewardsManager
                activeTab="my_rewards"
                filteredRewards={
                  filteredRewards
                }
                merchant={merchant}
                customerId={customerId}
                merchantId={merchantId}
                actionLoading={actionLoading}
                handleRedeemReward={
                  handleRedeemReward
                }
                filteredRestaurants={
                  filteredRestaurants
                }
                handleSelectRestaurant={
                  handleSelectRestaurant
                }
                onAddReviewClick={(
                  restaurantItem
                ) => {
                  const mId =
                    restaurantItem?.merchant_id ||
                    restaurantItem?.user_id ||
                    merchantId ||
                    "";

                  navigate(
                    `/feedback?merchant_id=${mId}&customer_id=${customerId}`
                  );
                }}
              />

            </section>
          )}

        {/* =====================================================
            PASS DETAIL MODAL
        ===================================================== */}

        {selectedPass && (
          <div className="cmv-modal-overlay">

            <div className="cmv-pass-modal">

              <button
                className="cmv-modal-close"
                onClick={() =>
                  setSelectedPass(null)
                }
              >
                ×
              </button>

              <div className="pass-modal-icon">
                🎫
              </div>

              <div className="cmv-eyebrow">
                LOYALTY PASS
              </div>

              <h2>
                {selectedPass.title}
              </h2>

              <p className="pass-modal-description">
                Complete your visits at this restaurant
                to unlock your reward.
              </p>

              <div className="pass-detail-box">

                <div>
                  <span>REWARD</span>
                  <strong>
                    {selectedPass.reward}
                  </strong>
                </div>

                <div>
                  <span>REQUIRED VISITS</span>
                  <strong>
                    {selectedPass.total_visits}
                  </strong>
                </div>

                <div>
                  <span>YOUR VISITS</span>
                  <strong>
                    {currentVisit}
                  </strong>
                </div>

                <div>
                  <span>STATUS</span>
                  <strong>
                    {currentVisit >=
                    Number(
                      selectedPass.total_visits ||
                        0
                    )
                      ? "Unlocked 🎉"
                      : "In Progress"}
                  </strong>
                </div>

              </div>

              <div className="modal-progress">

                <div className="pass-progress-info">
                  <span>Completion</span>

                  <strong>
                    {Math.min(
                      (currentVisit /
                        Math.max(
                          Number(
                            selectedPass.total_visits ||
                              1
                          ),
                          1
                        )) *
                        100,
                      100
                    ).toFixed(0)}
                    %
                  </strong>
                </div>

                <div className="cmv-progress">
                  <div
                    style={{
                      width: `${Math.min(
                        (currentVisit /
                          Math.max(
                            Number(
                              selectedPass.total_visits ||
                                1
                            ),
                            1
                          )) *
                          100,
                        100
                      )}%`,
                    }}
                  />
                </div>

              </div>

              <div className="modal-actions">

                <button
                  className="cmv-primary-btn"
                  onClick={() =>
                    navigate(
                      `/feedback?merchant_id=${merchantId}&customer_id=${customerId}`
                    )
                  }
                >
                  ★ Give Feedback
                </button>

                <button
                  className="cmv-secondary-btn"
                  onClick={() =>
                    setSelectedPass(null)
                  }
                >
                  Close
                </button>

              </div>

            </div>

          </div>
        )}

      </div>
    </>
  );
}

/* =============================================================
   EMPTY STATE
============================================================= */

function EmptyState({
  icon,
  title,
  text,
  buttonText,
  onClick,
}) {
  return (
    <div className="cmv-empty">

      <div className="cmv-empty-icon">
        {icon}
      </div>

      <h3>{title}</h3>

      <p>{text}</p>

      {buttonText && onClick && (
        <button
          className="cmv-primary-btn"
          onClick={onClick}
        >
          {buttonText}
        </button>
      )}

    </div>
  );
}

/* =============================================================
   GLOBAL STYLES
============================================================= */

const globalStyles = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  background: #f6f7fb;
  color: #111827;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

button,
input {
  font-family: inherit;
}

button {
  -webkit-tap-highlight-color: transparent;
}

.cmv-app {
  min-height: 100vh;
  background:
    radial-gradient(
      circle at 90% 0%,
      rgba(255, 140, 66, 0.08),
      transparent 28%
    ),
    radial-gradient(
      circle at 0% 30%,
      rgba(99, 102, 241, 0.05),
      transparent 25%
    ),
    #f6f7fb;
  padding: 24px 34px 60px;
}

/* =========================================================
   HEADER
========================================================= */

.cmv-header {
  max-width: 1440px;
  margin: 0 auto;
  min-height: 76px;
  padding: 12px 14px 12px 20px;
  border: 1px solid #e9ebf2;
  background: rgba(255,255,255,.92);
  backdrop-filter: blur(18px);
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  box-shadow: 0 12px 40px rgba(15,23,42,.05);
  position: sticky;
  top: 14px;
  z-index: 100;
}

.cmv-brand-area {
  display: flex;
  align-items: center;
  gap: 12px;
}

.cmv-brand-logo {
  width: 48px;
  height: 48px;
  border-radius: 15px;
  background: linear-gradient(135deg,#ff8c42,#ff5e62);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  font-size: 12px;
  box-shadow: 0 9px 24px rgba(255,94,98,.24);
}

.cmv-brand-name {
  font-size: 16px;
  font-weight: 800;
  color: #111827;
}

.cmv-brand-subtitle {
  font-size: 11px;
  color: #94a3b8;
  margin-top: 2px;
}

.cmv-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cmv-header-btn,
.cmv-scan-btn {
  height: 44px;
  border: 0;
  border-radius: 13px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  transition: .2s ease;
}

.cmv-header-btn {
  background: #f5f6fa;
  color: #374151;
}

.cmv-header-btn:hover {
  background: #eceef5;
  transform: translateY(-1px);
}

.cmv-scan-btn {
  background: linear-gradient(135deg,#ff8c42,#ff5e62);
  color: white;
  box-shadow: 0 7px 18px rgba(255,94,98,.2);
}

.cmv-scan-btn:hover {
  transform: translateY(-2px);
}

.scan-icon {
  font-size: 20px;
  line-height: 1;
}

.cmv-profile {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-left: 3px;
  padding-left: 10px;
  border-left: 1px solid #e5e7eb;
}

.cmv-avatar {
  width: 40px;
  height: 40px;
  border-radius: 13px;
  background: #111827;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
}

.cmv-profile-info {
  display: flex;
  flex-direction: column;
  min-width: 80px;
}

.cmv-profile-info strong {
  font-size: 12px;
  color: #111827;
}

.cmv-profile-info span {
  font-size: 10px;
  color: #94a3b8;
  margin-top: 2px;
}

.cmv-logout {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 10px;
  background: #fff1f2;
  color: #e11d48;
  cursor: pointer;
  font-size: 17px;
}

/* =========================================================
   INTRO
========================================================= */

.cmv-page-intro {
  max-width: 1440px;
  margin: 42px auto 28px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
}

.cmv-eyebrow {
  font-size: 10px;
  letter-spacing: 1.4px;
  color: #ff7043;
  font-weight: 800;
  margin-bottom: 7px;
}

.cmv-page-intro h1 {
  margin: 0;
  font-size: clamp(28px, 3vw, 42px);
  line-height: 1.1;
  letter-spacing: -1.5px;
  color: #111827;
}

.cmv-page-intro h1 span {
  color: #ff7043;
}

.cmv-page-intro p {
  margin: 10px 0 0;
  color: #7b8494;
  font-size: 14px;
}

.cmv-active-shop {
  min-width: 240px;
  padding: 14px 17px;
  border: 1px solid #d9f5e7;
  background: #f0fdf6;
  border-radius: 16px;
  display: flex;
  align-items: center;
  gap: 11px;
}

.shop-live-dot {
  width: 10px;
  height: 10px;
  background: #22c55e;
  border-radius: 50%;
  box-shadow: 0 0 0 5px #dcfce7;
}

.cmv-active-shop div:last-child {
  display: flex;
  flex-direction: column;
}

.cmv-active-shop span {
  font-size: 9px;
  color: #16a34a;
  font-weight: 800;
  letter-spacing: 1px;
}

.cmv-active-shop strong {
  font-size: 13px;
  margin-top: 3px;
  color: #166534;
}

/* =========================================================
   STATS
========================================================= */

.cmv-stats {
  max-width: 1440px;
  margin: 0 auto 24px;
  display: grid;
  grid-template-columns: repeat(4,1fr);
  gap: 14px;
}

.cmv-stat-card {
  min-height: 100px;
  background: white;
  border: 1px solid #e9ebf2;
  border-radius: 19px;
  padding: 18px;
  display: flex;
  align-items: center;
  gap: 13px;
  box-shadow: 0 8px 25px rgba(15,23,42,.035);
}

.cmv-stat-icon {
  width: 48px;
  height: 48px;
  flex: 0 0 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 21px;
}

.cmv-stat-icon.orange {
  background: #fff3eb;
}

.cmv-stat-icon.purple {
  background: #f3efff;
}

.cmv-stat-icon.blue {
  background: #eff6ff;
}

.cmv-stat-icon.green {
  background: #ecfdf5;
}

.cmv-stat-card > div:last-child {
  display: flex;
  flex-direction: column;
}

.cmv-stat-card span {
  font-size: 10px;
  color: #8a93a3;
  font-weight: 600;
}

.cmv-stat-card strong {
  margin-top: 5px;
  font-size: 25px;
  color: #111827;
  letter-spacing: -.7px;
}

/* =========================================================
   TABS
========================================================= */

.cmv-tabs {
  max-width: 1440px;
  margin: 0 auto 28px;
  padding: 6px;
  border: 1px solid #e8eaf0;
  background: #fff;
  border-radius: 17px;
  display: flex;
  gap: 4px;
  box-shadow: 0 7px 25px rgba(15,23,42,.035);
}

.cmv-tabs button {
  flex: 1;
  min-height: 48px;
  border: 0;
  border-radius: 12px;
  background: transparent;
  color: #7a8290;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 7px;
  transition: .2s;
}

.cmv-tabs button:hover {
  color: #111827;
  background: #f8f9fc;
}

.cmv-tabs button.active {
  color: white;
  background: linear-gradient(135deg,#ff8c42,#ff5e62);
  box-shadow: 0 7px 18px rgba(255,94,98,.18);
}

.cmv-tabs button b {
  min-width: 20px;
  padding: 2px 6px;
  border-radius: 8px;
  background: rgba(0,0,0,.06);
  font-size: 9px;
}

.cmv-tabs button.active b {
  background: rgba(255,255,255,.2);
}

/* =========================================================
   SECTION
========================================================= */

.cmv-section {
  max-width: 1440px;
  margin: 0 auto;
  animation: cmvFade .3s ease;
}

@keyframes cmvFade {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.cmv-section-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
}

.cmv-section-heading h2 {
  margin: 0;
  font-size: 25px;
  letter-spacing: -.7px;
  color: #111827;
}

.cmv-section-heading p {
  margin: 6px 0 0;
  font-size: 12px;
  color: #8a93a3;
}

.cmv-live {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 8px 12px;
  border-radius: 20px;
  background: #ecfdf5;
  color: #15803d;
  font-size: 11px;
  font-weight: 800;
}

.cmv-live span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 0 4px #dcfce7;
}

.cmv-count-pill {
  padding: 9px 13px;
  border-radius: 10px;
  background: #f1f5f9;
  color: #475569;
  font-size: 11px;
  font-weight: 800;
}

.reward-balance {
  min-width: 90px;
  padding: 9px 13px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 13px;
  display: flex;
  flex-direction: column;
  text-align: right;
}

.reward-balance span {
  color: #c2410c;
  font-size: 8px;
  font-weight: 800;
}

.reward-balance strong {
  color: #ea580c;
  font-size: 20px;
  margin-top: 2px;
}

/* =========================================================
   SEARCH
========================================================= */

.cmv-search {
  height: 52px;
  background: white;
  border: 1px solid #e6e9ef;
  border-radius: 14px;
  display: flex;
  align-items: center;
  padding: 0 14px;
  margin-bottom: 20px;
  box-shadow: 0 6px 20px rgba(15,23,42,.025);
}

.cmv-search > span {
  font-size: 22px;
  color: #a0a8b5;
}

.cmv-search input {
  flex: 1;
  min-width: 0;
  height: 100%;
  border: 0;
  outline: 0;
  background: transparent;
  padding: 0 10px;
  color: #111827;
  font-size: 12px;
}

.cmv-search input::placeholder {
  color: #a0a8b5;
}

.cmv-search button {
  border: 0;
  background: #f1f5f9;
  color: #64748b;
  width: 27px;
  height: 27px;
  border-radius: 8px;
  cursor: pointer;
}

/* =========================================================
   BUTTONS
========================================================= */

.cmv-primary-btn,
.cmv-secondary-btn {
  min-height: 42px;
  border: 0;
  border-radius: 12px;
  padding: 0 17px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 800;
  transition: .2s ease;
}

.cmv-primary-btn {
  color: white;
  background: linear-gradient(135deg,#ff8c42,#ff5e62);
  box-shadow: 0 7px 18px rgba(255,94,98,.17);
}

.cmv-primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 22px rgba(255,94,98,.23);
}

.cmv-primary-btn.large {
  min-height: 48px;
  padding: 0 22px;
  font-size: 12px;
}

.cmv-secondary-btn {
  background: #f1f5f9;
  color: #475569;
}

.cmv-secondary-btn:hover {
  background: #e8edf3;
}

/* =========================================================
   RESTAURANTS
========================================================= */

.cmv-restaurant-grid {
  display: grid;
  grid-template-columns: repeat(3,1fr);
  gap: 17px;
}

.cmv-restaurant-card {
  background: white;
  border: 1px solid #e7e9ef;
  border-radius: 21px;
  padding: 20px;
  box-shadow: 0 8px 25px rgba(15,23,42,.035);
  transition: .25s ease;
}

.cmv-restaurant-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 17px 35px rgba(15,23,42,.07);
  border-color: #fed7aa;
}

.restaurant-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.restaurant-logo {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  background: linear-gradient(135deg,#fff1e7,#fff7ed);
  color: #ea580c;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 900;
}

.restaurant-status {
  padding: 6px 9px;
  background: #ecfdf5;
  color: #15803d;
  border-radius: 8px;
  font-size: 8px;
  font-weight: 900;
}

.cmv-restaurant-card h3 {
  margin: 17px 0 7px;
  font-size: 17px;
  letter-spacing: -.3px;
}

.restaurant-address {
  margin: 0;
  color: #8992a1;
  font-size: 11px;
  line-height: 1.6;
  min-height: 35px;
}

.restaurant-divider {
  height: 1px;
  background: #f0f2f5;
  margin: 16px 0;
}

.restaurant-meta {
  display: flex;
  gap: 35px;
  margin-bottom: 15px;
}

.restaurant-meta span {
  display: flex;
  flex-direction: column;
}

.restaurant-meta b {
  font-size: 8px;
  color: #a0a8b5;
  letter-spacing: .8px;
}

.restaurant-meta small {
  font-size: 11px;
  color: #334155;
  font-weight: 700;
  margin-top: 3px;
}

.restaurant-select,
.restaurant-review {
  width: 100%;
  height: 41px;
  border: 0;
  border-radius: 11px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 800;
  transition: .2s;
}

.restaurant-select {
  background: #111827;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
}

.restaurant-select:hover {
  background: #1f2937;
}

.restaurant-select span {
  font-size: 17px;
}

.restaurant-review {
  margin-top: 7px;
  background: #fff7ed;
  color: #ea580c;
}

/* =========================================================
   PASSES
========================================================= */

.cmv-pass-grid {
  display: grid;
  grid-template-columns: repeat(3,1fr);
  gap: 17px;
}

.cmv-pass-card {
  background: white;
  border: 1px solid #e7e9ef;
  border-radius: 21px;
  padding: 20px;
  cursor: pointer;
  box-shadow: 0 8px 25px rgba(15,23,42,.035);
  transition: .25s ease;
  position: relative;
  overflow: hidden;
}

.cmv-pass-card::after {
  content: "";
  position: absolute;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: rgba(255,140,66,.06);
  right: -45px;
  top: -45px;
}

.cmv-pass-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 17px 35px rgba(15,23,42,.07);
}

.cmv-pass-card.completed {
  border-color: #bbf7d0;
}

.pass-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pass-icon {
  width: 45px;
  height: 45px;
  border-radius: 13px;
  background: #fff3eb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.pass-icon.done {
  background: #dcfce7;
  color: #16a34a;
  font-size: 18px;
  font-weight: 900;
}

.pass-status {
  padding: 6px 8px;
  border-radius: 8px;
  font-size: 8px;
  font-weight: 900;
}

.pass-status.progress {
  background: #fff7ed;
  color: #c2410c;
}

.pass-status.unlocked {
  background: #ecfdf5;
  color: #15803d;
}

.pass-number {
  margin-top: 17px;
  font-size: 8px;
  letter-spacing: 1px;
  font-weight: 800;
  color: #a0a8b5;
}

.cmv-pass-card h3 {
  margin: 6px 0 16px;
  font-size: 17px;
  color: #111827;
}

.pass-reward {
  padding: 12px;
  background: #f8fafc;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
}

.pass-reward span {
  font-size: 8px;
  font-weight: 800;
  color: #94a3b8;
}

.pass-reward strong {
  margin-top: 5px;
  color: #334155;
  font-size: 12px;
}

.pass-progress-info {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 10px;
  color: #8b94a3;
}

.pass-progress-info strong {
  color: #475569;
}

.cmv-progress {
  height: 7px;
  background: #eef0f4;
  border-radius: 20px;
  overflow: hidden;
  margin-top: 7px;
}

.cmv-progress > div {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg,#ff8c42,#ff5e62);
  transition: width .5s ease;
}

.pass-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 14px;
  color: #8b94a3;
  font-size: 9px;
  font-weight: 700;
}

.pass-footer span:last-child {
  color: #ea580c;
}

/* =========================================================
   LOCKED STATE
========================================================= */

.cmv-locked-card {
  max-width: 850px;
  min-height: 420px;
  margin: 40px auto;
  background: white;
  border: 1px solid #e7e9ef;
  border-radius: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 50px 30px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 15px 45px rgba(15,23,42,.05);
}

.locked-glow {
  position: absolute;
  width: 320px;
  height: 320px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(255,140,66,.12),
    transparent 68%
  );
  top: -150px;
  right: -100px;
}

.locked-icon {
  width: 76px;
  height: 76px;
  border-radius: 24px;
  background: #fff3eb;
  color: #f97316;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 35px;
  margin-bottom: 20px;
}

.cmv-locked-card h2 {
  margin: 0;
  font-size: 25px;
  letter-spacing: -.7px;
}

.cmv-locked-card p {
  max-width: 570px;
  color: #8a93a3;
  font-size: 13px;
  line-height: 1.8;
  margin: 10px auto 23px;
}

.locked-actions {
  display: flex;
  gap: 9px;
}

/* =========================================================
   EMPTY
========================================================= */

.cmv-empty {
  background: white;
  border: 1px dashed #d9dee8;
  border-radius: 22px;
  min-height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 35px;
}

.cmv-empty-icon {
  width: 65px;
  height: 65px;
  border-radius: 20px;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  margin-bottom: 14px;
}

.cmv-empty h3 {
  margin: 0;
  font-size: 17px;
}

.cmv-empty p {
  max-width: 400px;
  color: #8a93a3;
  font-size: 11px;
  line-height: 1.7;
  margin: 8px 0 17px;
}

/* =========================================================
   ERROR
========================================================= */

.cmv-error {
  max-width: 1440px;
  margin: 0 auto 20px;
  padding: 13px 15px;
  border: 1px solid #fecaca;
  background: #fff5f5;
  border-radius: 14px;
  display: flex;
  align-items: center;
  gap: 11px;
}

.cmv-error > span {
  width: 30px;
  height: 30px;
  border-radius: 9px;
  background: #fee2e2;
  color: #dc2626;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
}

.cmv-error div {
  flex: 1;
}

.cmv-error strong {
  font-size: 11px;
  color: #991b1b;
}

.cmv-error p {
  margin: 2px 0 0;
  font-size: 10px;
  color: #b91c1c;
}

.cmv-error button {
  border: 0;
  background: #dc2626;
  color: white;
  border-radius: 9px;
  padding: 8px 12px;
  font-size: 10px;
  font-weight: 800;
  cursor: pointer;
}

/* =========================================================
   MODAL
========================================================= */

.cmv-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 999999;
  background: rgba(15,23,42,.68);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  animation: modalFade .2s ease;
}

@keyframes modalFade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.cmv-scanner-modal,
.cmv-pass-modal {
  width: 100%;
  max-width: 450px;
  max-height: calc(100vh - 35px);
  overflow-y: auto;
  background: white;
  border-radius: 27px;
  padding: 25px;
  position: relative;
  box-shadow: 0 30px 80px rgba(0,0,0,.25);
  animation: modalUp .25s ease;
}

@keyframes modalUp {
  from {
    opacity: 0;
    transform: translateY(15px) scale(.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.cmv-modal-close {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 10px;
  background: #f1f5f9;
  color: #475569;
  font-size: 23px;
  line-height: 1;
  cursor: pointer;
  z-index: 5;
}

.cmv-scanner-heading {
  display: flex;
  gap: 13px;
  align-items: flex-start;
  padding-right: 35px;
}

.cmv-scanner-icon {
  width: 46px;
  height: 46px;
  flex: 0 0 46px;
  border-radius: 14px;
  background: #fff3eb;
  color: #ea580c;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 23px;
}

.cmv-scanner-heading h2 {
  margin: 0;
  font-size: 21px;
  letter-spacing: -.5px;
}

.cmv-scanner-heading p {
  margin: 6px 0 0;
  color: #8a93a3;
  font-size: 10px;
  line-height: 1.6;
}

.cmv-scanner-frame {
  margin-top: 20px;
  min-height: 310px;
  background: #111827;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

#reader {
  width: 100%;
}

#reader video {
  border-radius: 15px;
}

#reader__dashboard_section_csr {
  padding: 10px !important;
}

#reader__dashboard_section_swaplink {
  color: #ff8c42 !important;
}

#reader button {
  border: 0 !important;
  border-radius: 8px !important;
  padding: 7px 12px !important;
  cursor: pointer !important;
}

#reader select {
  max-width: 100% !important;
  border-radius: 8px !important;
  padding: 7px !important;
}

.scanner-corners {
  position: absolute;
  inset: 35px;
  pointer-events: none;
}

.scanner-corners i {
  position: absolute;
  width: 35px;
  height: 35px;
  border-color: #ff8c42;
  border-style: solid;
}

.scanner-corners i:nth-child(1) {
  top: 0;
  left: 0;
  border-width: 3px 0 0 3px;
}

.scanner-corners i:nth-child(2) {
  top: 0;
  right: 0;
  border-width: 3px 3px 0 0;
}

.scanner-corners i:nth-child(3) {
  bottom: 0;
  left: 0;
  border-width: 0 0 3px 3px;
}

.scanner-corners i:nth-child(4) {
  bottom: 0;
  right: 0;
  border-width: 0 3px 3px 0;
}

.cmv-scanner-tip {
  margin: 13px 0;
  padding: 10px 12px;
  background: #f8fafc;
  border-radius: 10px;
  color: #64748b;
  font-size: 10px;
  text-align: center;
}

.cmv-cancel-btn {
  width: 100%;
  height: 46px;
  border: 0;
  border-radius: 12px;
  background: #111827;
  color: white;
  font-weight: 800;
  cursor: pointer;
}

/* =========================================================
   PASS MODAL
========================================================= */

.cmv-pass-modal {
  max-width: 470px;
}

.pass-modal-icon {
  width: 58px;
  height: 58px;
  border-radius: 17px;
  background: #fff3eb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 27px;
  margin-bottom: 17px;
}

.cmv-pass-modal h2 {
  margin: 0;
  font-size: 25px;
  letter-spacing: -.7px;
}

.pass-modal-description {
  margin: 8px 0 20px;
  color: #8a93a3;
  font-size: 11px;
  line-height: 1.7;
}

.pass-detail-box {
  background: #f8fafc;
  border: 1px solid #edf0f4;
  border-radius: 17px;
  padding: 15px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.pass-detail-box div {
  display: flex;
  flex-direction: column;
}

.pass-detail-box span {
  color: #9aa2af;
  font-size: 8px;
  font-weight: 800;
}

.pass-detail-box strong {
  margin-top: 4px;
  color: #1f2937;
  font-size: 12px;
}

.modal-progress {
  margin-top: 20px;
}

.modal-actions {
  margin-top: 22px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 9px;
}

/* =========================================================
   LOADING
========================================================= */

.cmv-loading-screen {
  min-height: 100vh;
  background:
    radial-gradient(
      circle at 50% 30%,
      rgba(255,140,66,.1),
      transparent 35%
    ),
    #f7f8fb;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.cmv-loader-card {
  width: 100%;
  max-width: 360px;
  background: white;
  border: 1px solid #e7e9ef;
  border-radius: 25px;
  padding: 35px 25px;
  text-align: center;
  box-shadow: 0 20px 55px rgba(15,23,42,.07);
}

.cmv-loader-logo {
  width: 60px;
  height: 60px;
  border-radius: 19px;
  margin: 0 auto 22px;
  background: linear-gradient(135deg,#ff8c42,#ff5e62);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 900;
}

.cmv-spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #ffe4d5;
  border-top-color: #ff7043;
  border-radius: 50%;
  margin: 0 auto 17px;
  animation: cmvSpin .8s linear infinite;
}

@keyframes cmvSpin {
  to {
    transform: rotate(360deg);
  }
}

.cmv-loader-card h2 {
  font-size: 15px;
  margin: 0;
}

.cmv-loader-card p {
  margin: 7px 0 0;
  color: #8a93a3;
  font-size: 10px;
}

/* =========================================================
   TABLET
========================================================= */

@media (max-width: 1100px) {

  .cmv-app {
    padding: 20px;
  }

  .cmv-stats {
    grid-template-columns: repeat(2,1fr);
  }

  .cmv-restaurant-grid,
  .cmv-pass-grid {
    grid-template-columns: repeat(2,1fr);
  }

}

/* =========================================================
   MOBILE
========================================================= */

@media (max-width: 700px) {

  .cmv-app {
    padding: 12px 12px 40px;
  }

  .cmv-header {
    top: 8px;
    min-height: auto;
    padding: 10px;
    border-radius: 17px;
    flex-wrap: wrap;
  }

  .cmv-brand-logo {
    width: 40px;
    height: 40px;
    border-radius: 12px;
  }

  .cmv-brand-name {
    font-size: 14px;
  }

  .cmv-brand-subtitle {
    font-size: 9px;
  }

  .cmv-header-actions {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr auto;
  }

  .cmv-header-btn,
  .cmv-scan-btn {
    height: 40px;
    padding: 0;
    border-radius: 11px;
  }

  .cmv-profile {
    border-left: 0;
    padding-left: 0;
    margin: 0;
  }

  .cmv-profile-info {
    display: none;
  }

  .cmv-avatar {
    width: 36px;
    height: 36px;
    border-radius: 11px;
  }

  .cmv-logout {
    display: none;
  }

  .desktop-only {
    display: none;
  }

  .cmv-page-intro {
    margin: 28px auto 20px;
    display: block;
  }

  .cmv-page-intro h1 {
    font-size: 27px;
  }

  .cmv-page-intro p {
    font-size: 11px;
    line-height: 1.6;
  }

  .cmv-active-shop {
    margin-top: 15px;
    min-width: 0;
  }

  .cmv-stats {
    grid-template-columns: 1fr 1fr;
    gap: 9px;
  }

  .cmv-stat-card {
    min-height: 80px;
    padding: 12px;
    border-radius: 15px;
    gap: 9px;
  }

  .cmv-stat-icon {
    width: 38px;
    height: 38px;
    flex-basis: 38px;
    border-radius: 11px;
    font-size: 17px;
  }

  .cmv-stat-card strong {
    font-size: 20px;
  }

  .cmv-stat-card span {
    font-size: 8px;
  }

  .cmv-tabs {
    overflow-x: auto;
    margin-bottom: 20px;
    scrollbar-width: none;
  }

  .cmv-tabs::-webkit-scrollbar {
    display: none;
  }

  .cmv-tabs button {
    min-width: max-content;
    padding: 0 13px;
    font-size: 10px;
  }

  .cmv-section-heading {
    align-items: flex-start;
    margin-bottom: 15px;
  }

  .cmv-section-heading h2 {
    font-size: 20px;
  }

  .cmv-section-heading p {
    font-size: 10px;
    line-height: 1.5;
  }

  .cmv-section-heading > .cmv-primary-btn {
    display: none;
  }

  .cmv-restaurant-grid,
  .cmv-pass-grid {
    grid-template-columns: 1fr;
    gap: 11px;
  }

  .cmv-restaurant-card,
  .cmv-pass-card {
    border-radius: 18px;
    padding: 16px;
  }

  .cmv-locked-card {
    min-height: 390px;
    margin: 20px auto;
    padding: 35px 20px;
    border-radius: 22px;
  }

  .cmv-locked-card h2 {
    font-size: 21px;
  }

  .cmv-locked-card p {
    font-size: 11px;
  }

  .locked-actions {
    width: 100%;
    flex-direction: column;
  }

  .locked-actions button {
    width: 100%;
  }

  .cmv-scanner-modal,
  .cmv-pass-modal {
    border-radius: 22px;
    padding: 20px;
  }

  .cmv-scanner-frame {
    min-height: 270px;
  }

  .modal-actions {
    grid-template-columns: 1fr;
  }

  .cmv-error {
    align-items: flex-start;
  }

  .cmv-error button {
    display: none;
  }

}

/* =========================================================
   SMALL MOBILE
========================================================= */

@media (max-width: 390px) {

  .cmv-app {
    padding-left: 9px;
    padding-right: 9px;
  }

  .cmv-header-actions {
    grid-template-columns: 1fr 1fr auto;
  }

  .cmv-header-btn:nth-child(2) {
    display: none;
  }

  .cmv-stats {
    gap: 7px;
  }

  .cmv-stat-card {
    padding: 10px;
  }

  .cmv-stat-icon {
    width: 34px;
    height: 34px;
    flex-basis: 34px;
  }

  .cmv-tabs button {
    padding: 0 10px;
  }

}

/* =========================================================
   ACCESSIBILITY / SELECTION
========================================================= */

::selection {
  background: #ff8c42;
  color: white;
}

input:focus {
  outline: none;
}

button:focus-visible {
  outline: 3px solid rgba(255,140,66,.25);
  outline-offset: 2px;
}
`;
 
